require(/*! ./libs/browser-sentry.js */"./src/libs/browser-sentry.js");

// STORAGE
var config = require(/*! ./config.js */"./src/config.js");
var canStore = typeof Storage !== "undefined";
window.saveVal = function (name, val) {
  if (canStore) {
    localStorage.setItem(name, val);
  }
};
function deleteVal(name) {
  if (canStore) {
    localStorage.removeItem(name);
  }
}
window.getSavedVal = function (name) {
  if (canStore) {
    return localStorage.getItem(name);
  }
  return null;
};
var i18n = new (require(/*! ./libs/i18n.js */"./src/libs/i18n.js"))();
function setMenuButtonNames() {
  var menuBtns = ['Profile', 'Shop', 'Social', 'Maps', 'Mods', 'Settings', 'Host', 'Browser', 'Join'];
  for (var i = 0; i < menuBtns.length; i++) {
    document.getElementById('menuBtn' + menuBtns[i]).innerHTML = i18n.get('menu.btn.' + menuBtns[i].toLowerCase());
  }
  customizeButton.innerHTML = i18n.get('menu.btn.customize');
  inviteButton.innerHTML = i18n.get('menu.btn.invite');
}
;
setMenuButtonNames();

// OPEN LINK:
window.openURL = function (target) {
  window.open(target, "_blank");
};

// INITIATE MATCHMAKER:
var ClientManager = require(/*! sid-client-manager */"./kru_node_modules/sid-client-manager/dist/client-manager/src/index.js").default;
ClientManager.PING_REGION_CACHE_KEY = "pingRegion4";
var clientManager = new ClientManager("krunker.io");
// clientManager.enableLogging = true;
var connectedInstanceId = null; // SET IN `clientManager.seek` CALLBACK
var connectedHost = null;
var connectedPort = null;
function switchServer(instanceId) {
  clientManager.switchGame(instanceId);
}
function checkedSwitchServer(instanceId, changeElement) {
  // LOADING INDICATOR:
  changeElement.innerText = "...";

  // FETCH SERVER STATUS:
  clientManager.fetchGameInfo(instanceId).then(serverInfo => {
    // CHECK THE GAME IS NOT FULL:
    if (serverInfo.clients >= serverInfo.maxClients) {
      changeElement.innerText = i18n.get('matchmaker.full');
      setTimeout(() => {
        changeElement.innerText = `${Math.min(serverInfo.clients, serverInfo.maxClients)}/${serverInfo.maxClients}`;
      }, 1000);
    } else {
      // SET DEFAULT REGION:
      // if (serverInfo.data && !serverInfo.data.custom) {
      //     ClientManager.setDefaultRegion(serverInfo.region);
      // }

      // SWITCH SERVER:
      switchServer(instanceId);
    }
  });
}
window.switchServer = switchServer;
window.checkedSwitchServer = checkedSwitchServer;

// PRIVATE ROOM:
window.createPrivateRoom = function () {
  // SELECTED MAPS:
  var availableMaps = [];
  var tmpRawEl = document.getElementById("rawMapData");
  for (var i = 0; i < maps.length; i++) {
    var tmpEle = document.getElementById("gameMap" + i);
    if (tmpEle && tmpEle.checked) {
      availableMaps.push(i);
    }
  }
  if (availableMaps.length == 0 && !mapToHost && rawMapData.value == "") {
    hostGameMsg.innerHTML = "<span class='error'>" + i18n.get('custom.map.missing') + "</span>";
    return;
  }

  // SELECTED MODES:
  var availableModes = [];
  for (var i = 0; i < modes.length; i++) {
    if (document.getElementById("gameMode" + i).checked) {
      availableModes.push(i);
    }
  }
  if (availableModes.length == 0) {
    hostGameMsg.innerHTML = "<span class='error'>" + i18n.get('custom.mode.missing') + "</span>";
    return;
  }

  // SELECTED CLASSES:
  var availableClasses = [];
  for (var i = 0; i < Game.classes.length; i++) {
    if (document.getElementById("gameClass" + i).checked) {
      availableClasses.push(i);
    }
  }
  if (availableClasses.length == 0) {
    hostGameMsg.innerHTML = "<span class='error'>" + i18n.get('custom.class.missing') + "</span>";
    return;
  }

  // EMIT PRIVATE SERVER:
  var tmpDat = {
    customMap: mapToHost,
    rawMapData: tmpRawEl ? tmpRawEl.value : null,
    private: makePrivate.checked,
    maps: availableMaps,
    modes: availableModes,
    classes: availableClasses
  };
  for (var i = 0; i < config.serverConfig.length; i++) {
    var tmpEl = document.getElementById("customS" + config.serverConfig[i].varN);
    if (config.serverConfig[i].bool) {
      tmpV = tmpEl ? tmpEl.checked : 0;
    } else {
      if (config.serverConfig[i].input) {
        tmpV = tmpEl ? UTILS.sanitizeStr(tmpEl.value) : 0;
      } else {
        tmpV = tmpEl ? parseFloat(tmpEl.value) : 0;
      }
    }
    tmpDat[config.serverConfig[i].varN] = tmpV;
  }
  io.send("custom", tmpDat);
  hostGameMsg.innerHTML = i18n.get('generic.wait');
};
function customResp(resp, newInstanceId) {
  if (hostGameMsg) {
    hostGameMsg.innerHTML = resp;
  }
  if (newInstanceId) {
    updateRoom(newInstanceId);
  }
  mapToHost = null;
  custToHost = null;
}
function updateRoom(newInstanceId) {
  var tmpURL = clientManager.generateHref(newInstanceId);
  window.history.replaceState({}, "Krunker", tmpURL);
  windows[1].lastLoadTime = 0;
  connectedInstanceId = newInstanceId;
}

// OVERWRITE CONSOLE:
Object.defineProperty(console, '_commandLineAPI', {
  get: function () {
    throw '';
  }
});

// IMPORT:
var THREE = require("three");
THREE.OBJLoader = require(/*! ./libs/OBJLoader.js */"./src/libs/OBJLoader.js")(THREE);
THREE.Shaders = require(/*! ./libs/shaders.js */"./src/libs/shaders.js")(THREE);
var UTILS = require(/*! ./libs/utils.js */"./src/libs/utils.js");
var OVERLAY = require(/*! ./libs/game-overlay.js */"./src/libs/game-overlay.js");
var RENDER = new (require(/*! ./libs/render.js */"./src/libs/render.js"))(THREE, UTILS, config, OVERLAY);
var SOUND = window["SOUND"] = new (require(/*! ./libs/sound.js */"./src/libs/sound.js"))(UTILS, config);
var PARTICLES = new (require(/*! ./libs/particles.js */"./src/libs/particles.js"))(RENDER, config);
var UI = require(/*! ./libs/UI.js */"./src/libs/UI.js");
var DIV = new (require(/*! ./libs/animDiv.js */"./src/libs/animDiv.js"))(RENDER, config);
var API_CLIENT = require(/*! ./libs/apiClient.js */"./src/libs/apiClient.js");
var io = require(/*! ./libs/io-client.js */"./src/libs/io-client.js");
var Game = require(/*! ./data/game.js */"./src/data/game.js").obj;
Game = new Game(false, 0, null, RENDER, SOUND, PARTICLES);
var CONTROLS = new (require(/*! ./libs/controls.js */"./src/libs/controls.js"))(RENDER, THREE, UI, UTILS, Game, config, io);
Game.controls = CONTROLS;
var maps = require(/*! ./data/map.js */"./src/data/map.js").maps;
var modes = require(/*! ./data/map.js */"./src/data/map.js").modes;
var Account = require(/*! ./data/account.js */"./src/data/account.js");
var Player = require(/*! ./data/players.js */"./src/data/players.js").Player;
var devConsole = require(/*! ./libs/devConsole.js */"./src/libs/devConsole.js");
var notify = require(/*! ./libs/notify.js */"./src/libs/notify.js");
var bhop = require(/*! ./libs/bhop.js */"./src/libs/bhop.js");
var ioEvents;
var Filter = require(/*! bad-words */"./kru_node_modules/bad-words/lib/badwords.js");
var filter = new Filter();
var gameVersion = require(/*! ../version.json */"./version.json");
var player;
var account;
var tmpObj;
var tmpObj2;
var tmpInput;
var lastInput;
var tmpVector = new THREE.Vector3();
var youHost = false;
var hostId = null;
var fillingHostMod = false;
window.locked = false;
var inputSendData = [];
var canLoadMods = true;
var camAnimRot = 0;
var scoreVal = 0;
var team = 0;
var scrollDirM = 1;
var ping = -1;
var mainPing = 0;
window.idleTimer = 0;
var now;
var delta;
var lastUpdate;
var endAnim;
var deathTimer;
var showKillMsg = true;
var showPlayerMsg = true;
var showUnboxings = true;
var fpsCounter = [];
var ADSImage = '';
var customProfile = '';
var capSuccess = false;
var endMessageSent = false;
var lastMod = getSavedVal("krk_lastMod") || '';
function setLastMod(last) {
  lastMod = last;
  saveVal("krk_lastMod", last);
}
;
setLastMod(lastMod);

// RESIZE:
var windowScale = 1;
var uiCustomScale = 1;
var MIN_WIDTH = 1700;
var MIN_HEIGHT = 900;
function scaleBase() {
  var width = window.innerWidth;
  var height = window.innerHeight;
  var minWidth = MIN_WIDTH * uiCustomScale;
  var minHeight = MIN_HEIGHT * uiCustomScale;
  var widthScale = width / minWidth;
  var heightScale = height / minHeight;
  if (heightScale < widthScale) {
    windowScale = heightScale;
    uiBase.style.transform = "scale(" + heightScale.toFixed(3) + ")";
    uiBase.style.width = (width / heightScale).toFixed(3) + "px";
    uiBase.style.height = minHeight + "px";
  } else {
    windowScale = widthScale;
    uiBase.style.transform = "scale(" + widthScale.toFixed(3) + ")";
    uiBase.style.width = minWidth + "px";
    uiBase.style.height = (height / widthScale).toFixed(3) + "px";
  }
}
window.addEventListener("resize", scaleBase);
scaleBase();

// TERM ACCEPTANCE:
window.checkTerms = function (yes) {
  if (yes) {
    consentBlock.style.display = "none";
    saveVal("consent", 1);
  } else {
    $("#consentShake").effect("shake");
  }
};

// PRELOAD IMAGES:
var preloadImages = ["/img/button/button-normal.png", "/img/button/button-hover.png", "/img/button/button-pressed.png", "/img/social-buttons/discord-normal.png", "/img/social-buttons/discord-hover.png", "/img/social-buttons/discord-pressed.png", "/img/social-buttons/reddit-normal.png", "/img/social-buttons/reddit-hover.png", "/img/social-buttons/reddit-pressed.png", "/img/social-buttons/twitter-normal.png", "/img/social-buttons/twitter-hover.png", "/img/social-buttons/twitter-pressed.png", "/img/social-buttons/kr-normal.png", "/img/social-buttons/kr-hover.png", "/img/social-buttons/kr-pressed.png"];
var preloadedImageObjs = []; // STORE IMG OBJECTS SO THEY DON'T GET RELEASED:
window.addEventListener("load", function () {
  for (var src of preloadImages) {
    var img = new Image();
    img.src = src;
    preloadedImageObjs.push(img);
  }
});

// OVERWRITES:
const notEval = eval; // We can't call `eval` directly, since the `babel` uglifier won't uglify variable names to pereserve functionality
Math.PI2 = Math.PI * 2;
Math.lerpAngle = function (value1, value2, amount) {
  var difference = Math.abs(value2 - value1);
  if (difference > Math.PI) {
    if (value1 > value2) {
      value2 += Math.PI2;
    } else {
      value1 += Math.PI2;
    }
  }
  var value = value2 + (value1 - value2) * amount;
  if (value >= 0 && value <= Math.PI2) {
    return value;
  }
  return value % Math.PI2;
};
console.warn = function (text) {};
console.info = function (text) {};

// STREAM MODE:
var streamMode = false;
window.toggleStrm = function (strm, isInit = false, skip) {
  streamMode = strm;
  if (!isInit) {
    if (strm) {
      window.history.pushState(document.title, document.title, "/");
    } else {
      window.history.pushState(document.title, document.title, clientManager.generateHref(connectedInstanceId));
    }
  }
  updateLeaders(lastLeaderData, lastSpecC);
};

// ENTER GAME:
var inGame = false;
window.loading = false;
var spectate = false;
window.spectating = false;
window.toggleSpect = function (spect) {
  spectate = spect;
};
var challengeM = false;
window.toggleChal = function (chal) {
  challengeM = chal;
};
window.enterGame = function () {
  if (Game.singlePlayer && !inGame) {
    startGame("0:00");
    var tmpSpawn = Game.getSpawnPoint(null, true);
    var tmpClass = Game.classes[parseInt(classIndex)];
    addPlayers([io.socketId, 1, tmpSpawn.x, tmpSpawn.y, tmpSpawn.z, "TEST", classIndex, tmpClass.health, tmpClass.health, null, 100, null, [skinsLoadout[tmpClass.loadout[0]] != undefined ? skinsLoadout[tmpClass.loadout[0]] : -1, skinsLoadout[tmpClass.loadout[1]] != undefined ? skinsLoadout[tmpClass.loadout[1]] : -1], null, null, tmpClass.secondary ? parseInt(secondaryInd) : null, false, null, -((tmpSpawn.dir || 0) + 1) * Math.PI / 2]);
    inGame = true;
    updateLeaders([1, "TEST", 0, 0, 0, 0]);
    UI.toggleMenu(false);
  } else {
    if (io.connected && (!inGame || window.spectating && !spectate)) {
      bloodDisplay.style.display = "none";
      inGame = true;
      window.idleTimer = 0;
      UI.toggleMenu(false);
      instructions.innerHTML = i18n.get('generic.loading');
      window.loading = true;
      var tmpClass = parseInt(classIndex);
      var tmpLoadout = Game.classes[tmpClass].loadout;
      var skinsToSend = [skinsLoadout[tmpLoadout[0]] != undefined ? skinsLoadout[tmpLoadout[0]] : -1, skinsLoadout[tmpLoadout[1]] != undefined ? skinsLoadout[tmpLoadout[1]] : -1];
      io.send("etrg", [tmpClass, parseInt(sprayIndex), skinsToSend, parseInt(hatIndex), parseInt(backIndex), parseInt(secondaryInd), spectate ? 1 : 0, challengeM ? 1 : 0, teamIndex, parseInt(meleeIndex)]);
    }
  }
};

// RESIZE WINDOW:
var screenWidth;
var screenHeight;
var uiScale;
function resize() {
  screenWidth = window.innerWidth;
  screenHeight = window.innerHeight;
  uiScale = screenHeight / windowScale / 693;
  RENDER.resize();
}
window.addEventListener("resize", resize);
resize();

// ADS:
window.toggleAd = function (active) {
  // var tmpEl = document.getElementById("krunkerio_728x90_1");
  // if (!active) tmpEl.setAttribute("data-refresh-time", -1);
  // else tmpEl.removeAttribute("data-refresh-time");
};

// PAYPAL:
function buildPayPalApiUrl(path) {
  return config.apiURL + path;
}
var purchaseIndex = 0;
window.cancelPurchase = function () {
  window.idleTimer = 0;
  showWindow(14);
  instructions.style.display = "block";
  purchaseIndex = 0;
  context.toggleMenuHider(true);
  purchaseLoad.style.display = "none";
};
function updateFunds(funds) {
  if (account) {
    account.funds = funds;
  }
  updateMenuAccountData();
}
;
function purchaseRes(error, funds) {
  window.idleTimer = 0;
  if (error) {
    purchaseError();
  } else {
    if (account) {
      account.funds = funds;
    }
    updateMenuAccountData();
    updateWindow(null, true);
    UI.toggleMenuHider(true);
    purchaseLoad.style.display = "none";
  }
}
;
window.showPurchase = function (index) {
  window.idleTimer = 0;
  purchaseIndex = index;
  purchaseHolder.style.display = "block";
  var paypalEl = document.getElementById("paypal-button");
  if (paypalEl) {
    paypalEl.innerHTML = "";
  }
  if (account) {
    paypal.Button.render({
      style: {
        size: 'large'
      },
      env: 'production',
      commit: true,
      payment: function (data, actions) {
        purchaseHolder.style.display = "none";
        return actions.request.post(buildPayPalApiUrl('/my-api/create-payment/'), {
          pIndex: purchaseIndex,
          acID: account.id
        }).then(function (res) {
          return res.id;
        });
      },
      onAuthorize: function (data, actions) {
        return actions.request.post(buildPayPalApiUrl('/my-api/execute-payment/'), {
          pIndex: purchaseIndex,
          acID: account.id,
          paymentID: data.paymentID,
          payerID: data.payerID
        }).then(function (res) {
          if (res && res.funds != undefined && res.funds != null) {
            if (account) {
              account.funds = res.funds;
            }
            updateMenuAccountData();
            updateWindow(null, true);
            UI.toggleMenuHider(true);
            purchaseLoad.style.display = "none";
          } else {
            purchaseError();
          }
        });
      },
      onError: function (err) {
        purchaseError();
      }
    }, '#paypal-button');
  }
};
purchaseHolder.onclick = function () {
  purchaseHolder.style.display = "none";
};
window.purchaseError = function () {
  showWindow();
  UI.toggleMenuHider(false);
  instructions.style.display = "none";
  purchaseLoad.style.display = "block";
  purchLoadRing.style.display = "none";
  purchaseLabel.innerHTML = i18n.get('purchase.error') + " <a href='javascript:;'" + " onclick='cancelPurchase()'>" + i18n.get('purchase.error.click') + "<div style='color:rgba(255,255,255,0.3);font-size:20px'>" + i18n.get('purchase.error.limit') + "</div>";
};

// VOICE CHAT:
const voiceReader = new FileReader();
var recording = false;
var tmpVoice;
var mediaRecorder;
var voiceVolume = 0;
var voiceTimer;
var speakers = {};
window.voiceChat = function (data, name) {
  if (voiceVolume) {
    if (streamMode && filter) {
      name = UTILS.scrambleS(name);
    }
    try {
      var tmpVoice = new Howl({
        src: [data],
        volume: voiceVolume
      });
      tmpVoice.on('load', function () {
        if (tmpVoice.duration() <= config.voiceChatMaxLength) {
          tmpVoice.on('end', function () {
            speakers[name]--;
            if (speakers[name] <= 0) {
              var tmpDiv = document.getElementById("speaker" + name);
              if (tmpDiv) {
                tmpDiv.parentElement.removeChild(tmpDiv);
              }
              delete speakers[name];
            }
          });
          if (!speakers[name]) {
            speakers[name] = 0;
            speakerDisplay.innerHTML += "<div id='speaker" + name + "' class='voiceSpeaker'>" + name + " <i class='material-icons'" + " style='color:#fff;font-size:35px;vertical-align:middle'>volume_down</i></div>";
          }
          speakers[name]++;
          tmpVoice.play();
        }
      });
    } catch (e) {}
  }
};
voiceReader.addEventListener('loadend', function (el) {
  var voiceData = voiceReader.result;
  io.send("vc", voiceData);
});
window.toggleRecord = function (record) {
  if (player || window.spectating) {
    if (record && !recording) {
      voiceDisplay.style.opacity = 0.9;
      recording = true;
      navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false
      }).then(function (stream) {
        mediaRecorder = new MediaRecorder(stream, {
          mimetype: "audio/ogg",
          bitsPerSecond: 6000
        });
        mediaRecorder.start();
        const audioChunks = [];
        mediaRecorder.addEventListener("dataavailable", function (event) {
          audioChunks.push(event.data);
        });
        mediaRecorder.addEventListener("stop", function () {
          recTimer.style.display = "none";
          voiceDisplay.style.opacity = 0.5;
          var audioBlob = new Blob(audioChunks, {
            type: 'audio/ogg; codecs=opus'
          });
          voiceReader.readAsDataURL(audioBlob);
        });
        recTimer.style.display = "inline-block";
        recTimer.innerHTML = config.voiceChatMaxLength;
        var timeleft = config.voiceChatMaxLength;
        voiceTimer = setInterval(function () {
          timeleft--;
          recTimer.innerHTML = timeleft;
          if (timeleft <= 0) {
            recording = false;
            mediaRecorder.stop();
            clearInterval(voiceTimer);
          }
        }, 1000);
      }).catch(function (err) {
        recording = false;
        if (voiceTimer) {
          clearInterval(voiceTimer);
        }
        voiceDisplay.style.opacity = 0.5;
      });
    } else {
      if (!record && recording && mediaRecorder) {
        recording = false;
        mediaRecorder.stop();
        clearInterval(voiceTimer);
      }
    }
  }
};

// SHOW MENU:
function showMenu() {
  inGame = false;
  window.idleTimer = 0;
  UI.toggleMenu(true);
  CONTROLS.toggle(false);
  resetClipData();
}

// UPDATER SLIDER:
window.updateSliderLabel = function (id, val) {
  var tmpEl = document.getElementById("customSet" + id);
  if (tmpEl) {
    tmpEl.innerHTML = val;
  }
};

// SETTINGS:
window.setSetting = function (key, val) {
  if (settings[key].min || settings[key].max) {
    val = Math.min(settings[key].max, Math.max(settings[key].min, val));
  }
  if (document.getElementById("slid_" + key)) {
    document.getElementById("slid_" + key).value = val;
  }
  if (document.getElementById("slid_input_" + key)) {
    document.getElementById("slid_input_" + key).value = val;
  }
  settings[key].set(val);
  settings[key].val = val;
  saveVal(`kro_setngss_${key}`, val);
};
window.resetSettings = function () {
  if (confirm(i18n.get('settings.reset.confirm'))) {
    Object.keys(localStorage).filter(x => x.includes("kro_setngss_") || x.includes("cont_")).forEach(x => localStorage.removeItem(x));
    location.reload();
  }
};
var settings = {
  changeControls: {
    name: "<div style='width:100%'><a href='javascript:;' onclick='showWindow(7);' " + "class='menuLink'>" + i18n.get('settings.controls.change') + "</a> | " + "<a onclick='resetSettings()' class='+'>" + i18n.get('settings.reset') + "</a></div>",
    html: function () {
      return "";
    }
  },
  defaultRegion: {
    name: i18n.get('settings.server.region'),
    pre: "<div class='setHed'>" + i18n.get('settings.server.header') + "</div>",
    get val() {
      return localStorage[ClientManager.PING_REGION_CACHE_KEY];
    },
    set val(val) {},
    html: function () {
      var tmpHTML = `<select onchange='setSetting("defaultRegion", this.value)' class='inputGrey'>`;
      for (var regionId of availableRegions) {
        tmpHTML += "<option value='" + regionId + "' " + (regionId == settings.defaultRegion.val ? "selected" : "") + ">";
        tmpHTML += config.regionNames[regionId];
        tmpHTML += "</option>";
      }
      tmpHTML += "</select>";
      return tmpHTML;
    },
    set: function (val) {
      if (val && config.isProd) {
        localStorage.setItem(ClientManager.PING_REGION_CACHE_KEY, val);
      }
    }
  },
  resolution: {
    name: i18n.get('settings.quality.res'),
    pre: "<div class='setHed'>" + i18n.get('settings.quality.header') + "</div>",
    val: 0.6,
    min: 0.1,
    max: 2,
    html: function () {
      return `<input type='number' class='sliderVal' id='slid_input_resolution' min='0.1' max='2' value='${settings.resolution.val}' oninput='setSetting("resolution", this.value)' style='border-width:0px'/>
              <div class='slidecontainer'>
              <input type='range' id='slid_resolution' min='0.1' max='2' step='0.1'" value='${settings.resolution.val}' class='sliderM' oninput='setSetting("resolution", this.value)'></div>`;
    },
    set: function (val) {
      RENDER.setResMlt(val);
    }
  },
  particles: {
    name: i18n.get('settings.quality.part'),
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("particles", this.checked)'
          ${settings.particles.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      PARTICLES.active = val;
    }
  },
  showTrails: {
    name: i18n.get('settings.quality.trails'),
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("showTrails", this.checked)'
          ${settings.showTrails.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      PARTICLES.showTrails = val;
    }
  },
  muzzleFlash: {
    name: i18n.get('settings.quality.mflash'),
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("muzzleFlash", this.checked)'
          ${settings.muzzleFlash.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      PARTICLES.showMuzzle = val;
    }
  },
  sniperFlap: {
    name: "Sniper Flap",
    val: false,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("sniperFlap", this.checked)'
          ${settings.sniperFlap.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      RENDER.sniperFlap = val;
    }
  },
  showUI: {
    name: i18n.get('settings.interface.ui'),
    pre: "<div class='setHed'>" + i18n.get('settings.interface.header') + "</div>",
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("showUI", this.checked)'
          ${settings.showUI.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      UI.hideGameUI = !val;
      chatUI.style.display = val ? "block" : "none";
    }
  },
  dynamicHP: {
    name: i18n.get('settings.interface.hp'),
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("dynamicHP", this.checked)'
          ${settings.dynamicHP.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      OVERLAY.dynamicHP = val;
    }
  },
  showChat: {
    name: i18n.get('settings.interface.chat'),
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("showChat", this.checked)'
          ${settings.showChat.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      chatHolder.style.display = val ? "block" : "none";
    }
  },
  showKills: {
    name: i18n.get('settings.interface.kills'),
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("showKills", this.checked)'
          ${settings.showKills.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      showKillMsg = val;
    }
  },
  showMessages: {
    name: i18n.get('settings.interface.messages'),
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("showMessages", this.checked)'
          ${settings.showMessages.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      showPlayerMsg = val;
    }
  },
  showUnboxings: {
    name: i18n.get('settings.interface.unboxings'),
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("showUnboxings", this.checked)'
          ${settings.showUnboxings.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      showUnboxings = val;
    }
  },
  showPing: {
    name: i18n.get('settings.interface.ping'),
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("showPing", this.checked)'
          ${settings.showPing.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      pingDisplay.style.display = val ? "block" : "none";
    }
  },
  showFPS: {
    name: i18n.get('settings.interface.fps'),
    val: false,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("showFPS", this.checked)'
          ${settings.showFPS.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      fpsDisplay.style.display = menuFPSDisplay.style.display = val ? "block" : "none";
    }
  },
  showDeaths: {
    name: i18n.get('settings.interface.deaths'),
    val: false,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("showDeaths", this.checked)'
          ${settings.showDeaths.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      deathCount.style.display = val ? "inline-block" : "none";
    }
  },
  crosshairSho: {
    name: i18n.get('settings.crosshair.type'),
    pre: "<div class='setHed'>" + i18n.get('settings.crosshair.header') + "</div>",
    val: 1,
    html: function () {
      return `<select class='inputGrey' onchange="setSetting('crosshairSho', this.value)">
              <option value="0"${settings.crosshairSho.val == 0 ? " selected" : ""}>${i18n.get('generic.off')}</option>
              <option value="1"${settings.crosshairSho.val == 1 ? " selected" : ""}>${i18n.get('generic.default')}</option>
              <option value="2"${settings.crosshairSho.val == 2 ? " selected" : ""}>${i18n.get('settings.crosshair.type.2')}</option>
              <option value="3"${settings.crosshairSho.val == 3 ? " selected" : ""}>${i18n.get('settings.crosshair.type.3')}</option>
              <option value="4"${settings.crosshairSho.val == 4 ? " selected" : ""}>${i18n.get('settings.crosshair.type.4')}</option>
              </select>`;
    },
    set: function (val) {
      OVERLAY.crosshairType = val;
      let options = ['crosshairStyle', 'crosshairAlways', 'crosshairLen', 'crosshairThick'];
      for (let opt of options) {
        settings[opt].hide = opt == 'crosshairAlways' ? val < 2 : val == 4 || val < 2;
        let doc = document.getElementById(opt + '_div');
        if (doc) {
          doc.style.display = settings[opt].hide ? 'none' : 'block';
        }
      }
      settings.crosshairImage.hide = !(val == 4);
      let doc = document.getElementById('crosshairImage_div');
      if (doc) {
        doc.style.display = !(val == 4) ? 'none' : 'block';
      }
    }
  },
  crosshairStyle: {
    name: i18n.get('settings.crosshair.style'),
    val: 0,
    hide: true,
    html: function () {
      return `<select class='inputGrey' onchange="setSetting('crosshairStyle', this.value)">
              <option value="0"${settings.crosshairStyle.val == 0 ? " selected" : ""}>${i18n.get('settings.crosshair.style.0')}</option>
              <option value="1"${settings.crosshairStyle.val == 1 ? " selected" : ""}>${i18n.get('settings.crosshair.style.1')}</option>
              <option value="2"${settings.crosshairStyle.val == 2 ? " selected" : ""}>${i18n.get('settings.crosshair.style.2')}</option>
              <option value="3"${settings.crosshairStyle.val == 3 ? " selected" : ""}>${i18n.get('settings.crosshair.style.3')}</option>
              <option value="4"${settings.crosshairStyle.val == 4 ? " selected" : ""}>${i18n.get('settings.crosshair.style.4')}</option>
              </select>`;
    },
    set: function (val) {
      OVERLAY.crosshairStyle = val;
    }
  },
  crosshairImage: {
    name: i18n.get('settings.crosshair.image'),
    val: '',
    hide: true,
    html: function () {
      return `<input type='url' placeholder='${i18n.get('settings.crosshair.image.paste')}' name='url' class='inputGrey'
              value='${settings.crosshairImage.val}' oninput='setSetting("crosshairImage", this.value)'/>`;
    },
    set: function (val) {
      val = UTILS.isURL(val) && !/\.svg/.test(val) ? val : '';
      if (OVERLAY.crosshairImage.src != val && val.length) {
        OVERLAY.crosshairImage.src = val;
      }
    }
  },
  crosshairAlways: {
    name: i18n.get('settings.crosshair.always'),
    val: false,
    hide: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("crosshairAlways", this.checked)'
              ${settings.crosshairAlways.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      OVERLAY.crosshairAlways = val;
    }
  },
  crosshairColor: {
    name: i18n.get('settings.crosshair.color'),
    val: "#ffffff",
    html: function () {
      return `<input type='color' id='head' name='color' value='${settings.crosshairColor.val}' oninput='setSetting("crosshairColor", this.value)' style='float:right;margin-top:5px'/>`;
    },
    set: function (val) {
      OVERLAY.crosshairColor = val;
    }
  },
  crosshairShadow: {
    name: i18n.get('settings.crosshair.shadow'),
    val: "#000000",
    html: function () {
      return `<input type='color' id='head' name='color' value='${settings.crosshairShadow.val}' oninput='setSetting("crosshairShadow", this.value)' style='float:right;margin-top:5px'/>`;
    },
    set: function (val) {
      OVERLAY.crosshairShadow = val;
    }
  },
  crosshairLen: {
    name: i18n.get('settings.crosshair.size'),
    val: 16,
    min: 2,
    max: 50,
    hide: true,
    html: function () {
      return `<input type='number' class='sliderVal' id='slid_input_crosshairLen' min='2' max='50' value='${settings.crosshairLen.val}' oninput='setSetting("crosshairLen", this.value)' style='border-width:0px'/>
              <div class='slidecontainer'>
              <input type='range' min='2' max='50' step='1' value='${settings.crosshairLen.val}' class='sliderM' oninput="setSetting('crosshairLen', this.value)"></div>`;
    },
    set: function (val) {
      OVERLAY.crosshairLen = val;
    }
  },
  crosshairThick: {
    name: i18n.get('settings.crosshair.thickness'),
    val: 2,
    min: 2,
    max: 20,
    hide: true,
    html: function () {
      return `<input type='number' class='sliderVal' id='slid_input_crosshairThick' min='2' max='20' value='${settings.crosshairThick.val}' oninput='setSetting("crosshairThick", this.value)' style='border-width:0px'/>
            <div class='slidecontainer'>
            <input type='range' min='2' max='20' step='1' value='${settings.crosshairThick.val}' class='sliderM' oninput="setSetting('crosshairThick', this.value)"></div>`;
    },
    set: function (val) {
      OVERLAY.crosshairThick = val;
    }
  },
  sensitivity: {
    name: i18n.get('settings.gameplay.sensitivity'),
    pre: "<div class='setHed'>" + i18n.get('settings.gameplay.header') + "</div>",
    val: 1,
    min: 0.1,
    max: 15,
    html: function () {
      return `<input type='number' class='sliderVal' id='slid_input_sensitivity' min='0.1' max='15' value='${settings.sensitivity.val}' oninput='setSetting("sensitivity", this.value)' style='border-width:0px'/>
              <div class='slidecontainer'>
              <input type='range' id='slid_sensitivity' min='0.1' max='15' step='0.1' value='${settings.sensitivity.val}' class='sliderM' oninput='setSetting("sensitivity", this.value)'></div>`;
    },
    set: function (val) {
      CONTROLS.sensMlt = val;
    }
  },
  aimSensitivity: {
    name: i18n.get('settings.gameplay.aimsens'),
    val: 1,
    min: 0.1,
    max: 15,
    html: function () {
      return `<input type='number' class='sliderVal' id='slid_input_aimSensitivity' min='0.1' max='15' value='${settings.aimSensitivity.val}' oninput='setSetting("aimSensitivity", this.value)' style='border-width:0px'/>
              <div class='slidecontainer'>
              <input type='range' id='slid_aimSensitivity' min='0.1' max='15' step='0.1' value='${settings.aimSensitivity.val}' class='sliderM' oninput='setSetting("aimSensitivity", this.value)'></div>`;
    },
    set: function (val) {
      CONTROLS.sensAimMlt = val;
    }
  },
  fov: {
    name: i18n.get('settings.gameplay.fov'),
    val: config.fov,
    min: 60,
    max: 120,
    html: function () {
      return `<input type='number' class='sliderVal' id='slid_input_fov' min='60' max='120' value='${settings.fov.val}' oninput='setSetting("fov", this.value)' style='border-width:0px'/>
              <div class='slidecontainer'>
              <input type='range' id='slid_fov' min='60' max='120' step='5' value='${settings.fov.val}"' class='sliderM' oninput='setSetting("fov", this.value)'></div>`;
    },
    set: function (val) {
      RENDER.setFov(val);
    }
  },
  scrollDir: {
    name: i18n.get('settings.gameplay.scrollDir'),
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("scrollDir", this.checked)'
                  ${settings.scrollDir.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      scrollDirM = val ? 1 : -1;
    }
  },
  streamMode: {
    name: i18n.get('settings.gameplay.streamer'),
    val: false,
    dontInit: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("streamMode", this.checked)'
          ${settings.streamMode.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      toggleStrm(val);
    }
  },
  challMode: {
    name: i18n.get('settings.gameplay.challenge'),
    val: false,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("challMode", this.checked)'
          ${settings.challMode.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      toggleChal(val);
    }
  },
  invertY: {
    name: i18n.get('settings.gameplay.invert'),
    val: false,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("invertY", this.checked)'
          ${settings.invertY.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      CONTROLS.invertY = val;
    }
  },
  sound: {
    name: i18n.get('settings.audio.sound'),
    pre: "<div class='setHed'>" + i18n.get('settings.audio.header') + "</div>",
    val: 1,
    min: 0,
    max: 1,
    html: function () {
      return `<input type='number' class='sliderVal' id='slid_input_sound' min='0' max='1' value='${settings.sound.val}' oninput='setSetting("sound", this.value)' style='border-width:0px'/>
              <div class='slidecontainer'>
              <input type='range' id='slid_sound' min='0' max='1' step='0.1' value='${settings.sound.val}' class='sliderM' oninput='setSetting("sound", this.value)'></div>`;
    },
    set: function (val) {
      SOUND.setVolume(val);
    }
  },
  voiceVolume: {
    name: i18n.get('settings.audio.voice'),
    val: 1,
    min: 0,
    max: 1,
    html: function () {
      return `<input type='number' class='sliderVal' id='slid_input_voiceVolume' min='0' max='1' value='${settings.voiceVolume.val}' oninput='setSetting("voiceVolume", this.value)' style='border-width:0px'/>
              <div class='slidecontainer'>
              <input type='range' id='slid_voiceVolume' min='0' max='1' step='0.1' value='${settings.voiceVolume.val}' class='sliderM' oninput='setSetting("voiceVolume", this.value)'></div>`;
    },
    set: function (val) {
      voiceVolume = val;
    }
  },
  fpsFOV: {
    name: i18n.get('settings.viewmodel.fps'),
    pre: "<div class='setHed'>" + i18n.get('settings.viewmodel.header') + "</div>",
    val: config.fov,
    min: 60,
    max: 120,
    html: function () {
      return `<input type='number' class='sliderVal' id='slid_input_fpsFOV' min='60' max='120' value='${settings.fpsFOV.val}' oninput='setSetting("fpsFOV", this.value)' style='border-width:0px'/>
              <div class='slidecontainer'>
              <input type='range' id='slid_fpsFOV' min='60' max='120' step='5' value='${settings.fpsFOV.val}' class='sliderM' oninput='setSetting("fpsFOV", this.value)'></div>`;
    },
    set: function (val) {
      RENDER.setFPSFov(val);
    }
  },
  weaponBob: {
    name: i18n.get('settings.viewmodel.bobbing'),
    val: 1,
    min: 0,
    max: 2,
    html: function () {
      return `<input type='number' class='sliderVal' id='slid_input_weaponBob' min='0' max='2' value='${settings.weaponBob.val}' oninput='setSetting("weaponBob", this.value)' style='border-width:0px'/>
              <div class='slidecontainer'>
              <input type='range' id='slid_weaponBob' min='0' max='2' step='0.1' value='${settings.weaponBob.val}' class='sliderM' oninput='setSetting("weaponBob", this.value)'></div>`;
    },
    set: function (val) {
      RENDER.weaponLean = val;
    }
  },
  showWeapon: {
    name: i18n.get('settings.viewmodel.show.primary'),
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("showWeapon", this.checked)'
          ${settings.showWeapon.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      Game.hideWeapon[0] = !val;
      if (player && player.weaponMeshes[0] && player.weaponIndex == 0) {
        player.weaponMeshes[0].visible = val;
      }
    }
  },
  showWeaponSec: {
    name: i18n.get('settings.viewmodel.show.secondary'),
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("showWeaponSec", this.checked)'
          ${settings.showWeaponSec.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      Game.hideWeapon[1] = !val;
      if (player && player.weaponMeshes[1] && player.weaponIndex == 1) {
        player.weaponMeshes[1].visible = val;
      }
    }
  },
  showWeaponMel: {
    name: i18n.get('settings.viewmodel.show.melee'),
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("showWeaponMel", this.checked)'
          ${settings.showWeaponMel.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      Game.hideWeapon[2] = !val;
      if (player && player.weaponMeshes[2] && player.weaponIndex == 2) {
        player.weaponMeshes[2].visible = val;
      }
    }
  },
  hudHealthHigh: {
    name: i18n.get('settings.editing.health.high'),
    pre: "<div class='setHed'>" + i18n.get('settings.editing.header') + "</div>",
    val: '#9eeb56',
    html: function () {
      return `<input type='color' id='head' name='color' value='${settings.hudHealthHigh.val}' oninput='setSetting("hudHealthHigh", this.value)' style='float:right;margin-top:5px'/>`;
    },
    set: function (val) {}
  },
  hudHealthLow: {
    name: i18n.get('settings.editing.health.low'),
    val: '#eb5656',
    html: function () {
      return `<input type='color' id='head' name='color' value='${settings.hudHealthLow.val}' oninput='setSetting("hudHealthLow", this.value)' style='float:right;margin-top:5px'/>`;
    },
    set: function (val) {}
  },
  depthMap: {
    name: i18n.get('settings.editing.depth'),
    val: 0,
    min: 0,
    max: 500,
    html: function () {
      return `<input type='number' class='sliderVal' id='slid_input_depthMap' min='0' max='500' value='${settings.depthMap.val}' oninput='setSetting("depthMap", this.value)' style='border-width:0px'/>
              <div class='slidecontainer'>
              <input type='range' id='slid_depthMap' min='0' max='500' step='5' value='${settings.depthMap.val}' class='sliderM' oninput='setSetting("depthMap", this.value)'></div>`;
    },
    set: function (val) {
      RENDER.toggleDepthMap(val);
    }
  },
  greenScreen: {
    name: i18n.get('settings.editing.green'),
    val: false,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("greenScreen", this.checked)'
          ${settings.greenScreen.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      RENDER.toggleGreenscreen(val);
    }
  },
  ambientShading: {
    name: i18n.get('settings.shaders.ambient'),
    pre: "<div class='setHed'>" + i18n.get('settings.shaders.header') + "</div>",
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("ambientShading", this.checked)'
          ${settings.ambientShading.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      RENDER.toggleMeshGroup("ambient_0", val);
      RENDER.toggleMeshGroup("ambient_1", val);
    }
  },
  canLoadMods: {
    name: i18n.get('settings.mods.load'),
    pre: "<div class='setHed'>" + i18n.get('settings.mods.header') + "</div>",
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("canLoadMods", this.checked)'
          ${settings.canLoadMods.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      canLoadMods = val;
    }
  },
  autoLoadLast: {
    name: i18n.get('settings.mods.auto'),
    val: false,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("autoLoadLast", this.checked)'
          ${settings.autoLoadLast.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {}
  },
  scopeBorders: {
    name: i18n.get('settings.mods.borders'),
    val: true,
    html: function () {
      return `<label class='switch'><input type='checkbox' onclick='setSetting("scopeBorders", this.checked)'
          ${settings.scopeBorders.val ? "checked" : ""}><span class='slider'></span></label>`;
    },
    set: function (val) {
      Array.from(document.querySelectorAll('.black')).forEach(el => el.style.display = val ? "block" : "none");
    }
  },
  customScope: {
    name: i18n.get('settings.mods.scope'),
    val: '',
    html: function () {
      return `<input type='url' placeholder='${i18n.get('settings.mods.scope.paste')}' name='url' class='inputGrey'
              value='${settings.customScope.val}' oninput='setSetting("customScope", this.value)'/>`;
    },
    set: function (val) {
      val = UTILS.isURL(val) && !/\.svg/.test(val) ? val : '';
      recticleImg.src = val.length > 1 ? val : location.origin + '/textures/recticle.png';
    }
  },
  customADSDot: {
    name: i18n.get('settings.mods.dot'),
    val: '',
    html: function () {
      return `<input type='url' id='customADSDot' placeholder='${i18n.get('settings.mods.dot.paste')}' name='url' class='inputGrey'
              value='${settings.customADSDot.val}' oninput='setSetting("customADSDot", this.value)'/>`;
    },
    set: function (val) {
      val = UTILS.isURL(val) && !/\.svg/.test(val) ? val : '';
      if (val.length) {
        ADSImage = val;
      }
    }
  },
  endMessage: {
    name: i18n.get('settings.mods.endmessage'),
    val: '',
    html: function () {
      return `<input type='text' placeholder='${i18n.get('settings.mods.endmessage')}' name='text' class='inputGrey'
              value='${settings.endMessage.val}' oninput='setSetting("endMessage", this.value)'/>`;
    },
    set: function (val) {}
  },
  customProfile: {
    name: i18n.get('settings.mods.profile'),
    val: '',
    html: function () {
      return `<input type='url' id='customProfile' placeholder='${i18n.get('settings.mods.profile.paste')}' name='url' class='inputGrey'
              value='${settings.customProfile.val}' oninput='setSetting("customProfile", this.value)'/>`;
    },
    set: function (val) {
      val = UTILS.isURL(val) && !/\.svg/.test(val) ? val : '';
      customProfile = menuMiniProfilePic.src = hudClassImg.src = val;
    }
  }
};

// LOAD SETTINGS:
for (var key in settings) {
  if (settings[key].set && !settings[key].dontInit) {
    var tmpVal = getSavedVal(`kro_setngss_${key}`);
    settings[key].val = tmpVal !== null ? tmpVal : settings[key].val;
    if (settings[key].val == "false") {
      settings[key].val = false;
    }
    if (settings[key].min || settings[key].max) {
      settings[key].val = Math.min(settings[key].max, Math.max(settings[key].min, settings[key].val));
    }
    settings[key].set(settings[key].val, true);
  }
}
new MutationObserver((mutationsList, observer) => {
  if (ADSImage.length > 1) {
    if (ADSImage != mutationsList[0].target.src) {
      mutationsList[0].target.src = ADSImage;
    }
  }
}).observe(aimDot, {
  attributes: true,
  attributeFilter: ['src']
});

// CHANGE CONTROLS:
window.changeCont = function (val, otherSrc) {
  if (!otherSrc) {
    showWindow(7, true);
  }
  if (val <= 3) {
    CONTROLS.inputChanger = val;
  } else {
    if (val == 4) {
      CONTROLS.inputChanger = "jumpKey";
    } else {
      if (val == 5) {
        CONTROLS.inputChanger = "crouchKey";
      } else {
        if (val == 6) {
          CONTROLS.inputChanger = "meleeKey";
        } else {
          if (val == 7) {
            CONTROLS.inputChanger = "swapKey";
          } else {
            if (val == 8) {
              CONTROLS.inputChanger = "reloadKey";
            } else {
              if (val == 9) {
                CONTROLS.inputChanger = "sprayKey";
              } else {
                if (val == 10) {
                  CONTROLS.inputChanger = "aimKey";
                } else {
                  if (val == 11) {
                    CONTROLS.inputChanger = "chatKey";
                  } else {
                    if (val == 12) {
                      CONTROLS.inputChanger = "voiceKey";
                    } else {
                      if (val == 13) {
                        CONTROLS.inputChanger = "primKey";
                      } else {
                        if (val == 14) {
                          CONTROLS.inputChanger = "inspKey";
                        } else {
                          if (val == 15) {
                            CONTROLS.inputChanger = "listKey";
                          } else {
                            if (val == 16) {
                              CONTROLS.inputChanger = "interactKey";
                            } else {
                              if (val == 17) {
                                CONTROLS.inputChanger = "dropKey";
                              } else {
                                if (val == 18) {
                                  CONTROLS.inputChanger = "bhopModeKey";
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  document.getElementById("cont" + val).innerHTML = i18n.get('settings.controls.press');
};

// ACCOUNTS:
function updateAccount(data) {
  if (account) {
    account.setData(data);
  }
  updateWindow(5);
  updateMenuAccountData(data);
}
function updateMenuAccountData() {
  if (account) {
    signedOutHeaderBar.style.display = "none";
    signedInHeaderBar.style.display = null;
    if (account.level >= config.rewardMinLvl) {
      claimHolder.style.display = "block";
      merchHolder.style.top = "205px";
      updateClaimTimer();
    } else {
      merchHolder.style.top = "110px";
    }
    menuAccountUsername.innerText = account.name;
    menuKRCount.innerText = account.funds;
    menuLevelText.innerText = "LVL " + account.level;
    menuLevelBar.style.width = account.levelProg + "%";
    var levelIconId = UTILS.levelIconId(account.level);
    menuLevelIcon.style.backgroundImage = "url('/img/levels/" + levelIconId + ".png')";
  } else {
    signedOutHeaderBar.style.display = null;
    signedInHeaderBar.style.display = "none";
    claimHolder.style.display = "none";
    merchHolder.style.top = "110px";
  }
}
function updatePingDisplay() {
  var pingColor = "#9eeb56";
  if (ping >= 150) {
    pingColor = "#ff4b42";
  } else {
    if (ping >= 50) {
      pingColor = "#ffd542";
    }
  }
  var pingText = ping == -1 ? "-" : ping;
  pingDisplay.innerHTML = pingText + "<i class='material-icons' style='" + "color:" + pingColor + "'>signal_cellular_alt</i>";
  menuPingDisplay.innerHTML = "<i class='material-icons' style='" + "color:" + pingColor + "'>signal_cellular_alt</i> " + pingText;
}
function updateFPSDisplay() {
  if (!settings.showFPS.val) {
    return;
  }
  var fpsColor = "#9eeb56";
  var fps = 0;
  let now = performance.now();
  for (; fpsCounter.length > 0 && fpsCounter[0] <= now - 1e3;) {
    fpsCounter.shift();
  }
  fpsCounter.push(now);
  fps = fpsCounter.length;
  if (fps < 30) {
    fpsColor = "#ff4b42";
  } else {
    if (fps < 50) {
      fpsColor = "#ffd542";
    }
  }
  fpsDisplay.innerHTML = menuFPSDisplay.innerHTML = "<span style='color:" + fpsColor + "'>" + fps + "</span> FPS";
}
function showAccResp(resp) {
  try {
    accResp.innerHTML = resp || "";
    accResp.style.display = resp ? "block" : "none";
  } catch (e) {}
}
function accountAction(index, data) {
  if (index >= 0) {
    showAccResp(i18n.get('generic.wait'));
  }
  if (index == 0 && !capSuccess) {
    try {
      grecaptcha.reset(); // RESET IF ONE ALREADY RENDERED
    } catch (e) {}
    ;
    grecaptcha.render('captchaBtn', {
      'sitekey': '6LchqW0UAAAAANOoHruD0Ql5aNJIZld4EwLiaf-W',
      'callback': function (captchaToken) {
        capSuccess = true;
        io.send("a", index, data, captchaToken);
      }
    });
    grecaptcha.execute();
  } else {
    io.send("a", index, data);
  }
}
function accountResp(error, id, name, data, token) {
  if (error) {
    showAccResp(error);
  } else {
    account = new Account(id, name, null, config);
    saveVal("krunker_id", id);
    saveVal("krunker_username", name);
    updateAccount(data);
    if (account.hack) {
      window.activeHacker = true;
    }
    if (token) {
      saveVal("krunker_token", token);
      loginToken = token;
    }
    updateWindow(null, true);
  }
}
window.registerAcc = function () {
  accountAction(0, [accName.value, accPass.value]);
};
function autoLogin() {
  loginToken = getSavedVal("krunker_token");
  var tmpName = getSavedVal("krunker_username");
  if (loginToken && tmpName) {
    accountAction(1, [tmpName, null, loginToken]);
  }

  // WELCOME MESSAGE:
  var lastPlayed = getSavedVal("krunker_last");
  var nowTim = Date.now();
  saveVal("krunker_last", nowTim);
  if (!lastPlayed || nowTim - lastPlayed >= 600000) {
    io.send("sb", "welc", tmpName);
  }
}
window.loginAcc = function () {
  accountAction(1, [accName.value, accPass.value, null]);
};
window.logoutAcc = function () {
  accountAction(-1);
  showAccResp();
  deleteVal("krunker_id");
  deleteVal("krunker_username");
  deleteVal("krunker_token");
  deleteVal("skins");
  deleteVal("hatIndex");
  deleteVal("backIndex");
  deleteVal("meleeIndex");
  hatIndex = -1;
  backIndex = -1;
  meleeIndex = -1;
  skinsLoadout = {};
  selectSecondary(2);
  windows[12].clanData = null;
  loginToken = null;
  account = null;
  updateAccount();
  showWindow(5);
  updateClassDisplay();
};

// LOG OUT FROM ALL OTHER SESSIONS;
var clearedSessions = false;
window.newTok = function (nt) {
  if (nt) {
    saveVal("krunker_token", nt);
    loginToken = nt;
  }
};
window.logoutSessions = function (el) {
  if (el) {
    el.style.display = "none";
  }
  clearedSessions = true;
  io.send("las");
};

// CLAIM REWARD:
var lastClaimTimer;
var timVal = 0;
function updateClaimTimer() {
  if (claimHolder.style.display == "block") {
    timVal = config.rewardTime - ((now || Date.now()) - account.lastReward);
    var tmpTimer = UTILS.getTimeH(Math.max(0, timVal));
    if (lastClaimTimer != tmpTimer) {
      lastClaimTimer = tmpTimer;
      claimTimer.innerHTML = tmpTimer == "00:00:00" ? "" : tmpTimer;
      merchHolder.style.top = tmpTimer == "00:00:00" ? "205px" : "237px";
    }
    var tmpSrc = timVal <= 0 ? "./img/claim_0.png" : "./img/claim_1.png";
    if (claimImg.getAttribute('src') != tmpSrc) {
      claimImg.src = tmpSrc;
    }
  }
}
function claimResp(tim, fnd) {
  updateFunds(fnd);
  if (account) {
    account.lastReward = tim;
  }
  updateClaimTimer();
}
window.claimReward = function () {
  // CHECK IF ALREADY CLAIMED:
  if (timVal > 0) {
    // alert("Already claimed.");
    return;
  }

  // SHOW AD:
  showPreAd();
};

// LOADOUTS:
window.setClassIndex = function (index) {
  classIndex = index;
  menuMiniProfilePic.src = customProfile.length ? customProfile : "/textures/classes/icon_" + classIndex + ".png";
};
var teamIndex = 1;
var meleeIndex = getSavedVal("meleeIndex") || -1;
var backIndex = getSavedVal("backIndex") || -1;
var hatIndex = getSavedVal("hatIndex") || -1;
var savedSkins = getSavedVal("skins");
var skinsLoadout = savedSkins ? JSON.parse(savedSkins) : {};
setClassIndex(getSavedVal("classindex") || 0);
var secondaryInd = getSavedVal("secondaryInd") || 2;
var activeSkinSel = 0;
window.selectHat = function (index) {
  saveVal("hatIndex", index);
  hatIndex = index;
  updateClassDisplay();
  showWindow(3);
};
window.selectBack = function (index) {
  saveVal("backIndex", index);
  backIndex = index;
  updateClassDisplay();
  showWindow(3);
};
window.selectMelee = function (index) {
  saveVal("meleeIndex", index);
  meleeIndex = index;
  updateClassDisplay();
  showWindow(3);
};
window.selectSecondary = function (index) {
  saveVal("secondaryInd", index);
  secondaryInd = index;
  updateClassDisplay();
  showWindow(3);
};
window.selectClass = function (index) {
  saveVal("classindex", index);
  if (Game.classes[index].txts) {
    showSpBubble(Game.classes[index].txts[UTILS.randInt(0, Game.classes[index].txts.length - 1)]);
  } else {
    if (!UTILS.randInt(0, 2)) {
      showSpBubble(["Let's Go!", "Alright!", "I'm Ready!"][UTILS.randInt(0, 2)]);
    }
  }
  setClassIndex(index);
  updateClassDisplay();
  showWindow(3);
};
window.skinSelector = function (index) {
  activeSkinSel = index;
  updateClassDisplay();
  showWindow(15);
};
window.selectSkin = function (index, weapon) {
  tmpObj = Game.store.skins[index];
  if (tmpObj) {
    skinsLoadout[weapon] = index;
  } else {
    skinsLoadout[weapon] = undefined;
  }
  saveVal("skins", JSON.stringify(skinsLoadout));
  updateClassDisplay();
  showWindow(3);
};

// PLAYER MENU PREVIEW:
var playerPreviewW = 660;
var playerPreviewH = 350;
var classScene;
var classPlayer;
var classCam = new THREE.PerspectiveCamera(15, 1, 0.1, 100);
var classRender = new THREE.WebGLRenderer({
  canvas: classPreviewCanvas,
  precision: "mediump",
  antialias: false,
  alpha: true
});
classCam.position.x = -10;
classCam.position.y = 17;
classCam.position.z = -29;
function updateClassDisplay() {
  // UPDATE HEADER DATA:
  var selectedClass = Game.classes[classIndex];
  menuClassName.innerText = selectedClass.name;

  // SUBTEXT:
  var subtextHTML = "";
  function addWeaponSubtext(weaponId, setColor = true) {
    // ADD DASH:
    if (subtextHTML) {
      subtextHTML += " - ";
    }

    // GET SKIN COLOR:
    var color = "inherit";
    var name = Game.weapons[weaponId].name;
    if (skinsLoadout[weaponId] != null) {
      var skinData = Game.store.skins[skinsLoadout[weaponId]];
      if (skinData) {
        color = Game.store.rarities[skinData.rarity].color;
        name = skinData.name;
      }
    }

    // ADD HTML:
    subtextHTML += "<span style='color:" + (setColor ? color : "inherit") + "'>" + name + "</span>";
  }
  for (var weaponId of selectedClass.loadout) {
    addWeaponSubtext(weaponId);
  }
  menuClassSubtext.innerHTML = subtextHTML;

  // CREATE SCENE:
  classScene = new THREE.Scene();
  classScene.add(new THREE.AmbientLight(9937064));
  var dirLight = new THREE.DirectionalLight(15923452, 0.5);
  dirLight.position.set(10, 17, -10);
  classScene.add(dirLight);

  // GET SKINS:
  var weaponSkins = [skinsLoadout[selectedClass.loadout[0]] != undefined ? skinsLoadout[selectedClass.loadout[0]] : -1, skinsLoadout[selectedClass.loadout[1]] != undefined ? skinsLoadout[selectedClass.loadout[1]] : -1];

  // GENERATE PLAYER:
  classPlayer = new Player(-1, this, UTILS, config, Game);
  classPlayer.sid = -1;
  classPlayer.init(0, 0, 0, "preview", false);
  classPlayer.skins = weaponSkins;
  classPlayer.hatIndex = hatIndex;
  classPlayer.backIndex = backIndex;
  classPlayer.meleeIndex = meleeIndex;
  classPlayer.secIndex = secondaryInd;
  classPlayer.setClass(Game, classIndex, secondaryInd, true);
  Game.players.swapWeapon(classPlayer, 0, true);
  classScene.add(Game.players.generateMeshes(classPlayer, false));
  classPlayer.swapTime = 0;
  classPlayer.weaponMeshes[0].visible = true;

  // MOVE CAMERA:
  classCam.lookAt(new THREE.Vector3(0, config.playerHeight * 0.8, 0));
}
updateClassDisplay();
var hideFull = getSavedVal("krk_hideFull") == "true" ? true : false;
window.toggleHF = function (enabled) {
  hideFull = enabled;
  saveVal("krk_hideFull", enabled);
};
toggleHF(hideFull);

// OPEN WINDOW:
setInterval(() => {
  window.kiH(io);
}, 12000);
window.windows = [{
  header: i18n.get('windows.settings.header'),
  gen: function () {
    var tmpHTML = "";
    for (var key in settings) {
      if (settings[key].pre) {
        tmpHTML += settings[key].pre;
      }
      tmpHTML += "<div class='settName' id='" + key + "_div'" + " style='display:" + (settings[key].hide ? 'none' : 'block') + "'>" + settings[key].name + " " + settings[key].html() + "</div>";
    }
    return tmpHTML;
  }
}, {
  header: i18n.get('windows.servers.header'),
  lastLoadTime: 0,
  serverListData: [],
  gen: function () {
    if (Date.now() - this.lastLoadTime < config.serverBrowserRate) {
      return this.genList();
    } else {
      this.lastLoadTime = Date.now();
      return this.loadData();
    }
  },
  loadData: function () {
    // FETCH SERVER LIST:
    clientManager.fetchGameList().then(serverListData => {
      // SAVE DATA:
      this.serverListData = serverListData;

      // CHECK IF NEEDS TO FETCH PRIVATE SERVER:
      var hasThisServer = false;
      for (var server of serverListData) {
        if (server.id === connectedInstanceId) {
          hasThisServer = true;
          break;
        }
      }
      if (hasThisServer) {
        // SHOW SERVER LIST:
        window.showWindow(2, true);
      } else {
        clientManager.fetchGameInfo(connectedInstanceId).then(serverInfo => {
          // SAVE DATA:
          this.privateServerData = serverInfo;

          // SHOW SERVER LIST:
          window.showWindow(2, true);
        });
      }
    });

    // LOADING TEXT:
    return i18n.get('generic.loading');
  },
  expandedRegion: -1,
  totalPlayerCount: 0,
  serverSearch: null,
  searchList: function () {
    var tmpEl = document.getElementById("serverSearch");
    this.serverSearch = tmpEl && tmpEl.value != "" ? tmpEl.value : null;
    tmpEl = document.getElementById("serverHolder");
    if (tmpEl) {
      tmpEl.innerHTML = this.getServers();
    }
  },
  getServers: function () {
    var debugServerList = !!localStorage.debugServerList;

    // CREATE BASE DATA:
    var tmpHTML = "";
    this.totalPlayerCount = 0;
    var sortedList = {
      custom: {
        order: 1,
        name: "Custom Games",
        players: 0,
        games: []
      }
    };

    // PROCESS SERVERS:
    var hasThisServer = false;
    for (var i = 0; i < this.serverListData.length; i++) {
      var server = this.serverListData[i];

      // VALIDATE DATA:
      if (!server.data) {
        console.warn("Server doesn't have data yet.");
        continue;
      }

      // ADD REGION DATA:
      if (!sortedList[server.region]) {
        sortedList[server.region] = {
          name: config.regionNames[server.region],
          players: 0,
          games: []
        };
      }

      // SAVE SERVER:
      var adjustedRegion = server.data.cs ? "custom" : server.region;
      server.clients = Math.min(server.clients, server.maxClients); // CAP PLAYER DISPLAY:
      if (connectedInstanceId === server.id) {
        hasThisServer = true;
      }
      if (!this.serverSearch || this.searchMatches(server)) {
        sortedList[adjustedRegion].players += server.clients;
      }
      this.totalPlayerCount += server.clients;
      sortedList[adjustedRegion].games.push(server);
    }

    // DISPLAY PRIVATE SERVER:
    if (!hasThisServer) {
      if (!this.privateServerData) {
        console.warn("Missing private server data.");
      } else {
        if (!this.privateServerData.data) {
          console.warn("Server doesn't have data yet.");
        } else {
          sortedList["custom"].games.push(this.privateServerData);
        }
      }
    }

    // SORT REGIONS AND PLAYERS:
    var regions = [];
    for (var region in sortedList) {
      if (sortedList.hasOwnProperty(region)) {
        regions.push(sortedList[region]);
      }
    }
    regions = regions.sort((b, a) => {
      return (a.order || -1) - (b.order || -1);
    });
    for (var region of regions) {
      region.games.sort((b, a) => {
        return a.clients - b.clients;
      });
    }

    // YOUR LEVEL:
    var yourLvl = account ? account.level : 0;

    // GENERATE HTML:
    for (var regionCounter = 0; regionCounter < regions.length; regionCounter++) {
      var region = regions[regionCounter];
      region.games = region.games.filter(x => hideFull ? x.clients != x.maxClients : true);
      var regionLabel = region.name + " - " + region.players + " online";
      var isExpanded = this.expandedRegion == regionCounter;
      var plusOrMinus = isExpanded ? "&#x25BC;" : "&#x25B6;";
      tmpHTML += "<div class='menuSelectorHeader' onclick='setExpandedRegion(" + (isExpanded ? -1 : regionCounter) + ")' style='cursor: pointer;'>" + plusOrMinus + " " + regionLabel + "</div>";
      if (isExpanded) {
        tmpHTML += "<div class='menuSelectorHolder'>";
        var addedCount = 0;
        for (var gameIndex = 0; gameIndex < region.games.length; gameIndex++) {
          var game = region.games[gameIndex];
          var isSelected = connectedInstanceId && connectedInstanceId == game.id;
          if (!this.serverSearch || this.searchMatches(game)) {
            addedCount++;
            var info = debugServerList ? game.id : game.data.i;
            var serverLabel = info + (game.data.earnKR ? " <i class='material-icons' style='color:#2196F3;font-size:33px;" + "vertical-align:bottom;'>check_circle</i>" : "") + "<div class='serverPCount'>" + game.clients + "/" + game.maxClients + "</div>" + (game.data.cs ? "<div class='serverRegion'>" + game.id.split(':')[0] + " -&nbsp;</div>" : "");
            var itemClass = "menuSelector" + (isSelected ? " selectedMenuSelector" : "");
            var onClick = "checkedSwitchServer(\"" + game.id + "\", this.querySelector(\".serverPCount\"))";
            tmpHTML += "<div class='" + itemClass + "' onclick='" + onClick + "'>" + serverLabel + "</div>";
          }
        }
        if (!region.games.length || !addedCount) {
          tmpHTML += "<div style='margin-left:30px;margin-top:5px'>" + i18n.get('windows.servers.none') + "</div>";
        }
        tmpHTML += "</div>";
      }
    }
    return tmpHTML;
  },
  genList: function () {
    var _this = this;
    window.setExpandedRegion = function (region) {
      _this.expandedRegion = region;
      _this.lastLoadTime = Date.now(); // Prevent reloading
      showWindow(2, true);
    };
    var tmpHTML = "<div style='font-size:20px'>";

    // ADD CREATE PRIVATE ROOM:
    tmpHTML += "<a class='menuLink' onclick='openHostWindow()'>" + i18n.get('windows.servers.host') + "</a>" + "<div style='float:right;display:inline-block'><input id='serverSearch'" + (this.serverSearch ? "value='" + this.serverSearch + "'" : "") + " type='text' placeholder='" + i18n.get('generic.search') + "' oninput='windows[1].searchList()'></input></div></div>" + '<div id="serverFilters"><div id="hideFull" style="float:right;align-items:center;display:flex">' + '<span class="grey">' + i18n.get('windows.servers.hide') + '</span>' + '<label class="switchsml"><input type="checkbox" onclick="toggleHF(this.checked);windows[1].searchList()"' + (hideFull ? " checked" : "") + '><span class="sliderSml"></span></label></div></div>' + "<div style='height:10px'></div>";
    tmpHTML += "<div style='font-size:20px'>";
    // ADD SERVERS:
    tmpHTML += "<div id='serverHolder'>" + this.getServers() + "</div>";

    // ADD TOTAL PLAYERS:
    tmpHTML += "<div style='height:10px'></div><b style='color:rgba(0,0,0,0.6)'>" + i18n.get('windows.servers.online', this.totalPlayerCount) + "</b>";
    tmpHTML += "</div>";
    return tmpHTML;
  },
  searchMatches(server) {
    if (!server.data) {
      return false;
    }
    return (server.data.i || "").toLowerCase().indexOf((this.serverSearch || "").toLowerCase()) >= 0;
  }
}, {
  header: i18n.get('windows.loadout.header'),
  gen: function () {
    var tmpClass = Game.classes[classIndex];
    if (Game.config.classes.indexOf(parseInt(classIndex)) < 0) {
      classIndex = Game.config.classes[0];
      tmpClass = Game.classes[classIndex];
    }
    var weap1 = Game.weapons[tmpClass.loadout[0]].name;
    var col1 = "#2196F3";
    var weap2 = tmpClass.secondary ? Game.weapons[secondaryInd].name : i18n.get('generic.none');
    var col2 = tmpClass.secondary ? "#2196F3" : "rgba(0,0,0,0.3)";
    var col3 = "rgba(0,0,0,0.3)";
    var col4 = col3;
    var col5 = "rgba(0,0,0,0.3)";
    if (account) {
      if (skinsLoadout[tmpClass.loadout[0]] != undefined) {
        weap1 = Game.store.skins[skinsLoadout[tmpClass.loadout[0]]];
        if (weap1) {
          col1 = Game.store.rarities[weap1.rarity].color;
          weap1 = weap1.name;
        }
      }
      if (tmpClass.loadout[1] && skinsLoadout[tmpClass.loadout[1]] != undefined) {
        weap2 = Game.store.skins[skinsLoadout[tmpClass.loadout[1]]];
        if (weap2) {
          col2 = Game.store.rarities[weap2.rarity].color;
          weap2 = weap2.name;
        }
      }
      if (hatIndex >= 0 && Game.store.skins[hatIndex]) {
        col3 = Game.store.rarities[Game.store.skins[hatIndex].rarity].color;
      }
      if (backIndex >= 0 && Game.store.skins[backIndex]) {
        col4 = Game.store.rarities[Game.store.skins[backIndex].rarity].color;
      }
      if (meleeIndex >= 0 && Game.store.skins[meleeIndex]) {
        col5 = Game.store.rarities[Game.store.skins[meleeIndex].rarity].color;
      }
    }
    return "<div class='settName'>" + i18n.get('windows.loadout.class') + "<span class='settText floatR'" + " onclick='showWindow(6)'>" + tmpClass.name + "</span></div>" + "<div class='settName'>" + i18n.get('windows.loadout.primary') + "<span class='settLabel wepLink' style='color:" + col1 + "' onclick='skinSelector(" + tmpClass.loadout[0] + ")'>" + weap1 + "</span></div>" + "<div class='settName'>" + i18n.get('windows.loadout.secondary') + "<span class='settLabel" + (tmpClass.secondary ? " wepLink" : "") + "' " + (tmpClass.secondary ? "onclick='showWindow(20)" + "'" : "") + " style='color:" + col2 + "'>" + weap2 + "</span></div>" + "<div class='settName'>" + i18n.get('windows.loadout.melee') + "<span onclick='showWindow(26)' class='settText floatR" + "' style='color:" + col5 + "'>" + (Game.store.skins[meleeIndex] ? Game.store.skins[meleeIndex].name : "Combat Knife") + "</span></div>" + "<div class='settName'>" + i18n.get('windows.loadout.hat') + "<span onclick='showWindow(16)' class='settText floatR' style='color:" + col3 + "'>" + (Game.store.skins[hatIndex] ? Game.store.skins[hatIndex].name : i18n.get('generic.none')) + "</span></div>" + "<div class='settName'>" + i18n.get('windows.loadout.body') + "<span onclick='showWindow(17)' class='settText floatR' style='color:" + col4 + "'>" + (Game.store.skins[backIndex] ? Game.store.skins[backIndex].name : i18n.get('generic.none')) + "</span></div>" + "<div class='settName'>" + i18n.get('windows.loadout.spray') + "<span onclick='showWindow(9)' class='settText floatR'>" + Game.sprays[sprayIndex].name + "</span></div>";
  }
}, {
  header: i18n.get('windows.mods.header'),
  openList: function () {
    fillingHostMod = false;
    showWindow(18);
  },
  gen: function () {
    return "<div id='modLinks'><a href='https://goo.gl/dPAxfr' class='menuLink'>" + i18n.get('windows.mods.guide') + "</a> | " + "<a href='javascript:;' onclick='windows[3].openList()' class='menuLink'>" + i18n.get('windows.mods.list') + "</a> | " + "<a href='javascript:;' onclick='showWindow(19)' class='menuLink'>" + i18n.get('windows.mods.publish') + "</a> | " + "<a href='/viewer.html' class='menuLink'>" + i18n.get('windows.mods.viewer') + "</a></div>" + "<form id='modDropper'><input onchange='loadMod()' id='modInput'" + "type='file'><p id='modLInfo'>" + i18n.get('windows.mods.drop') + "</p></form>" + "<input type='text' id='modURL' class='accountInput' style='width:78%' placeholder='" + i18n.get('windows.mods.paste') + "'>" + "<a class='menuLink' style='display:inline-block;margin-left:10px' onclick='loadModURL()'>" + i18n.get('windows.mods.load') + "</a>";
  }
}, {
  header: i18n.get('windows.account.header'),
  gen: function () {
    return account ? "<div class='settName' style='width:100%'>" + i18n.get('generic.name') + "<a href='/social.html?p=profile&q=" + account.name + "' class='floatR'>" + account.name + "</a></div>" + "<div class='settName' style='width:100%'>" + i18n.get('generic.clan') + "<a class='floatR'" + " class='menuLink' onclick='showWindow(13)'>" + (account.clan ? "[" + account.clan + "]" : "None") + "</a></div>" + "<div class='settName'>" + i18n.get('generic.level') + "<span class='floatR'>" + account.level + "</span></div>" + "<div class='xpBar'><div class='xpBarB' style='width:" + account.levelProg + "%'></div></div>" + "<div class='settName'>" + i18n.get('generic.score') + "<span class='floatR'>" + account.score + "</span></div>" + "<div class='settName'>KR<span class='floatR'>" + account.funds + "KR</span></div>" + "<div class='settName'>" + i18n.get('generic.kills') + "<span class='floatR'>" + account.kills + "</span></div>" + "<div class='settName'>" + i18n.get('generic.deaths') + "<span class='floatR'>" + account.deaths + "</span></div>" + "<div class='settName'>" + i18n.get('generic.kdr') + "<span class='floatR'>" + (account.kills / Math.max(account.deaths, 1)).toFixed(2) + "</span></div>" + "<div class='settName'>" + i18n.get('generic.games.played') + "<span class='floatR'>" + account.games + "</span></div>" + "<div class='settName'>" + i18n.get('generic.games.won') + "<span class='floatR'>" + account.wins + "</span></div>" + "<div class='settName'>W/L<span class='floatR'>" + (account.wins / Math.max(account.games, 1)).toFixed(2) + "</span></div>" + "<div class='settName'>" + i18n.get('generic.timep') + "<span class='floatR'>" + UTILS.getReadableTime(account.timePlayed) + "</span></div>" + "<div style='height:10px'></div>" + "<a class='menuLink' onclick='logoutAcc()'>" + i18n.get('generic.logout') + "</a>" + (clearedSessions ? "" : "<a style='float:right' class='menuLink'" + " onclick='logoutSessions(this)'>" + i18n.get('generic.logout.sessions') + "</a>") : "<input id='accName' type='text' placeholder='" + i18n.get('generic.username') + "' class='accountInput' style='margin-top:0' value='" + (getSavedVal("krunker_username") || "") + "'></input>" + "<input id='accPass' type='password' placeholder='" + i18n.get('generic.password') + "' class='accountInput'></input>" + "<div id='accResp' style='margin-top:10px;color:rgba(0,0,0,0.5);display:none'></div>" + "<div style='margin-top:10px;color:rgba(0,0,0,0.3)'>" + i18n.get('windows.account.recover') + "</div>" + "<div class='accountButton' onclick='registerAcc()'>" + i18n.get('generic.register') + "</div><div class='accountButton' onclick='loginAcc()' style='margin-left: 20px'>" + i18n.get('generic.login') + "</div>";
  }
}, {
  header: i18n.get('windows.class.header'),
  gen: function () {
    var tmpHTML = "<div id='skinList'>";
    for (var i = 0; i < Game.classes.length; ++i) {
      if (Game.config.classes.indexOf(i) >= 0 && !Game.classes[i].hide) {
        tmpHTML += "<div class='skinCard'>" + Game.classes[i].name + "<div class='itemOwn'>" + Game.weapons[Game.classes[i].loadout[0]].name + "</div>" + "<img style='margin-top:6px;image-rendering:pixelated' class='skinImgC' src='." + UTILS.versionifyUrl("/textures/classes/icon_" + i + ".png") + "'/>" + "<div class='selctBtn' onmouseenter='playTick()'" + "onclick='selectClass(" + i + ")'>" + i18n.get('generic.select') + "</div></div>";
      }
    }
    tmpHTML += "</div>";
    return tmpHTML;
  }
}, {
  header: i18n.get('windows.controls.header'),
  gen: function () {
    var tmpHTML = "";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.forward') + "<span class='settText floatR' id='cont0'" + " onclick='changeCont(0)'>" + UTILS.getKeyName(CONTROLS.moveKeys[0]) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.backward') + "<span class='settText floatR' id='cont1'" + " onclick='changeCont(1)'>" + UTILS.getKeyName(CONTROLS.moveKeys[1]) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.left') + "<span class='settText floatR' id='cont2'" + " onclick='changeCont(2)'>" + UTILS.getKeyName(CONTROLS.moveKeys[2]) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.right') + "<span class='settText floatR' id='cont3'" + " onclick='changeCont(3)'>" + UTILS.getKeyName(CONTROLS.moveKeys[3]) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.reload') + "<span class='settText floatR' id='cont8'" + " onclick='changeCont(8)'>" + UTILS.getKeyName(CONTROLS.reloadKey) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.aim') + "<span class='settText floatR' id='cont10'" + " onclick='changeCont(10)'>" + UTILS.getKeyName(CONTROLS.aimKey) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.inspect') + "<span class='settText floatR' id='cont14'" + " onclick='changeCont(14)'>" + UTILS.getKeyName(CONTROLS.inspKey) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.spray') + "<span class='settText floatR' id='cont9'" + " onclick='changeCont(9)'>" + UTILS.getKeyName(CONTROLS.sprayKey) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.jump') + "<span class='settText floatR' id='cont4'" + " onclick='changeCont(4)'>" + UTILS.getKeyName(CONTROLS.jumpKey) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.crouch') + "<span class='settText floatR' id='cont5'" + " onclick='changeCont(5)'>" + UTILS.getKeyName(CONTROLS.crouchKey) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.prim') + "<span class='settText floatR' id='cont13'" + " onclick='changeCont(13)'>" + UTILS.getKeyName(CONTROLS.primKey) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.melee') + "<span class='settText floatR' id='cont6'" + " onclick='changeCont(6)'>" + UTILS.getKeyName(CONTROLS.meleeKey) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.swap') + "<span class='settText floatR' id='cont7'" + " onclick='changeCont(7)'>" + UTILS.getKeyName(CONTROLS.swapKey) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.chat') + "<span class='settText floatR' id='cont11'" + " onclick='changeCont(11)'>" + UTILS.getKeyName(CONTROLS.chatKey) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.voice') + "<span class='settText floatR' id='cont12'" + " onclick='changeCont(12)'>" + UTILS.getKeyName(CONTROLS.voiceKey) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.list') + "<span class='settText floatR' id='cont15'" + " onclick='changeCont(15)'>" + UTILS.getKeyName(CONTROLS.listKey) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.interact') + "<span class='settText floatR' id='cont16'" + " onclick='changeCont(16)'>" + UTILS.getKeyName(CONTROLS.interactKey) + "</span></div>";
    tmpHTML += "<div class='settName'>" + i18n.get('windows.controls.drop') + "<span class='settText floatR' id='cont17'" + " onclick='changeCont(17)'>" + UTILS.getKeyName(CONTROLS.dropKey) + "</span></div>";
    return tmpHTML;
  }
}, {
  header: i18n.get('windows.host.header'),
  presets: {},
  presetLoaded: function (mapN, data) {
    try {
      if (mapN && windows[7].presets[mapN] && data) {
        windows[7].presets[mapN].data = JSON.parse(data);
      } else {
        windows[7].presets[mapN].data = "DEFAULT";
      }
    } catch (e) {
      windows[7].presets[mapN].data = "DEFAULT";
    }
    updateWindow(8);
  },
  gen: function () {
    var tmpHTML = "";
    fillingHostMod = true;
    tmpHTML += "<div class='settName b'>" + i18n.get('windows.host.maps') + "</div>";
    tmpHTML += "<div style='margin-top:5px'>";
    if (!mapToHost) {
      for (var i = 0; i < maps.length; i++) {
        var map = maps[i];
        var switchHTML = "<label class='switch'><input id='gameMap" + i + "' type='checkbox' checked=''><span class='slider'></span></label>";
        tmpHTML += "<div class='settNameSmall' style='margin:0'>" + UTILS.capFirst(map.name) + switchHTML + "</div>";
      }
    }
    tmpHTML += "<div class='settNameSmall' style='margin:0;margin-top:10px'>" + i18n.get('windows.host.cmaps') + " " + "<div style='float:right'>" + (mapToHost ? "<span><i style='color:#eb5656;font-size:30px;" + "vertical-align:-3px;cursor:pointer' onclick='openHostWindow(true)'" + "class='material-icons'>delete</i> </span>" : "") + "<a id='commMap' " + "href='javascript:;' onclick='showWindow(10);' class='menuLink' " + "style='font-size:18px'>" + (mapToHost || i18n.get('generic.select')) + "</a></div></div><br/>";
    if (!mapToHost) {
      tmpHTML += "<div class='settNameSmall' style='margin:0;margin-top:-24px;'>" + i18n.get('windows.host.raw') + "<input id='rawMapData' type='text' class='formInput' " + (custToHost ? "value='" + custToHost + "'" : "placeholder='" + i18n.get('windows.host.raw') + "'") + " autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false'></div><br/>";
    }
    tmpHTML += "</div>";

    // READY BOOL:
    var tmpPre = windows[7].presets[mapToHost];
    var isReady = !mapToHost || tmpPre && tmpPre.data;

    // LOAD PRESET:
    if (isReady) {
      if (tmpPre) {
        tmpPre = tmpPre.data;
      }
      if (tmpPre == "DEFAULT") {
        tmpPre = null;
      }

      // MODES:
      tmpHTML += "<div class='settName b'>" + i18n.get('windows.host.modes') + "</div>";
      tmpHTML += "<div style='margin-top:5px'>";
      for (var i = 0; i < modes.length; i++) {
        var mode = modes[i];
        var check = !tmpPre ? i == 0 : tmpPre.modes && tmpPre.modes.indexOf(i) >= 0;
        var switchHTML = "<label class='switch'><input id='gameMode" + i + "' type='checkbox' " + (check ? "checked" : "") + "><span class='slider'></span></label>";
        tmpHTML += "<div class='settNameSmall' style='margin:0'>" + UTILS.capFirst(mode.name) + switchHTML + "</div>";
      }

      // CLASSES:
      tmpHTML += "<div class='settName b' style='margin-top:20px'>" + i18n.get('windows.host.classes') + "</div>";
      tmpHTML += "<div style='margin-top:5px'>";
      for (var i = 0; i < Game.classes.length; i++) {
        var tClass = Game.classes[i];
        var check = !tmpPre ? true : !tmpPre.classes || tmpPre.classes.indexOf(i) >= 0;
        var switchHTML = "<label class='switch'><input id='gameClass" + i + "' type='checkbox' " + (check ? "checked" : "") + "><span class='slider'></span></label>";
        tmpHTML += "<div class='settNameSmall' style='margin:0'>" + tClass.name + switchHTML + "</div>";
      }

      // SETTINGS:
      tmpHTML += "<div class='settName b' style='margin-top:25px'>" + i18n.get('windows.host.settings') + "</div>";
      for (var i = 0; i < config.serverConfig.length; i++) {
        tmpObj = config.serverConfig[i];
        var name = i18n.get('server.config.' + tmpObj.varN);
        if (tmpObj.bool) {
          var check = tmpObj.def;
          if (tmpPre && tmpPre.settings && tmpPre.settings[tmpObj.varN] != undefined) {
            check = !!tmpPre.settings[tmpObj.varN];
          }
          tmpHTML += "<div class='settNameSmall' style='margin:0;margin-bottom:5px;'>" + name + " <label class='switch'><input type='checkbox' id='customS" + tmpObj.varN + "' " + (check ? "checked" : "") + "><span class='slider'></span></label></div>";
        } else {
          if (tmpObj.input) {
            tmpHTML += "<div class='settNameSmall' style='margin:0;margin-bottom:5px;'>" + name + "<input id='customS" + tmpObj.varN + "' value='" + tmpObj.def + "' type='text'" + "style='border-radius:12px;border:none;background:#eee;padding:6px;padding-bottom:6px;float:right;margin-top:5px;margin-bottom:5px;'" + " autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false'></div>";
          } else {
            var def = tmpObj.def;
            var setMax = account && account.featured ? tmpObj.maxF || tmpObj.max : tmpObj.max;
            if (tmpPre && tmpPre.settings && tmpPre.settings[tmpObj.varN] != undefined) {
              def = tmpPre.settings[tmpObj.varN];
              if (def > setMax) {
                def = setMax;
              }
            }
            tmpHTML += "<div class='settNameSmall' style='margin-left:0'>" + name + "<span class='sliderVal' id='customSet" + i + "'>" + def + "</span><div class='slidecontainer'><input type='range' min='" + tmpObj.min + "' max='" + setMax + "' step='" + tmpObj.step + "' id='customS" + tmpObj.varN + "' value='" + def + "' oninput='updateSliderLabel(" + i + ",this.value)' class='sliderM'></div></div>";
          }
        }
      }
      tmpHTML += "<div class='settNameSmall' style='margin:0'>" + i18n.get('server.config.private') + " <label class='switch'><input" + " id='makePrivate' type='checkbox'><span class='slider'></span></label></div>";
      tmpHTML += "<div id='hostGamePreset' style='text-align:left;margin-top:30px'>" + windows[7].genPresets(true) + "</div>";
    }

    // GRAB MAP CONFIG:
    else {
      if (!windows[7].presets[mapToHost]) {
        windows[7].presets[mapToHost] = {};
        API_CLIENT.getMapPreset(mapToHost, this.presetLoaded);
      }
      tmpHTML += "<div style='color:rgba(0,0,0,0.3)'>" + i18n.get('windows.host.preset.load') + "</div>";
    }
    // HOST ACTION UI:
    if (isReady) {
      tmpHTML += "<div style='text-align:left;margin-top:30px'>";
      tmpHTML += "<div style='color:#919191;margin-bottom:5px' id='hostGameMsg'></div>";
      tmpHTML += "<a class='menuLink' onclick='createPrivateRoom()'>" + i18n.get('windows.host.start') + "</a>";
      tmpHTML += "</div>";
    }

    // FINAL:
    return tmpHTML;
  },
  presetAction: function (action) {
    if (action == 0 && presetSelect.value == "Select") {
      return;
    }
    if (action == 1 && presetName.value == "Select") {
      return;
    }
    if (action == 2 && presetSelect.value == "Select") {
      return;
    }
    let presets = getSavedVal('krk_hostPresets');
    presets = presets ? JSON.parse(presets) : {};
    if (action == 2) {
      if (presets[presetSelect.value]) {
        delete presets[presetSelect.value];
      }
      saveVal('krk_hostPresets', JSON.stringify(presets));
    } else {
      let preset = action == 1 ? {} : presets[presetSelect.value];
      var tmpElm;
      for (var i = 0; i < maps.length; i++) {
        var map = maps[i];
        tmpElm = document.getElementById("gameMap" + i);
        if (action == 1) {
          if (tmpElm.checked != 1) {
            preset["gameMap" + i] = tmpElm.checked;
          }
        } else {
          if ("gameMap" + i in preset) {
            tmpElm.checked = preset["gameMap" + i];
          }
        }
      }
      for (var i = 0; i < modes.length; i++) {
        tmpElm = document.getElementById("gameMode" + i);
        if (action == 1) {
          if (tmpElm.checked != !i) {
            preset["gameMode" + i] = tmpElm.checked;
          }
        } else {
          if ("gameMode" + i in preset) {
            tmpElm.checked = preset["gameMode" + i];
          }
        }
      }
      for (var i = 0; i < Game.classes.length; i++) {
        var tClass = Game.classes[i];
        tmpElm = document.getElementById("gameClass" + i);
        if (action == 1) {
          if (tmpElm.checked != 1) {
            preset["gameClass" + i] = tmpElm.checked;
          }
        } else {
          if ("gameClass" + i in preset) {
            tmpElm.checked = preset["gameClass" + i];
          }
        }
      }
      for (var i = 0; i < config.serverConfig.length; i++) {
        tmpObj = config.serverConfig[i];
        tmpElm = document.getElementById("customS" + tmpObj.varN);
        if (action == 1) {
          if (tmpElm[tmpObj.bool ? 'checked' : 'value'] != tmpObj.def) {
            preset[tmpObj.varN] = tmpElm[tmpObj.bool ? 'checked' : 'value'];
          }
        } else {
          if (tmpObj.varN in preset) {
            if (!tmpObj.bool && !tmpObj.input) {
              document.getElementById("customSet" + i).innerText = preset[tmpObj.varN];
            }
            tmpElm[tmpObj.bool ? 'checked' : 'value'] = preset[tmpObj.varN];
          }
        }
      }
      if (action == 1) {
        if (mapToHost) {
          preset['commMap'] = mapToHost;
        }
        if (modToHost) {
          preset['hostModURL'] = modToHost;
        }
        tmpElm = document.getElementById('rawMapData');
        if (tmpElm.value != "") {
          preset['rawMapData'] = tmpElm.value;
        }
        //tmpElm = document.getElementById('hostModURL');
        //if (tmpElm.value != "") preset['hostModURL'] = tmpElm.value;
        tmpElm = document.getElementById('makePrivate');
        if (tmpElm.checked != 0) {
          preset['makePrivate'] = tmpElm.checked;
        }
        presets[presetName.value || "Preset1"] = preset;
        saveVal('krk_hostPresets', JSON.stringify(presets));
      } else {
        if ('commMap' in preset) {
          document.getElementById('commMap').innerText = mapToHost = preset['commMap'];
        }
        //if ('hostModURL' in preset) document.getElementById('hostModURL').innerText = modToHost = preset['hostModURL'];
        if ('rawMapData' in preset) {
          document.getElementById('rawMapData').value = preset['rawMapData'];
        }
        //if ('hostModURL' in preset) document.getElementById('hostModURL').value = preset['hostModURL'];
        if ('makePrivate' in preset) {
          document.getElementById('makePrivate').checked = preset['makePrivate'];
        }
      }
    }
    windows[7].genPresets();
  },
  genPresets: function (init = false) {
    let presets = getSavedVal('krk_hostPresets');
    presets = presets ? JSON.parse(presets) : {};
    var tmpHTML = "<div class='settName b' style='margin-top:25px'>" + i18n.get('windows.host.preset') + "</div>";
    tmpHTML += "<span class='settNameSmall' style='margin:0;margin-bottom:5px;'>" + "<input id='presetName' type='text' class='formInput' placeholder='" + i18n.get('windows.host.preset.name') + "'" + " autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false'" + " style='border:none;background:#eee;padding:6px;padding-bottom:6px;float:left;margin-top:5px;margin-bottom:5px;'>" + "<select id='presetSelect' style='border-radius:12px;margin-left:10px;border:none;background:#eee;padding:6px;padding-bottom:6px;margin-top:5px;margin-bottom:5px;'>" + "<option selected>Select</option>";
    for (let key in presets) {
      let preset = presets[key];
      tmpHTML += "<option>" + key + "</option>";
    }
    tmpHTML += "</select>";
    tmpHTML += "<div class='hostPresetBtn' onclick='windows[7].presetAction(2)'>" + i18n.get('generic.delete') + "</div>" + "<div class='hostPresetBtn' onclick='windows[7].presetAction(1)'>" + i18n.get('generic.save') + "</div>" + "<div class='hostPresetBtn' onclick='windows[7].presetAction(0)'>" + i18n.get('generic.load') + "</div></span>";
    if (init) {
      return tmpHTML;
    } else {
      hostGamePreset.innerHTML = tmpHTML;
    }
  }
}, {
  header: i18n.get('windows.spray.header'),
  gen: function () {
    var tmpHTML = "<div id='skinList'>";
    for (var i = 0; i < Game.sprays.length; ++i) {
      tmpHTML += "<div class='skinCard'>" + Game.sprays[i].name + "<div class='itemOwn'>" + i18n.get('windows.spray.default') + "</div>" + "<img style='margin-top:10px;image-rendering:pixelated' class='skinImgC' src='." + UTILS.versionifyUrl("/textures/sprays/" + i + ".png") + "'/>" + "<div class='selctBtn' onmouseenter='playTick()'" + "onclick='selectSpray(" + i + ")'>" + i18n.get('generic.select') + "</div></div>";
    }
    tmpHTML += "</div>";
    return tmpHTML;
  }
}, {
  header: i18n.get('windows.maps.header'),
  searchMaps: function () {
    searchResults.innerHTML = i18n.get('generic.loading');
    API_CLIENT.searchMap(mpSrch.value, searchResp);
  },
  searchResp: function (data) {
    var tmpHTML = "";
    if (!data.length) {
      tmpHTML = i18n.get('windows.maps.none');
    } else {
      tmpHTML += "<div style='height:10px'></div>";
      tmpHTML += getCardsList(data, "map");
    }
    if (document.getElementById("searchResults")) {
      document.getElementById("searchResults").innerHTML = tmpHTML;
    }
  },
  mapsLoaded: function (data, index, error) {
    if (mapList) {
      if (!data || !data.length) {
        mapList.innerHTML = i18n.get('windows.maps.none');
        this.listData[index] = null;
      } else {
        if (error) {
          mapList.innerHTML = error;
          this.listData[index] = null;
        } else {
          this.listData[index].dat = getCardsList(data, "map");
          updateWindow(10);
        }
      }
    }
  },
  tabIndex: 0,
  listData: {},
  switchTab: function (index) {
    if (this.tabIndex != index) {
      this.tabIndex = index;
      updateWindow(10);
    }
  },
  gen: function () {
    var tmpTab = config.mapTabs[this.tabIndex];
    var tabHTML = "";
    for (var i = 0; i < config.mapTabs.length; ++i) {
      tabHTML += "<div class='menuTab" + (this.tabIndex == i ? " tabA" : "") + "' onclick='windows[9].switchTab(" + i + ")'>" + config.mapTabs[i].n + "</div>";
    }
    var tmpDat = "";
    if (tmpTab.search) {
      tmpDat = "<input style='margin-top:10px' type='text' id='mpSrch' " + "class='smlInput' placeholder='" + i18n.get('windows.maps.name') + "' /><a " + "class='menuLink' style='margin-left:20px' " + "onclick='windows[9].searchMaps()'>" + i18n.get('generic.search') + "</a>" + "<div style='color:rgba(0,0,0,0.5);margin-top:5px' id='searchResults'></div>";
    } else {
      if (this.listData[this.tabIndex]) {
        tmpDat = this.listData[this.tabIndex].dat || i18n.get('generic.loading');
      } else {
        tmpDat = i18n.get('generic.loading');
        this.listData[this.tabIndex] = {};
        API_CLIENT.listMaps(this.tabIndex, account ? account.id : null, mapListResp);
      }
    }
    return "<a href='./editor.html' class='menuLink'>" + i18n.get('windows.maps.editor') + "</a> | " + "<a href='javascript:;' onclick='showWindow(11)' class='menuLink'>" + i18n.get('windows.maps.publish') + "</a>" + "<a href='https://discord.gg/Kfypyp5' class='menuLink' style='float:right'>" + i18n.get('windows.maps.community') + "</a><br/>" + "<div style='margin-top:25px;margin-bottom:15px'>" + tabHTML + "</div><div style='color:rgba(0,0,0,0.3)' id='mapList'>" + tmpDat + "</div>";
  }
}, {
  header: i18n.get('windows.publish.map.header'),
  gen: function () {
    var tmpHTML = account ? "<div style='margin-top:-8px;margin-bottom:10px'" + " class='setHed'>" + i18n.get('windows.publish.map.header') + "</div>" + "<div style='color:rgba(0,0,0,0.4);font-size:18px'>" + "<input onclick='selectMapThumb()' type='button' id='thumbBtn' style='cursor:pointer' value='Select' />" + "<input id='mapThumb' type='file' accept='image/*' style='width:1px;visibility:hidden;'" + " onchange='updateMapThumb()'><span style='color:rgba(0,0,0,0.4);margin-left:10px'" + " id='mapThumbName'>" + i18n.get('windows.publish.map.thumbnail') + "</span></div>" + "<input id='mapDataNew' type='text' placeholder='" + i18n.get('windows.publish.map.paste') + "' class='mapInput' " + "autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false'/>" + "<div id='mapUpResp' style='color:rgba(0,0,0,0.3);margin-top:8px;margin-bottom:5px'></div>" + "<div class='mapLoadButton' style='margin-top:6px' onclick='uploadCustomMap()'>" + i18n.get('windows.publish.map.update') + "</div>" : "<div style='color:rgba(0,0,0,0.3);margin-top:20px'><a href='javascript:;'" + " onclick='showWindow(5);' class='menuLink'>" + i18n.get('windows.publish.map.login') + "</div>";
    return tmpHTML;
  }
}, {
  header: i18n.get('windows.theatre.header'),
  gen: function () {
    var tmpHTML = "";
    return tmpHTML;
  }
}, {
  header: i18n.get('windows.clans.header'),
  clanData: null,
  kickReq: function (id) {
    io.send("cln", 5, id);
    if (this.clanData && this.clanData.members) {
      for (var i = this.clanData.members.length - 1; i >= 0; --i) {
        if (this.clanData.members[i].player_id == id) {
          this.clanData.members.splice(i, 1);
        }
      }
      updateWindow(13);
    }
  },
  sendReq: function (ind, vl) {
    var tmpEl = document.getElementById("clanErr");
    if (tmpEl) {
      tmpEl.style.color = "rgba(0,0,0,0.6)";
      tmpEl.innerHTML = i18n.get('generic.loading');
    }
    tmpEl = document.getElementById("clanInp" + ind);
    var tmpVl = tmpEl ? tmpEl.value : null;
    io.send("cln", ind, vl || tmpVl || 1);
  },
  updReq: function (index, playerID, val) {
    io.send("clnR", playerID, val);
    if (this.clanData.members && val == 1) {
      this.clanData.members.push({
        player_name: this.clanData.requests[index].player_name
      });
    }
    this.clanData.requests.splice(index, 1);
    updateWindow(13);
  },
  delReq: function () {
    this.clanData = null;
    if (account) {
      account.clan = null;
    }
    io.send("cln", 4, 1);
    showWindow(5);
  },
  resp: function (err, data, worked) {
    var tmpEl = document.getElementById("clanErr");
    if (err && tmpEl) {
      tmpEl.style.color = worked ? "rgba(0,0,0,0.6)" : "rgba(255,0,0,0.6)";
      tmpEl.innerHTML = err;
    } else {
      if (data) {
        if (account) {
          account.clan = data.clan_name;
        }
        this.clanData = data;
        updateWindow(13);
      }
    }
  },
  gen: function () {
    var membersHTML = "";
    var requestHTML = "";
    if (this.clanData && this.clanData.members) {
      var canKick = account && this.clanData.clan_playerid == account.id;
      membersHTML = "<div class='setHed' style='margin-top:10px'>" + i18n.get('windows.clans.members', this.clanData.members.length) + "</div>";
      for (var i = 0; i < this.clanData.members.length; ++i) {
        membersHTML += "<div class='settName'><a target='_blank'" + "href='/social.html?p=profile&q=" + this.clanData.members[i].player_name + "'>" + this.clanData.members[i].player_name + "</a>" + (canKick && this.clanData.clan_playerid != this.clanData.members[i].player_id ? "<i style='font-size:40px;float:right;color:rgba(255,0,0,0.6)' " + " class='material-icons h' onclick='windows[12].kickReq(" + this.clanData.members[i].player_id + ")'>clear</i>" : "") + "</div>";
      }
    }
    if (this.clanData && this.clanData.requests) {
      requestHTML = "<div class='setHed' style='margin-top:10px'>" + i18n.get('windows.clans.requests') + "</div>";
      for (var i = 0; i < this.clanData.requests.length; ++i) {
        requestHTML += "<div class='settName'><a target='_blank'" + " href='/social.html?p=profile&q=" + this.clanData.requests[i].player_name + "'>" + this.clanData.requests[i].player_name + "</a>" + "<span style='float:right'>" + "<i style='font-size:40px;color:rgba(255,0,0,0.6)' " + " class='material-icons h' onclick='windows[12].updReq(" + i + "," + this.clanData.requests[i].cr_playerid + ", 0)'>clear</i>" + "<i style='font-size:40px;color:rgba(0,255,0,0.6);" + "margin-left:10px' class='material-icons h' " + "onclick='windows[12].updReq(" + i + "," + this.clanData.requests[i].cr_playerid + ", 1)'>done</i></span></div>";
      }
      if (!this.clanData.requests.length) {
        requestHTML += "<div style='color:rgba(0,0,0,0.4)'>" + i18n.get('windows.clans.requests.none') + "</div>";
      }
    }
    var tmpHTML = account ? account.clan ?
    // CLAN PAGE:
    "<div class='setHed' style='margin-top:0px'>" + i18n.get('windows.clans.page', account.clan) + "<a style='float:right' href='javascript:;' onclick='windows[12].delReq()' class='menuLink'>" + (this.clanData ? account && this.clanData.clan_playerid == account.id ? i18n.get('generic.delete') : i18n.get('generic.leave') : "") + "</a></div><div id='clanErr' style='margin-top:0px;color:rgba(0,0,0,0.5)'>" + (this.clanData ? "<div class='settName'>" + i18n.get('generic.level') + "<span class='floatR'>" + Math.max(1, Math.floor(config.rankVar * Math.sqrt(this.clanData.clan_score || 0))) + "</span></div>" + ("<div class='settName'>" + i18n.get('generic.score') + "<span class='floatR'>" + (this.clanData.clan_score || 0) + "</span></div>") + membersHTML + requestHTML : i18n.get('generic.loading')) + "</div>" :
    // CREATE/JOIN CLAN:
    "<div class='setHed' style='margin-top:-5px'>" + i18n.get('windows.clans.create') + "</div>" + "<input id='clanInp1' type='text' class='smlInput' maxlength='4' placeholder='" + i18n.get('windows.clans.name') + "' /><a " + "class='menuLink' style='margin-left:20px' onclick='windows[12].sendReq(1)'>" + i18n.get('generic.create') + "</a>" + "<div style='margin-top:0px' class='setHed'>" + i18n.get('windows.clans.join') + " " + "<a href='./social.html?q=clan' class='menuLink'" + " style='margin-top:10px;display:inline-block'>" + i18n.get('windows.clans.view') + "</a></div>" + "<input id='clanInp2' type='text' class='smlInput' maxlength='4' placeholder='" + i18n.get('windows.clans.name') + "' /><a " + "class='menuLink' style='margin-left:20px' onclick='windows[12].sendReq(2)'>" + i18n.get('generic.submit') + "</a>" + "<div id='clanErr' style='margin-top:10px'></div>"

    // NOT LOGGED IN:
    : "<div style='color:rgba(0,0,0,0.3);margin-top:20px'><a href='javascript:;'" + " onclick='showWindow(5);' class='menuLink'>" + i18n.get('windows.clans.login') + "</div>";
    if (account && account.clan && !this.clanData) {
      this.sendReq(3);
    }
    return tmpHTML;
  }
}, {
  header: i18n.get('windows.store.header'),
  gen: function () {
    // PLAY SOUND:
    SOUND.play('store', 0.4);

    // WHEELS:
    var wheelHTML = "";
    for (var i = 0; i < Game.store.wheels.length; ++i) {
      tmpObj = Game.store.wheels[i];
      if (account && account.following == 0 && tmpObj.free && account.level >= tmpObj.minLvl || !tmpObj.free) {
        wheelHTML += "<div><a href='javascript:;' class='menuLink' onclick='prizeWheel(" + i + ")'>" + i18n.get('windows.store.spin', tmpObj.name) + "</a> " + (tmpObj.lab ? "<span style='color:#fff;margin-left:5px;background-color:" + tmpObj.lab.col + ";font-size:15px;padding:3px;padding-left:8px;padding-right:8px'> " + tmpObj.lab.nm + " </span>" : "") + "<span style='float:right;color:rgba(0,0,0,0.3)'>" + (tmpObj.priceT || tmpObj.price) + "<span style='color:rgba(0,0,0,0.6)'> " + (tmpObj.priceT ? "" : "KR") + "</span></span></div>";
      }
    }

    // PURCHASES:
    var purchaseHTML = "<div style='color:rgba(0,0,0,0.3);font-size:19px;margin-bottom:20px'>" + i18n.get('windows.store.agree', "<a href='./docs/terms.txt'>") + "</a></div>";
    for (var i = 0; i < Game.store.purchases.length; ++i) {
      tmpObj = Game.store.purchases[i];
      purchaseHTML += "<div><a href='javascript:;' class='menuLink' onclick='showPurchase(" + i + ")'>" + tmpObj.val + " KR </a><span style='float:right;color:rgba(0,0,0,0.3)'>" + (tmpObj.tag ? "<span style='color:#fff;font-size:15px;padding:10px;padding-top:2px;" + "vertical-align:middle;padding-bottom:2px;background-color:" + tmpObj.tagCol + "'>" + tmpObj.tag + "</span> " : "") + tmpObj.price + "<span style='color:rgba(0,0,0,0.6)'> USD</span></span></div>";
    }
    var buyHTML = "<div style='height:10px;'>" + "</div><b style='font-size:26px;margin-bottom:10px'>" + i18n.get('windows.store.purchase') + "</b>" + purchaseHTML;

    // FINALIZE:
    var tmpHTML = account ? "<b style='font-size:26px'>" + i18n.get('windows.store.market') + "</b>" + "<div style='color:rgba(0,0,0,0.3);margin-bottom:10px'>" + i18n.get('windows.store.buy') + " <a href='javascript:;' onclick='window.open(" + "`/social.html?p=market`)'>" + i18n.get('windows.store.market2') + "</a></div>" + "<b style='font-size:26px'>" + i18n.get('windows.store.wheels') + "</b>" + "<div style='color:rgba(0,0,0,0.3);margin-bottom:10px'>" + i18n.get('windows.store.unlock') + "</div>" + wheelHTML + buyHTML + "<div style='float:right;margin-top:10px'>" + i18n.get('windows.store.amount', account.funds) + "</div>" : "<div style='color:rgba(0,0,0,0.3)'><a href='javascript:;'" + " onclick='showWindow(5);' class='menuLink'>" + i18n.get('windows.store.login') + "</div>";
    return tmpHTML;
  }
}, {
  header: i18n.get('windows.skin.header'),
  gen: function () {
    var tmpHTML = "<div id='skinList'>" + "<div class='skinCard'>" + i18n.get('generic.default') + "" + "<div class='itemOwn'>by Krunker.io</div>" + "<img class='skinImg' src='." + UTILS.versionifyUrl("/textures/previews/weapons/" + Game.weapons[activeSkinSel].src + ".png") + "' style='margin-top:-10px'>" + "<div class='selctBtn' onmouseenter='playTick()' style='margin-top:-40px'" + " onclick='selectSkin(-1," + activeSkinSel + ")'>" + i18n.get('generic.select') + "</div></div>";
    if (account || Game.singlePlayer) {
      var tmpSkins = (Game.singlePlayer ? Object.keys(Game.store.skins).map(x => x = {
        ind: parseInt(x),
        cnt: 1
      }) : account.skins).slice().sort(function (a, b) {
        return (b.ind == null || !Game.store.skins[b.ind] ? 0 : Game.store.skins[b.ind].rarity) - (a.ind == null || !Game.store.skins[a.ind] ? 0 : Game.store.skins[a.ind].rarity);
      });
      for (var i = 0; i < tmpSkins.length; ++i) {
        tmpObj = Game.store.skins[tmpSkins[i].ind];
        if (tmpObj && !tmpObj.type && tmpObj.weapon == activeSkinSel + 1) {
          tmpHTML += "<div class='skinCard' style='color:" + Game.store.rarities[tmpObj.rarity].color + "'>" + "<div class='itemCnt' data-badge='x" + tmpSkins[i].cnt + "'></div>" + tmpObj.name + "<div class='itemOwn'>by " + (tmpObj.creator || "Krunker.io") + "</div>" + "<img style='margin-top:-10px' class='skinImg" + (tmpObj.type ? "C" : "") + "' src='." + UTILS.versionifyUrl("/textures/previews/" + (tmpObj.type ? "cosmetics/" + tmpObj.type + "_" + tmpObj.id : "weapons/weapon_" + tmpObj.weapon + "_" + (tmpObj.pat != undefined ? "c" + tmpObj.pat : tmpObj.id)) + ".png") + "'/>" + "<div class='selctBtn' style='margin-top:-40px' onmouseenter='playTick()'" + "onclick='selectSkin(" + tmpSkins[i].ind + "," + (tmpObj.weapon - 1) + ")'>" + i18n.get('generic.select') + "</div></div>";
        }
      }
    }
    tmpHTML += "</div>";
    return tmpHTML;
  }
}, {
  header: i18n.get('windows.hat.header'),
  gen: function () {
    return getItemsList("selectHat", 1);
  }
}, {
  header: i18n.get('windows.back.header'),
  gen: function () {
    return getItemsList("selectBack", 2);
  }
}, {
  header: i18n.get('windows.mods.community.header'),
  modData: null,
  searchMods: function () {
    searchResults.innerHTML = i18n.get('generic.loading');
    API_CLIENT.searchMod(moSrch.value, searchResp);
  },
  searchResp: function (data) {
    var tmpHTML = "";
    if (!data.length) {
      tmpHTML = i18n.get('windows.mods.community.none');
    } else {
      tmpHTML += "<div style='height:10px'></div>";
      tmpHTML += getCardsList(data, "mod");
    }
    if (document.getElementById("searchResults")) {
      document.getElementById("searchResults").innerHTML = tmpHTML;
    }
  },
  resp: function (data, error) {
    if (data && data.length) {
      this.modData = data;
      this.modData.loaded = true;
      updateWindow(18);
    } else {
      this.modData = null;
      var tmpEl = document.getElementById("modsList");
      if (tmpEl) {
        tmpEl.innerHTML = i18n.get('windows.mods.community.none');
      }
    }
  },
  gen: function () {
    var tmpHTML = "";
    if (this.modData && this.modData.loaded) {
      tmpHTML = "<div style='margin-bottom:-5px;margin-top:-5px;'>" + i18n.get('generic.search') + "</div>" + "<input type='text' id='moSrch' class='smlInput' placeholder='" + i18n.get('windows.mods.community.name') + "' /><a " + "class='menuLink' style='margin-left:20px' " + "onclick='windows[17].searchMods()'>" + i18n.get('generic.search') + "</a>" + "<div style='color:rgba(0,0,0,0.5);margin-top:5px' id='searchResults'></div>";
      var mapHeaders = ["<div style='margin-bottom:5px;margin-top:15px'>" + i18n.get('windows.mods.community.hot') + "</div>", "<div style='margin-top:20px;margin-bottom:5px'>" + i18n.get('windows.mods.community.new') + "</div>", "<div style='margin-top:20px;margin-bottom:5px'>" + i18n.get('windows.mods.community.fav') + "</div>"];
      for (var i = 0; i < this.modData.length; ++i) {
        if (this.modData[i]) {
          if (this.modData[i].length) {
            tmpHTML += mapHeaders[i];
          }
          tmpHTML += getCardsList(this.modData[i], "mod");
        }
      }
    } else {
      tmpHTML = i18n.get('generic.loading');
      if (!this.modData) {
        this.modData = {};
        API_CLIENT.listMods(account ? account.id : null, modListResp);
      }
    }
    return "<div style='color:rgba(0,0,0,0.3)' id='modsList'>" + tmpHTML + "</div>";
  }
}, {
  header: i18n.get('windows.publish.mod.header'),
  gen: function () {
    return account ? "<div style='margin-top:0px' class='setHed'>" + i18n.get('windows.publish.mod.header') + "</div>" + "<div style='color:rgba(0,0,0,0.4);font-size:18px'>" + "<input onclick='selectModThumb()' type='button' id='thumbBtn' style='cursor:pointer' value='Select' />" + "<input id='modThumb' type='file' accept='image/*' style='width:1px;visibility:hidden;'" + " onchange='updateModThumb()'><span style='color:rgba(0,0,0,0.4);margin-left:10px'" + " id='modThumbName'>" + i18n.get('windows.publish.mod.thumbnail') + "</span></div>" + "<input id='pubModName' type='text' placeholder='" + i18n.get('windows.publish.mod.name') + "' class='mapInput' " + "autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false'/>" + "<input id='pubModURL' type='text' placeholder='" + i18n.get('windows.publish.mod.paste') + "' class='mapInput' " + "autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false'/>" + "<div id='modUpResp' style='color:rgba(0,0,0,0.3);margin-top:8px'></div>" + "<div class='mapLoadButton' style='margin-top:6px' onclick='uploadCustomMod()'>" + i18n.get('windows.publish.mod.update') + "</div>" : "<div style='color:rgba(0,0,0,0.3);'><a href='javascript:;'" + " onclick='showWindow(5)' class='menuLink'>" + i18n.get('windows.publish.mod.login') + "</div>";
  }
}, {
  header: i18n.get('windows.secondary.header'),
  gen: function () {
    var tmpHTML = "<div id='skinList'>";
    for (var i = 0; i < Game.weapons.length; ++i) {
      tmpObj = Game.weapons[i];
      if (tmpObj && tmpObj.secondary) {
        var unlocked = !tmpObj.minRec || account && account.level >= tmpObj.minRec || Game.singlePlayer;
        tmpHTML += "<div class='skinCard'>" + tmpObj.name + "<div class='itemOwn'>" + (tmpObj.minRec ? i18n.get('windows.secondary.' + (unlocked ? 'unlocked' : 'req'), tmpObj.minRec) : i18n.get('generic.default')) + "</div>" + "<img style='margin-top:10px;image-rendering:pixelated' class='skinImgC' src='." + UTILS.versionifyUrl("/img/prev/" + tmpObj.src + ".png") + "'/>" + "<div class='selctBtn' onmouseenter='playTick()'" + (unlocked ? "onclick='selectSecondary(" + i + ")" : "") + "'>" + i18n.get('generic.select') + "</div></div>";
      }
    }
    tmpHTML += "</div>";
    return tmpHTML;
  }
}, {
  header: i18n.get('windows.advertise.header'),
  gen: function () {
    var tmpHTML = "<div class='setHed' style='margin-top:0'>Advertise in Game</div>" + "<div style='color:rgba(0,0,0,0.4)'>On krunker.io you have the ability to place advertisements in game.<div style='height:10px'></div> " + "The game features several <b>3d Billboards</b> that yield a very high impression rate & that are <b>not affected by ad blockers</b>.</div>" + "<img src='./img/ad_1.png' style='width:100%;margin-top:10px'/>" + "<div style='color:rgba(0,0,0,0.4);margin-top:10px'><b>Daily Users:</b> ~ 2,000,000<br/>" + "<b>Registered Accounts:</b> ~ 5,000,000<br/>" + "<b>Daily Impressions:</b> ~ 6,500,000<br/>" + "<b>Peak CCU:</b> ~ 28,000<br/>" + "<b>Session Time avg:</b> 14 minutes<br/>" + "<div style='height:5px'></div>" + "<i style='color:rgba(0,0,0,0.2)'>as of 16/06/2019</i>" + "</div><div style='margin-top:10px;color:rgba(0,0,0,0.4)'>For inquiries contact <a>info@yendis.ch</a></div>";
    return tmpHTML;
  }
}, {
  header: "Social",
  gen: function () {
    return "TODO";
  }
}, {
  header: i18n.get('windows.players.header'),
  gen: function () {
    var tmpHTML = "<div style='margin-top:0px' class='setHed'><center>" + (Game.players.list.length ? i18n.get('windows.players.header') + "<hr>" : i18n.get('windows.players.none')) + "</div>";
    tmpHTML += "<div style='background-color:gainsboro;border-radius: 12px;'>";
    if (player) {
      tmpHTML += "<div><span class='settNameSmall'>" + (youHost ? "<i class='material-icons' style='font-size:25px'>stars</i>" : "") + player.name + (player.clan ? "<span style='color:" + (config.verClans.indexOf(player.clan) >= 0 ? "#fbc02d" : "#353535") + "'> [" + player.clan + "]</span>" : "") + "</span>" + (account && account.developer ? "<span style='float:right'>" + "<span onmouseenter='playTick()' class='punishButton kill' onclick='punishPlayer(\"" + player.id + "\", 2)'>Kill</span>" + "<span onmouseenter='playTick()' class='punishButton tpall' onclick='punishPlayer(null, 5)'>TPAll</span>" + "</span>" : "") + "</div>";
    }
    for (let p of Game.players.list.filter(x => !x.isYou)) {
      tmpHTML += "<div><span class='settNameSmall'>" + (hostId == p.id ? "<i class='material-icons' style='font-size:25px'>stars</i>" : "") + "<a target='_blank' class='" + (p.isHacker ? 'red' : 'grey') + "' href='/social.html?p=profile&q=" + p.name + "'>" + p.name + (p.clan ? "<span style='color:" + (config.verClans.indexOf(p.clan) >= 0 ? "#fbc02d" : "#353535") + "'> [" + p.clan + "]</span>" : "") + "</a></span>" + (youHost || account && account.developer ? "<span style='float:right'>" + "<span onmouseenter='playTick()' class='punishButton kick' onclick='punishPlayer(\"" + p.id + "\", 0)'>Kick</span>" + "<span onmouseenter='playTick()' class='punishButton ban' onclick='punishPlayer(\"" + p.id + "\", 1)'>Ban</span>" + (account && account.developer ? "<span onmouseenter='playTick()' class='punishButton kill' onclick='punishPlayer(\"" + p.id + "\", 2)'>Kill</span>" : "") + (account && account.developer ? "<span onmouseenter='playTick()' class='punishButton tp2' onclick='punishPlayer(\"" + p.id + "\", 3)'>TP2</span>" : "") + (account && account.developer ? "<span onmouseenter='playTick()' class='punishButton tpme' onclick='punishPlayer(\"" + p.id + "\", 4)'>TPME</span>" : "") + "</span>" : "") + "</div>";
    }
    tmpHTML += "</div>";
    return tmpHTML;
  }
}, {
  header: i18n.get('windows.join.header'),
  gen: function () {
    return `<input id='gameURL' type='text' placeholder='${i18n.get('windows.join.code')}' class='accountInput' style='margin-top:0' value=''></input>
          <div class='accountButton' onclick='joinGame()', style='width:100%'>${i18n.get('windows.join.header')}</div>`;
  }
}, {
  header: i18n.get('windows.client.header'),
  gen: function () {
    var tmpHTML = "<div><ul style='padding:0;display:flex;list-style:none;text-align:center;margin:0;margin-top:-10px'>" + "<li style='display: flex;flex-basis:200px;-webkit-box-flex:1;flex-grow:1;margin-right:10px'>" + "<a href='//client.krunker.io/setup.exe' style='display:block;width:100%;padding-top:1em;'>" + "<img src ='./img/windows.png' style='width:80px;height:80px;display:block;margin:0 auto 10px;'>" + i18n.get('windows.client.windows') + "</a></li>" + "<li style='display: flex;flex-basis:200px;-webkit-box-flex:1;flex-grow:1;'>" + "<a href='//client.krunker.io/setup.dmg' style='display: block;width: 100%;padding-top:1em;'>" + "<img src ='./img/mac.png' style='width:80px;height:80px;display:block;margin:0 auto 10px;'>" + i18n.get('windows.client.mac') + "</a></li>" + "<li style='display: flex;flex-basis:200px;-webkit-box-flex:1;flex-grow:1;'>" + "<a href='//client.krunker.io/setup.AppImage' style='display: block;width: 100%;padding-top:1em;'>" + "<img src ='./img/linux.png' style='width:80px;height:80px;display:block;margin:0 auto 10px;'>" + i18n.get('windows.client.linux') + "</a></li>" + "</ul></div>";
    return tmpHTML;
  }
}, {
  header: i18n.get('windows.melee.header'),
  gen: function () {
    return getItemsList("selectMelee", 3);
  }
}];
function getCardsList(data, strng) {
  var tmpHTML = "";
  var clickFunc = strng == "map" ? "selectHostMap" : "loadUserMod";
  for (var x = 0; x < data.length; ++x) {
    tmpHTML += "<div class='mapListItem'>" + "<img class='mapListThumb' src='" + (data[x][strng + "_image"] ? data[x][strng + "_image"] : "./img/noimg.png") + "' onclick='" + clickFunc + "(&quot;" + data[x][strng + "_name"] + "&quot;," + "&quot;" + data[x].mod_url + "&quot;,&quot;" + data[x].mod_id + "&quot;)'/>" + "<div style='margin-top:-3px'><a href='javascript:;'" + " onclick='" + clickFunc + "(&quot;" + data[x][strng + "_name"] + "&quot;," + "&quot;" + data[x].mod_url + "&quot;,&quot;" + data[x].mod_id + "&quot;)'/>" + data[x][strng + "_name"] + "</a></div><div style='display: flex'><span style='color:rgba(0,0,0,0.2);font-size:15px'> by " + "<a target='_blank' class='grey' href='/social.html?p=profile&q=" + data[x].creatorname + "'>" + data[x].creatorname + "</a></span>" + "<div style='font-size:15px;text-align:right;flex-grow:1'>" + data[x][strng + "_votes"] + "</div></div></div>";
  }
  return tmpHTML;
}
function getItemsList(funcN, typ) {
  var tmpHTML = "<div id='skinList'>" + "<div class='skinCard'>" + (typ == 3 ? "Combat Knife" : i18n.get('generic.none')) + "<div class='itemOwn'>" + i18n.get('generic.default') + "</div>" + "<img class='skinImgC' src='." + UTILS.versionifyUrl("/textures/previews/cosmetics/" + typ + "_default.png") + "'>" + "<div class='selctBtn' onmouseenter='playTick()' onclick='" + funcN + "(-1)'>" + i18n.get('generic.select') + "</div></div>";
  if (account || Game.singlePlayer) {
    var tmpHats = (Game.singlePlayer ? Object.keys(Game.store.skins).map(x => x = {
      ind: parseInt(x),
      cnt: 1
    }) : account.skins).slice().sort(function (a, b) {
      return (b.ind == null || !Game.store.skins[b.ind] ? 0 : Game.store.skins[b.ind].rarity) - (a.ind == null || !Game.store.skins[a.ind] ? 0 : Game.store.skins[a.ind].rarity);
    });
    for (var i = 0; i < tmpHats.length; ++i) {
      tmpObj = Game.store.skins[tmpHats[i].ind];
      if (tmpObj && tmpObj.type == typ) {
        tmpHTML += "<div class='skinCard' style='color:" + Game.store.rarities[tmpObj.rarity].color + "'>" + "<div class='itemCnt' data-badge='x" + tmpHats[i].cnt + "'></div>" + tmpObj.name + "<div class='itemOwn'>by " + (tmpObj.creator || "Krunker.io") + "</div>" + "<img class='skinImg" + (tmpObj.type ? "C" : "") + "' src='." + UTILS.getPreview(tmpObj, Game.store) + "'/>" + "<div class='selctBtn' onmouseenter='playTick()'" + "onclick='" + funcN + "(" + tmpHats[i].ind + ")'>" + i18n.get('generic.select') + "</div></div>";
      }
    }
  }
  tmpHTML += "</div>";
  return tmpHTML;
}
;
for (var i = 0; i < windows.length; ++i) {
  windows[i].html = "";
}
var lastWindow = 0;
window.updateWindow = function (index, any) {
  if (windowHolder.style.display == "block") {
    if (lastWindow == index && index != null) {
      showWindow(index, true);
    } else {
      if (any) {
        showWindow(lastWindow, true);
      }
    }
  }
};
window.showWindow = function (index, force) {
  window.idleTimer = 0;
  if (!force && (!index || windowHolder.style.display == "block" && index == lastWindow)) {
    UI.toggleWindow(false, CONTROLS.gamepad.connected);
    CONTROLS.inputChanger = null;
  } else {
    UI.toggleMenu(true);
    if (windows[index - 1].gen) {
      menuWindow.innerHTML = windows[index - 1].gen();
    } else {
      menuWindow.innerHTML = windows[index - 1].html;
    }
    lastWindow = index;
    windowHeader.innerHTML = windows[index - 1].header;
    UI.toggleWindow(true, CONTROLS.gamepad.connected);
  }
};
window.playTick = function () {
  SOUND.play('tick_0', 0.2);
};
window.copyInviteLink = function () {
  UTILS.copyToClipboard(`https://${location.host}/?game=${connectedInstanceId}`);
  inviteButton.innerText = i18n.get('menu.btn.invite.clicked');
  setTimeout(() => inviteButton.innerText = i18n.get('menu.btn.invite'), 1250);
};
window.punishPlayer = function (id, action) {
  if ((action > 2 || action < 0) && !(account && account.developer)) {
    return;
  }
  let player = Game.players.list.find(x => x.id == id);
  if (player) {
    io.send("pnh", action, player.id);
  } else {
    if (action > 4) {
      io.send("pnh", action, null);
    }
  }
};

// PRIZE WHEEL:
var spinCanvas = spinWindow;
var spinContext = spinCanvas.getContext("2d");
var wheelPad = 0.95;
var spinBtnScl = 0.6;
var spinPreviewSize = 0.3;
var winItem = null;
var isSpinning = false;
var spinWhlMlt = 0;
var spinVal = 0;
var spinIndex = 0;
var endAnimVal = 0;
var endAnimTarget = 0;
var spinnerScene;
var spinnerPreview;
var spinCamX = 30;
var spinCamOff = 300;
var canSpin = true;
var bobAnim = 0;
var tickCounter = 0;
var spinWheel;
var spinnerCam = new THREE.PerspectiveCamera(45, 1, 0.1, 100);
var spinnerRender = new THREE.WebGLRenderer({
  precision: "mediump",
  antialias: false,
  alpha: true
});
spinnerRender.setPixelRatio(window.devicePixelRatio * 0.6);
spinnerCam.position.y = 10;
spinItemCanvas.appendChild(spinnerRender.domElement);
window.prizeWheel = function (index) {
  spinWheel = Game.store.wheels[index];
  if (spinWheel.openURL) {
    window.openURL(config.followURLS[UTILS.randInt(0, config.followURLS.length - 1)]);
  }
  spinIndex = index;
  showWindow(0);
  spinWhlMlt = 0;
  canSpin = !isSpinning;
  spinVal = 0;
  tickCounter = 0;
  spinRotation = 0;
  endAnimVal = endAnimTarget = 0;
  UI.toggleMenuHider(false);
  spinItem.style.display = "none";
  spinItemName.style.display = "none";
  spinUI.style.display = "block";
  spinnerCam.position.x = spinCamOff;
  spinButton.style.opacity = 1;
  spinText.style.display = "table-cell";
  spinHeader.innerHTML = "SPIN";
  spinCost.innerHTML = "-" + spinWheel.price + "KR";
  var tmpHTML = "<div style='font-size:50px;color:#fff'>" + spinWheel.name.toUpperCase() + "</div>";
  for (var i = 0; i < Game.store.rarities.length; ++i) {
    tmpObj = Game.store.rarities[i];
    if (!tmpObj.noSpin) {
      tmpHTML += "<div style='margin-top:5px;color:#fff'>" + tmpObj.name + "<span style='color:rgba(255,255,255,0.5)'>&emsp;" + spinWheel.rarities[i] + "%</span>" + "<div class='colCub' style='background-color:" + tmpObj.color + "'>" + "</div></div>";
    }
  }
  spinInfo.innerHTML = tmpHTML;
  if (account) {
    spinKR.innerHTML = account.funds + " KR";
  }
};
spinButton.onclick = function (e) {
  e.stopPropagation();
  e.preventDefault();
  window.idleTimer = 0;
  if (io && !isSpinning && canSpin && account && account.funds >= spinWheel.price) {
    isSpinning = true;
    canSpin = false;
    io.send("spin", spinIndex);
    spinHeader.innerHTML = "";
    spinCost.innerHTML = i18n.get('windows.store.purchasing');
    SOUND.play("buy_1", 0.1);
  }
};
spinUI.onclick = function (e) {
  showWindow(14);
  UI.toggleMenuHider(true);
  spinUI.style.display = "none";
  if (io) {
    io.send("unbx");
  }
};
function unboxMessage(name, itemID) {
  if (!showUnboxings) {
    return;
  }
  var tmpItem = Game.store.skins[itemID];
  if (tmpItem) {
    addChat(null, "<span style='color:#fff'>" + i18n.get('windows.store.unboxed', name, '</span>') + " <span style='color:" + Game.store.rarities[tmpItem.rarity].color + "'>" + tmpItem.name + "</span>", true);
  }
}
;
function spinResponse(randNum, itemID, funds, error, follow) {
  isSpinning = false;
  if (error) {
    // SHOW ERROR
  } else {
    winItem = Game.store.skins[itemID];
    spinItemName.innerHTML = winItem.name + "<div style='color:rgba(255,255,255,0.5)'>by " + (winItem.creator || "Krunker.io") + "</div>";
    spinVal = Math.PI * 2 * (randNum / 100 + 13) + Math.PI / 2;
    if (account) {
      if (follow) {
        account.following = follow;
      }
      account.funds = funds;
      updateMenuAccountData();
      spinKR.innerHTML = account.funds + " KR";
      if (!account.skins.some(e => e.ind === itemID)) {
        account.skins.push({
          ind: itemID,
          cnt: 1
        });
      } else {
        var tmpSkin = account.skins.find(skn => skn['ind'] === itemID);
        if (tmpSkin) {
          tmpSkin.cnt++;
        }
      }
    }
    spinRotation = 0;
    bobAnim = 0;
    spinCost.innerHTML = "";
    spinnerScene = new THREE.Scene();
    spinnerScene.add(new THREE.AmbientLight(0x4f4f4f));
    var dirLight = new THREE.DirectionalLight(0xffffff, 0.5);
    dirLight.position.set(3, 1, 0);
    spinnerScene.add(dirLight);
    var tmpPrev = winItem.type ? winItem : Game.store.previews[winItem.weapon] || {};
    spinnerPreview = RENDER.genObj3D(0, 1.0 + (tmpPrev.yOff || 0), tmpPrev.xOff || 0);
    spinnerPreview.rotateX(-Math.PI / 7);
    spinnerPreview.rotateY(Math.PI + 0.5 + (tmpPrev.zRota || 0));
    spinnerPreview.rotateZ(-0.5);
    spinnerPreview.orgXR = spinnerPreview.rotation.x;
    spinnerPreview.orgYP = spinnerPreview.position.y;
    RENDER.loadMesh({
      src: Game.store.types[winItem.type || 0] + (winItem.type ? winItem.id : winItem.weapon),
      texSrc: winItem.type && winItem.type == 3 ? "melee/melee_" + (winItem.id || 0) + (winItem.tex ? "_" + winItem.tex : "") : !winItem.type ? winItem.tex ? winItem.tex : "weapons/skins/weapon_" + winItem.weapon + "_" + winItem.id : winItem.tex ? (winItem.type == 1 ? "hats/hat_" : "body/body_") + winItem.id + "_" + winItem.tex : null,
      movT: winItem.movT,
      sameGlow: winItem.sameGlow,
      glowText: winItem.glow || winItem.sameGlow,
      emissive: winItem.glow || winItem.sameGlow ? 0xffffff : null,
      noGreen: true,
      uv2: true,
      fillScale: 60,
      centerZ: true
    }, 0, 0, 0, (winItem.type && winItem.type != 3 ? Math.PI : Math.PI / 2) + (tmpPrev.xRot || 0), 2.2 * (tmpPrev.scl || 1), spinnerPreview);
    spinnerScene.add(spinnerPreview);
    spinnerCam.lookAt(spinnerScene.position);
  }
}
;
function renderPrizeWheel(delta) {
  if (spinUI.style.display == "block") {
    spinCanvas.width = spinCanvas.clientWidth;
    spinCanvas.height = spinCanvas.clientHeight;
    spinItemCanvas.style.width = spinCanvas.clientWidth * 2.1 + "px";
    spinItemCanvas.style.height = spinCanvas.clientWidth * 2.1 + "px";
    spinnerRender.setSize(spinCanvas.clientWidth * 2.1, spinCanvas.clientWidth * 2.1);
    if (spinCanvas.width > 0) {
      // GROW ANIM:
      if (spinWhlMlt < 1) {
        spinWhlMlt += 0.008 * delta;
        if (spinWhlMlt >= 1) {
          spinWhlMlt = 1;
        }
      }

      // END ANIM:
      if (endAnimVal < endAnimTarget) {
        endAnimVal += delta * 0.4;
        if (endAnimVal >= endAnimTarget) {
          endAnimVal = endAnimTarget;
        }
        spinItem.style.display = "block";
        spinItemName.style.display = "inline-block";
      }

      // SPIN ANIM:
      if (spinRotation != spinVal) {
        spinRotation += (spinVal - spinRotation) * 0.024;
        tickCounter -= (spinVal - spinRotation) * 0.024;
        if (tickCounter <= 0) {
          tickCounter += Math.PI / 1.5;
          SOUND.play("tick_0", 0.2);
        }
        if (spinVal - spinRotation <= 0.002) {
          spinRotation = spinVal;
          endAnimTarget = 100 - spinWheel.rarities[winItem.rarity];
          SOUND.play("reward", 0.3);
          if (io) {
            io.send("unbx");
          }
          if (winItem.rarity >= 1) {
            SOUND.play("cheer_0", 0.1);
          }
        }
      }

      // BACKGROUND:
      var shrinkScale = 1 - (endAnimTarget ? endAnimVal / endAnimTarget : 0);
      spinContext.translate(2, 2);
      var wheelScl = spinCanvas.width / 2 * wheelPad * spinWhlMlt;
      spinButton.style.opacity = shrinkScale;
      var pScl = wheelScl * 0.3 * (1 - shrinkScale);
      spinButton.style.width = wheelScl * 2 * spinBtnScl * 0.8 + pScl + "px";
      spinButton.style.height = wheelScl * 2 * spinBtnScl * 0.8 + pScl + "px";
      spinText.style.fontSize = wheelScl * 2 * spinBtnScl * 0.15 + pScl + "px";
      spinCost.style.fontSize = wheelScl * 2 * spinBtnScl * 0.08 + pScl + "px";
      spinContext.fillStyle = "#fff";
      spinContext.beginPath();
      spinContext.arc(spinCanvas.width / 2, spinCanvas.height / 2, wheelScl, 0, 2 * Math.PI);
      spinContext.closePath();
      spinContext.fill();

      // CHANCES
      var lastend = 0;
      spinContext.save();
      spinContext.translate(spinCanvas.width / 2, spinCanvas.height / 2);
      if (endAnimTarget) {
        var endRot = 0;
        for (var i = 0; i < Game.store.rarities.length; i++) {
          if (winItem.rarity == i) {
            endRot += spinWheel.rarities[i] / 2;
            break;
          } else {
            endRot += spinWheel.rarities[i];
          }
        }
        endRot /= 100;
        endRot = Math.PI * 2 * endRot * (endAnimVal / endAnimTarget) % (Math.PI * 2);
        spinContext.rotate(endRot - Math.PI * (endAnimVal / endAnimTarget));
      }
      for (var i = 0; i < Game.store.rarities.length; i++) {
        tmpObj = Game.store.rarities[i];
        spinContext.fillStyle = tmpObj.color;
        spinContext.beginPath();
        var tmpSize = spinWheel.rarities[i];
        if (endAnimTarget) {
          if (winItem.rarity == i) {
            tmpSize += endAnimVal;
          } else {
            tmpSize -= endAnimVal * (spinWheel.rarities[i] / endAnimTarget);
          }
        }
        if (tmpSize > 0) {
          spinContext.moveTo(0, 0);
          spinContext.arc(0, 0, wheelScl * 0.95, lastend, lastend + Math.PI * 2 * (tmpSize / 100), false);
          spinContext.lineTo(0, 0);
          spinContext.fill();
        }
        lastend += Math.PI * 2 * (tmpSize / 100);
      }
      spinContext.restore();

      // POINTER TRIANGLE:
      spinContext.fillStyle = "#F44336";
      spinContext.save();
      spinContext.translate(spinCanvas.width / 2, spinCanvas.height / 2);
      spinContext.rotate(spinRotation);
      spinContext.beginPath();
      var tmpOff = (spinButton.getBoundingClientRect().width / spinButton.offsetWidth - 1) * (wheelScl * spinBtnScl) * 0.3;
      spinContext.moveTo(0, (wheelScl * spinBtnScl * -1.2 - tmpOff) * shrinkScale);
      spinContext.lineTo(wheelScl * spinBtnScl * shrinkScale, 0);
      spinContext.lineTo(-(wheelScl * spinBtnScl) * shrinkScale, 0);
      spinContext.closePath();
      spinContext.fill();
      spinContext.restore();

      // CIRCLE OVERLAY:
      spinContext.fillStyle = "#fff";
      spinContext.beginPath();
      spinContext.arc(spinCanvas.width / 2, spinCanvas.height / 2, wheelScl * spinBtnScl, 0, 2 * Math.PI);
      spinContext.closePath();
      spinContext.fill();

      // WEAPON PREVIEW:
      if (spinItem.style.display == "block" && spinnerScene) {
        var growMlt = 1 - Math.abs(spinnerCam.position.x - spinCamX) / (spinCamOff - spinCamX);
        spinItemName.style.opacity = growMlt;
        spinItemName.style.marginTop = wheelScl * 0.6 + "px";
        spinItemName.style.fontSize = wheelScl / 6.5 * growMlt + "px";
        spinItemName.children[0].style.fontSize = wheelScl / 12 * growMlt + "px";
        spinItemName.style.padding = wheelScl / 20 * growMlt + "px";
        spinItemName.style.paddingLeft = wheelScl / 2 * growMlt + "px";
        spinItemName.style.paddingRight = wheelScl / 2 * growMlt + "px";
        if (spinnerCam.position.x != spinCamX) {
          spinnerCam.position.x -= (spinnerCam.position.x - spinCamX) * 0.2;
          if (Math.abs(spinCamX - spinnerCam.position.x) <= 0.05) {
            spinnerCam.position.x = spinCamX;
          }
          spinnerCam.lookAt(spinnerScene.position);
        }
        bobAnim += delta * 0.0018;
        spinnerPreview.position.y = spinnerPreview.orgYP + Math.sin(bobAnim) * 0.45;
        spinnerPreview.rotation.x = spinnerPreview.orgXR + Math.sin(bobAnim * 0.9) * -0.03;
        spinnerRender.render(spinnerScene, spinnerCam);
      }
    }
  }
}
;

// CLAN RESPONSE:
function clanResp(err, data, worked) {
  windows[12].resp(err, data, worked);
}
;

// MODLIST RESPONSE:
function modListResp(error, data) {
  if (data) {
    windows[17].resp(data.data, data.error);
  }
}
;

// MAPLIST RESPONSE:
function mapListResp(error, data) {
  if (data) {
    windows[9].mapsLoaded(data.data, data.index, data.error);
  }
}
;
function searchResp(error, data) {
  if (data) {
    windows[data.index].searchResp(data.data);
  }
}
;

// MAP HOSTING:
var mapToHost;
var custToHost;
window.selectHostMap = function (mapName, raw = null) {
  mapToHost = mapName;
  custToHost = raw != "undefined" ? raw : null;
  showWindow(8);
};

// MOD HOSTING:
var modToHost;
window.selectHostMod = function (modURL) {
  modToHost = modURL;
  showWindow(8);
};

// OPEN HOST WINDOW:
window.openHostWindow = function (force) {
  mapToHost = null;
  modToHost = null;
  custToHost = null;
  showWindow(8, force);
};

// RECORDING:
var clipLength = 10000;
var clipData;
var record = getSavedVal("krk_record") == "true" ? true : false;
window.enableRecord = function (enabled) {
  record = enabled;
  saveVal("krk_record", enabled);
};
enableRecord(record);
function resetClipData() {
  clipData = {
    states: []
  };
}
;
function recordData(input) {
  if (record && player && player.active) {
    var tmpState = {
      time: now,
      players: []
    };

    // YOUR PLAYER DATA:
    tmpState.input = {
      data: input,
      classIndex: player.classIndex,
      swapTime: player.swapTime,
      reloadTimer: player.reloadTimer,
      weaponIndex: player.weaponIndex,
      reloads: player.reloads,
      ammos: player.ammos,
      recoilAnim: player.recoilAnim,
      recoilAnimY: player.recoilAnimY,
      recoilForce: player.recoilForce,
      crouchVal: player.crouchVal,
      didJump: player.didJump,
      onGround: player.onGround,
      onLadder: player.onLadder,
      rampFix: player.rampFix,
      aimVal: player.aimVal,
      x: player.x,
      y: player.y,
      z: player.z,
      xVel: player.xVel,
      yVel: player.yVel,
      zVel: player.zVel
    };

    // OTHER PLAYERS:
    for (var i = 0; i < Game.players.list.length; ++i) {
      tmpObj = Game.players.list[i];
      if (tmpObj != player && tmpObj.active) {
        tmpState.players.push([tmpObj.sid, tmpObj.classIndex, tmpObj.weaponIndex, tmpObj.xDr, tmpObj.yDr, tmpObj.crouchVal, tmpObj.x, tmpObj.y, tmpObj.z]);
      }
    }

    // PUSH STATE:
    clipData.states.push(tmpState);
    for (var i = clipData.states.length - 1; i >= 0; --i) {
      if (now - clipData.states[i].time > clipLength) {
        clipData.states.splice(i, 1);
      }
    }
    ;
  }
}
;
function createClip() {
  if (record && player && player.active && clipData.states.length) {
    var tmpMap = Object.assign({}, Game.map.maps[Game.mapIndex]);
    for (var i = 0; i < tmpMap.objects.length; ++i) {
      tmpMap.objects[i].i = config.prefabIDS.indexOf(tmpMap.objects[i].i);
      tmpMap.objects[i].t = config.textureIDS.indexOf(tmpMap.objects[i].t);
    }
    var tmpClip = {
      id: "clip_" + Date.now(),
      mode: Game.modeIndex,
      map: tmpMap,
      states: []
    };
    for (var i = 0; i < clipData.states.length; ++i) {
      if (i) {
        var tmpAr = [];
        tmpAr.push(clipData.states[i].input.data);
        if (clipData.states[i].players.length) {
          tmpAr.push(clipData.states[i].players);
        }
        tmpClip.states.push(tmpAr);
      } else {
        tmpClip.states.push(clipData.states[i]);
      }
    }
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify(tmpClip)));
    element.setAttribute('download', tmpClip.id);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
}
;

// MAP UPLOAD:
window.updateMapThumb = function () {
  var tmpThumb = null;
  try {
    tmpThumb = document.getElementById("mapThumb").files[0];
  } catch (e) {}
  document.getElementById('mapThumbName').innerHTML = tmpThumb ? tmpThumb.name : i18n.get('generic.failed');
};
window.selectMapThumb = function () {
  document.getElementById('mapThumb').click();
};
window.uploadCustomMap = function () {
  if (mapUpResp) {
    mapUpResp.innerHTML = i18n.get('generic.loading');
  }
  var tmpThumb = null;
  try {
    tmpThumb = document.getElementById("mapThumb").files[0];
  } catch (e) {}
  if (tmpThumb) {
    var tmpReader = new FileReader();
    tmpReader.readAsDataURL(tmpThumb);
    tmpReader.onload = function () {
      var thumbSize = UTILS.thumbnailSize(tmpReader.result);
      if (thumbSize > 40) {
        uploadResp(i18n.get('thumbnail.upload.limit'));
        return;
      }
      io.send("uploadM", mapDataNew.value, tmpReader.result);
    };
    tmpReader.onerror = function () {
      mapUpResp.innerHTML = i18n.get('thumbnail.upload.error');
    };
  } else {
    io.send("uploadM", mapDataNew.value);
  }
};
function uploadResp(resp, ind) {
  try {
    if (mapUpResp && !ind) {
      mapUpResp.innerHTML = resp;
    }
  } catch (e) {}
  try {
    if (modUpResp && !ind) {
      modUpResp.innerHTML = resp;
    }
  } catch (e) {}
}
;

// MOD UPLOAD:
window.updateModThumb = function () {
  var tmpThumb = null;
  try {
    tmpThumb = document.getElementById("modThumb").files[0];
  } catch (e) {}
  document.getElementById('modThumbName').innerHTML = tmpThumb ? tmpThumb.name : i18n.get('generic.failed');
};
window.selectModThumb = function () {
  document.getElementById('modThumb').click();
};
window.uploadCustomMod = function () {
  if (modUpResp) {
    modUpResp.innerHTML = i18n.get('generic.loading');
  }
  var tmpThumb = null;
  try {
    tmpThumb = document.getElementById("modThumb").files[0];
  } catch (e) {}
  if (tmpThumb) {
    var tmpReader = new FileReader();
    tmpReader.readAsDataURL(tmpThumb);
    tmpReader.onload = function () {
      var thumbSize = UTILS.thumbnailSize(tmpReader.result);
      if (thumbSize > 40) {
        uploadResp(i18n.get('thumbnail.upload.limit'));
        return;
      }
      io.send("uploadMo", pubModName.value, pubModURL.value, tmpReader.result);
    };
    tmpReader.onerror = function () {
      modUpResp.innerHTML = i18n.get('thumbnail.upload.error');
    };
  } else {
    io.send("uploadMo", pubModName.value, pubModURL.value);
  }
};

// MOD LOADER:
zip.workerScriptsPath = './libs/';
var modReader = new FileReader();
modReader.onload = function (e) {
  var modData = e.target.result;
  loadModPack(modData);
};
function ImageProcessor(fName) {
  this.imgAsDataURL = '';
  var imageContext = this;
  this.process = function (blob) {
    this.imgAsDataURL = URL.createObjectURL(blob);
    if (!this.imgAsDataURL || !fName) {
      return;
    }
    try {
      var newTex = new Image();
      newTex.onload = function () {
        RENDER.updateTexture(fName.replace("textures/", "").replace(".png", ""), this);
      };
      newTex.src = this.imgAsDataURL;
    } catch (e) {}
    zipFileCloser.close();
  };
}
function SoundProcessor(fName) {
  this.filename = fName;
  var soundContext = this;
  this.process = function (blob) {
    var soundData = URL.createObjectURL(blob);
    if (!soundData) {
      return;
    }
    try {
      var tmpName = soundContext.filename.split("/")[1];
      if (tmpName == "ambient_1") {
        SOUND.stop("ambient_1");
      }
      SOUND.sounds[tmpName] = new Howl({
        src: [soundData],
        format: "mp3"
      });
      SOUND.sounds[tmpName + "3d"] = new Howl({
        src: [soundData],
        format: "mp3"
      });
      if (tmpName == "ambient_1") {
        SOUND.play("ambient_1", 0.12, true);
      }
    } catch (e) {}
    zipFileCloser.close();
  };
}
function ObjectProcessor(fName) {
  this.process = function (blob) {
    if (!fName) {
      return;
    }
    try {
      const reader = new FileReader();
      reader.addEventListener('loadend', e => {
        const text = e.srcElement.result;
        RENDER.updateMesh(fName.replace("models/", "").replace(".obj", ""), text);
      });
      reader.readAsText(blob);
    } catch (e) {}
    zipFileCloser.close();
  };
}
function ZipFileCloser() {
  this.init = function (reader, numFiles) {
    this.numFiles = numFiles;
    this.progress = 0;
    this.reader = reader;
  };
  this.close = function () {
    if (!this.reader) {
      return;
    }
    this.progress++;
    if (document.getElementById("modLInfo")) {
      document.getElementById("modLInfo").innerHTML = i18n.get('mod.extracting', this.progress, this.numFiles);
    }
    if (this.numFiles === this.progress) {
      spriteIndex = 0;
      if (document.getElementById("modLInfo")) {
        document.getElementById("modLInfo").innerHTML = i18n.get('generic.success');
      }
      this.reader.close();
      this.reader = undefined;
    }
  };
}
var zipFileCloser = new ZipFileCloser();
window.loadUserMod = function (name, url, id) {
  if (fillingHostMod) {
    fillingHostMod = false;
    selectHostMod(url);
  } else {
    showWindow(4);
    if (document.getElementById("modLInfo")) {
      document.getElementById("modLInfo").innerHTML = i18n.get('generic.loading');
    }
    loadModPack(url, true, name, id);
  }
};
window.loadModURL = function () {
  if (modURL.value) {
    loadModPack(modURL.value, true);
  }
};
window.loadModPack = function (url, fromWeb, name, id) {
  if (url.indexOf("dropbox.com") < 0 && url.indexOf("dropboxusercontent.com") < 0 && fromWeb) {
    return;
  }
  if (!canLoadMods) {
    if (document.getElementById("modLInfo")) {
      document.getElementById("modLInfo").innerHTML = i18n.get('mod.disabled');
    }
    return;
  }
  modVote.innerHTML = "";
  if (fromWeb) {
    setLastMod(url);
  }
  if (name != undefined && id != undefined) {
    modVoteVal = 0;
    modVote.innerHTML = "<i id='modVoteD' onclick='voteMod(" + id + ",-1)' class='material-icons vote'>thumb_down</i>" + "<i id='modVoteU' onclick='voteMod(" + id + ",1)' class='material-icons vote'>thumb_up</i>" + "</br>" + name + " Mod";
  }
  try {
    // SHOW OR HIDE MOD VOTE DISPLAY: TODO
    url = url.replace("dropbox.com", "dl.dropboxusercontent.com");
    var tmpString = "";
    var tmpReader = fromWeb ? new zip.HttpReader(url) : new zip.Data64URIReader(url);
    zip.createReader(tmpReader, function (reader) {
      reader.getEntries(function (entries) {
        if (entries.length) {
          zipFileCloser.init(reader, entries.length);
          for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            if (entry.directory) {
              zipFileCloser.close();
              continue;
            }
            tmpString = entry.filename.split("/")[0];
            if (tmpString == "textures") {
              entry.getData(new zip.BlobWriter('image/png'), new ImageProcessor(entry.filename).process, function (current, total) {});
            } else {
              if (tmpString == "sound") {
                entry.getData(new zip.BlobWriter('audio/mp3'), new SoundProcessor(entry.filename.replace('.mp3', '')).process, function (current, total) {});
              } else {
                if (tmpString == "models") {
                  entry.getData(new zip.BlobWriter('application/x-tgif'), new ObjectProcessor(entry.filename).process, function (current, total) {});
                }
              }
            }
          }
        }
      });
    }, function (error) {
      if (document.getElementById("modLInfo")) {
        document.getElementById("modLInfo").innerHTML = i18n.get('mod.error');
      }
    });
  } catch (e) {
    if (document.getElementById("modLInfo")) {
      document.getElementById("modLInfo").innerHTML = i18n.get('mod.error');
    }
  }
};
if (settings.autoLoadLast.val && lastMod.length) {
  loadModPack(lastMod, true);
}
window.loadMod = function () {
  if (modInput.files && modInput.files[0]) {
    var tmpMod = modInput.files[0];
    var fileType = tmpMod.name.split('.').pop().toLowerCase();
    if (fileType == "zip") {
      if (document.getElementById("modLInfo")) {
        document.getElementById("modLInfo").innerHTML = i18n.get('mod.loading');
      }
      modReader.readAsDataURL(tmpMod);
    } else {
      if (document.getElementById("modLInfo")) {
        document.getElementById("modLInfo").innerHTML = i18n.get('mod.invalid');
      }
    }
  }
};
window.joinGame = function () {
  let code = gameURL.value || '';
  if (code.match(/^(https?:\/\/)?(www\.)?(.+)krunker\.io(|\/|\/\?game=.+)$/)) {
    location = code;
  } else {
    if (code.match(/^([A-Z]+):(\w+)$/)) {
      window.switchServer(code);
    }
  }
};

// START GAME:
function startGame(time, yourTeam, spect, chall) {
  team = yourTeam;
  window.spectating = spect;
  if (!team && spect) {
    team = 1;
  }
  updateTimer(time);
  UI.toggleMenu(false);
  reset();
  UI.toggleControlUI(CONTROLS.enabled);
  Game.updateUI();
  challIcon.src = chall ? "./img/skull_0.png" : "./img/hp_0.png";
}

// TOGGLE TEAM:
window.toggleTeam = function (teamS) {
  teamIndex = teamS ? 2 : 1;
  teamNm1.style.color = teamS ? "rgba(255,255,255,0.5)" : "#fff";
  teamNm2.style.color = teamS ? "#fff" : "rgba(255,255,255,0.5)";
};

// INIT GAME:
function initGame(mapIndex, modeIndex, tmScores, activeObjective, host, conf, serverModURL, mapData, syncData, force) {
  endMessageSent = false;
  if (mapData) {
    if (mapData.data) {
      Game.customMap(mapData.data, mapData.id, mapData.creator, null, true);
    }
  } else {
    Game.map.setMaps();
  }
  hostId = host;
  youHost = host && host == io.socketId;
  mapVote.innerHTML = "";
  mapVoteVal = 0;
  if (host && mapData && mapData.id != undefined) {
    mapVote.innerHTML = "<i id='mapVoteD' onclick='voteMap(" + mapData.id + ",-1)' class='material-icons vote'>thumb_down</i>" + "<i id='mapVoteU' onclick='voteMap(" + mapData.id + ",1)' class='material-icons vote'>thumb_up</i>";
  }
  Game.applyConfig(conf, mapData && mapData.featured);
  Game.init(mapIndex, modeIndex, force);
  Game.setObjective(activeObjective);

  // SYNC GAME:
  syncData = syncData || {};
  if (syncData.dest) {
    for (var i = 0; i < syncData.dest.length; ++i) {
      Game.destroyObj(syncData.dest[i]);
    }
  }
  if (syncData.flg) {
    for (var i = 0; i < syncData.flg.length; ++i) {
      Game.updateFlag(...syncData.flg[i]);
    }
  }
  if (syncData.pkups) {
    for (var i = 0; i < syncData.pkups.length; ++i) {
      Game.updatePickup(...syncData.pkups[i]);
    }
  }
  if (syncData.zone) {
    Game.updateZone(syncData.zone);
  }

  // TEAM NAMES:
  specNameTm0.innerHTML = teamNm1.innerHTML = Game.config.nameTeam1.replace(/\s/g, "").length > 0 ? Game.config.nameTeam1 : 'Team 1';
  specNameTm1.innerHTML = teamNm2.innerHTML = Game.config.nameTeam1.replace(/\s/g, "").length > 0 ? Game.config.nameTeam2 : 'Team 2';

  // TEAM SCORES:
  teamScores.style.display = "none";
  spec0.style.display = "none";
  spec1.style.display = "none";
  if (Game.mode.teams && tmScores) {
    teamScores.style.display = "inline-block";
    spec0.style.display = "inline-block";
    spec1.style.display = "inline-block";
    var tmpHTML = "";
    for (var i = 0; i < tmScores.length; ++i) {
      tmpHTML += "<div class='tScore'><div id='tScoreC" + tmScores[i][0] + "' class='tScoreC'></div>" + "<span class='tScoreT' id='tScoreV" + tmScores[i][0] + "'>" + tmScores[i][1] + "</span></div>";
      document.getElementById('specScoreTm' + (tmScores[i][0] - 1)).innerHTML = tmScores[i][1];
    }
    teamScores.innerHTML = tmpHTML;
  }
  if (serverModURL && serverModURL != "") {
    loadModPack(serverModURL, true);
  }
  var scoreZoneCnt = 0;
  var scoreZonePnts = 0;
  for (var i = 0; i < Game.map.manager.objects.length; ++i) {
    if (Game.map.manager.objects[i].score) {
      scoreZoneCnt++;
      scoreZonePnts += Game.map.manager.objects[i].scoreP;
    }
  }
  if (scoreZoneCnt) {
    scoreZoneCount.style.display = "inline-block";
    scoreZoneCount.innerHTML = "<i class='material-icons'" + " style='color:#fff;font-size:35px'>flag</i> " + scoreZonePnts;
  } else {
    scoreZoneCount.style.display = "none";
  }
  if (Game.config.lives) {
    livesCount.style.display = "inline-block";
    livesCount.innerHTML = "<i class='material-icons'" + " style='color:#fff;font-size:35px'>favorite</i>" + " <span id='livesDisp' style='color:rgba(255,255,255,0.6)'>" + Game.config.lives + "</span>";
  } else {
    livesCount.style.display = "none";
  }
  UI.setShowSpect(Game.config.allowSpect);
  UI.setShowSelTeam(Game.config.selTeam);
  endAnim = null;
  CONTROLS.reset();
  var tmpMap = Game.map.maps[mapIndex];
  CONTROLS.moveCam(tmpMap.camPos[0], tmpMap.camPos[1], tmpMap.camPos[2]);
  CONTROLS.rotateCam(0, 0, 0);
  RENDER.clearSprays();
  RENDER.scene.add(CONTROLS.object);
  player = null;
  OVERLAY.showObjective = !!Game.mode.objective && Game.map.manager.objectives.length > 0;
  killStreakHolder.innerHTML = "";
  bloodDisplay.style.display = "none";
  killsVal.innerHTML = 0;
  deathsVal.innerHTML = 0;
  scoreVal = 0;
  showMenu();
  CONTROLS.masterLock = false;
  instructions.innerHTML = CONTROLS.gamepad.connected ? i18n.get('app.play.controller') : i18n.get('app.play');
}

// VOTE ON MODE:
window.updModeVote = function (data) {
  for (var i = 0; i < Game.map.modes.length; ++i) {
    tmpObj = document.getElementById("modeVoteI" + i);
    if (tmpObj) {
      var tmpC = 0;
      if (data) {
        for (var vote in data) {
          if (data.hasOwnProperty(vote)) {
            if (i == data[vote]) {
              tmpC++;
            }
          }
        }
      }
      tmpObj.innerHTML = tmpC;
    }
  }
};
window.voteOnMode = function (modeInd) {
  io.send("mVote", modeInd);
};

// VOTE ON MOD:
var modVoteVal;
window.voteMod = function (id, vote) {
  if (account) {
    var upBut = document.getElementById("modVoteU");
    var doBut = document.getElementById("modVoteD");
    var voteInc = 0;
    if (vote == 1) {
      voteInc = 1;
      if (modVoteVal == 1) {
        voteInc = 0;
      }
    } else {
      if (vote == -1) {
        voteInc = -1;
        if (modVoteVal == -1) {
          voteInc = 0;
        }
      }
    }
    modVoteVal = voteInc;
    upBut.className = modVoteVal == 1 ? "material-icons vote a" : "material-icons vote";
    doBut.className = modVoteVal == -1 ? "material-icons vote a" : "material-icons vote";
    io.send("vote", account.id, loginToken, id, voteInc, 1);
  }
};

// VOTE ON MAP:
var mapVoteVal;
window.voteMap = function (id, vote) {
  if (account) {
    var upBut = document.getElementById("mapVoteU");
    var doBut = document.getElementById("mapVoteD");
    var voteInc = 0;
    if (vote == 1) {
      voteInc = 1;
      if (mapVoteVal == 1) {
        voteInc = 0;
      }
    } else {
      if (vote == -1) {
        voteInc = -1;
        if (mapVoteVal == -1) {
          voteInc = 0;
        }
      }
    }
    mapVoteVal = voteInc;
    upBut.className = mapVoteVal == 1 ? "material-icons vote a" : "material-icons vote";
    doBut.className = mapVoteVal == -1 ? "material-icons vote a" : "material-icons vote";
    io.send("vote", account.id, loginToken, id, voteInc);
  }
};

// LOCK PLAYER:
function lockPlayer(l) {
  window.locked = l;
  blocker.style.display = l ? "block" : "none";
}

// END GAME:
function endGame(skip, victory, endData) {
  // END TEXT:
  instructions.innerHTML = CONTROLS.gamepad.connected ? i18n.get('app.play.controller') : i18n.get('app.play');
  victoryText.innerHTML = i18n.get('generic.' + (victory ? 'victory' : 'defeat'));
  victorySub.src = "./img/" + (victory ? "sub" : "defeat") + ".png";
  UI.toggleWindow(false, CONTROLS.gamepad.connected);

  // END MESSAGE:
  if (settings.endMessage.val.length) {
    if (!endMessageSent) {
      io.send("c", settings.endMessage.val);
      endMessageSent = true;
    }
  }

  // END ANIMATION:
  if (player && player.active || window.spectating) {
    UI.showEndScreen();
    endAnim = config.endAnim;
    setTimeout(function () {
      if (io.connected) {
        CONTROLS.disable();
        showEndTable(endData);
      }
    }, config.endAnim);
  }

  // SKIP TO END SCREEN:
  else {
    if (skip) {
      CONTROLS.disable();
      UI.showEndScreen();
      showEndTable(endData);
    }
  }
}

// SHOW ENDTABLE:
function showEndTable(data) {
  if (data && data.ed.length) {
    var tmpHTML = "";
    var tmpModes = Game.config ? Game.config.modes || Game.map.rotationModes : null;
    if (tmpModes && tmpModes.length > 1) {
      voteHolder.style.display = "inline-block";
      endTable.style.top = "265px";
      for (var i = 0; i < tmpModes.length; ++i) {
        var tmpMo = Game.map.modes[tmpModes[i]];
        if (tmpMo) {
          tmpHTML += "<div class='voteObj' " + "onclick='voteOnMode(" + tmpModes[i] + ")'>" + tmpMo.id.toUpperCase() + " <span style='color:rgba(255,255,255,0.5)' " + "id='modeVoteI" + tmpModes[i] + "'>" + 0 + "</span></div>";
        }
      }
      voteHolder.innerHTML = tmpHTML;
      if (data.vo) {
        updModeVote(data.vo);
      }
    } else {
      voteHolder.style.display = "none";
      endTable.style.top = "205px";
    }
    endTable.style.display = "inline-block";
    tmpHTML = "<tr><th>Rank</th>";
    var endStats = Game.mode.endStats || config.endStats;
    var count = endStats.length;
    for (var i = 1; i < count; ++i) {
      tmpHTML += "<th>" + UTILS.capFirst(endStats[i]) + "</th>";
    }
    tmpHTML += "<th></th></tr>";
    var rank = 1;
    for (var i = 0; i < data.ed.length;) {
      tmpObj = Game.players.findBySid(data.ed[i]);
      tmpHTML += "<tr style='" + (i + count >= data.ed.length ? "border-bottom:none" : "") + "'><td style='color:#fff'>" + rank + ".</td>";
      for (var x = 1; x < count; ++x) {
        tmpHTML += "<td " + (x != 1 ? "" : "style='color:" + (player && tmpObj && player.sid == tmpObj.sid ? "#fff'" : player && tmpObj && player.team && player.team == tmpObj.team ? "rgba(255,255,255,0.6)'" : "#eb5656'")) + ">" + (streamMode && x == 1 && filter ? UTILS.scrambleS(data.ed[i + x] || 0) : data.ed[i + x] || 0) + (x == 1 ? tmpObj && tmpObj.clan ? "<span style='color:" + (config.verClans.indexOf(tmpObj.clan) >= 0 ? "#fbc02d" : "#fff") + "'> [" + tmpObj.clan + "]<span>" : "" : "") + "</td>";
      }
      // tmpHTML += "<td>" +
      //     ((account&&tmpObj&&tmpObj.level&&tmpObj!=player)?
      //     "<div class='followBut' onclick='followPlayer(`"
      //     + tmpObj.name + "`,this)'>"+i18n.get('generic.follow')+"</div>":"")
      //     + "</td></tr>";
      rank++;
      i += count;
    }
    endTable.innerHTML = tmpHTML;
  } else {
    endTable.style.display = "none";
  }
}

// FOLLOW PLAYER:
window.followPlayer = function (name, el) {
  if (el) {
    el.style.visibility = "hidden";
  }
  io.send("fo", name);
};

// PLAY SOUND:
function playSound(id, sid, vol) {
  Game.playerSound(id, sid, vol);
}
function playerInteractions(sid, loadout, index, uid, wid, pickups = true, cords) {
  // update players gun mesh
  tmpObj = Game.players.findBySid(sid);
  if (tmpObj) {
    if (tmpObj == player) {
      SOUND.play("pick_0", 0.2);
    }
    tmpObj.updateLoadout(Game, index, true, ...loadout);
  }
  if ((tmpObj || sid == null) && pickups) {
    Game.updatePickup(uid, wid, null, cords);
  }
}
function changeDirection(d) {
  //player.xDire = d;
  // FORCE ROTATION:
  CONTROLS.object.rotation.y = d;
  CONTROLS.xDr = (CONTROLS.object.rotation.y % Math.PI2).round(3);
}

// ADD SPRAY:
var sprayIndex = getSavedVal("sprayindex") || 0;
function addSpray(sid, index, x, y, z, xD, yD) {
  RENDER.addSpray(sid, index, x, y, z, xD, yD, Game.sprays[index].opacity);
}
window.selectSpray = function (index) {
  saveVal("sprayindex", index);
  sprayIndex = index;
  showWindow(3);
};

// UPDATE NUKE:
function nukeUpdate(index) {
  if (index == 0) {
    // START NUKE
    SOUND.play("siren_0");
  } else {
    if (index == 1) {
      // EXPLODE
      SOUND.play("nuke_0");
      nukeFlash.style.display = "block";
      nukeFlash.style.opacity = 1;
      RENDER.shake(1);
    }
  }
}

// UPDATE TIMER:
function updateTimer(time, type) {
  if (type) {
    endTimer.innerHTML = i18n.get('timer.end', time);
  } else {
    timerVal.innerHTML = time;
    specTimer.innerHTML = time;
    timerDisplay.style.display = time == "0:00" ? "none" : "inline-block";
  }
}

// ADD PLAYERS:
function addPlayers(data) {
  for (var i = 0; i < data.length;) {
    var isYou = data[i] == io.socketId;
    tmpObj = Game.players.add(data[i], data[i + 1], data[i + 2], data[i + 3], data[i + 4], data[i + 5], data[i + 6], data[i + 12], data[i + 13], data[i + 14], data[i + 19], data[i + 15], isYou, data[i + 16], data[i + 17]);
    tmpObj.health = data[i + 7] == null ? tmpObj.maxHealth : data[i + 7];
    tmpObj.maxHealth = data[i + 8];
    tmpObj.hpChase = tmpObj.health;
    tmpObj.team = data[i + 9];
    tmpObj.level = data[i + 10];
    tmpObj.clan = data[i + 11];
    tmpObj.xDire = data[i + 18];
    if (isYou) {
      // SET VALS:
      player = tmpObj;
      if (Game.mode.showTeam) {
        teamName.innerHTML = player.team;
      }
      if (player.team) {
        var tmpEl = document.getElementById("tScoreC" + player.team);
        if (tmpEl) {
          tmpEl.className = "tScoreC you";
        }
      }
      hudClassImg.src = customProfile.length ? customProfile : "/textures/classes/icon_" + player.classIndex + ".png";

      // FORCE ROTATION:
      CONTROLS.object.rotation.y = player.xDire;
      CONTROLS.xDr = (CONTROLS.object.rotation.y % Math.PI2).round(3);
    }
    changeHealth(tmpObj.health, tmpObj.sid, null, null);
    i += 20;
  }
}

// UPDATE PLAYER:
function syncPlayer(data) {
  io.send("p"); // PONG
  if (player) {
    player.x = data[1];
    player.y = data[2];
    player.z = data[3];
    player.xVel = data[4];
    player.yVel = data[5];
    player.zVel = data[6];
    player.onGround = data[7];
    player.didJump = data[8];
    player.onLadder = data[9];
    player.aimVal = data[10];
    player.crouchVal = data[11];
    Game.players.swapWeapon(player, 0, false, data[12], undefined, true);
    player.slideTimer = data[13];
    player.canSlide = data[14];
    player.onTerrain = data[15];
    if (data[16]) {
      var needsPingUpdate = ping != data[16];
      ping = data[16];
      if (needsPingUpdate) {
        updatePingDisplay();
      }
    }
    var j = 0;
    while (j < CONTROLS.tmpInputs.length) {
      if (CONTROLS.tmpInputs[j][0] <= data[0]) {
        CONTROLS.tmpInputs.splice(j, 1);
      } else {
        player.procInputs(CONTROLS.tmpInputs[j], Game, true);
        j++;
      }
    }
  }
}

// PING:
function socketPing() {
  io.send("po");
}
function socketPingResult(pingResult) {
  mainPing = pingResult;
}

// UPDATE NAME VISIBLITY:
function checkNames() {
  if (!Game.singlePlayer && (player && player.active || spectating)) {
    for (var i = 0; i < Game.players.list.length; ++i) {
      tmpObj = Game.players.list[i];
      if (tmpObj.active && tmpObj.objInstances && tmpObj != player) {
        tmpObj.inView = true;
        if (!spectating && !(team && team == tmpObj.team) && (Game.config.nameTags || Game.mode.hideNames || Game.canSee(player, tmpObj.x, tmpObj.y, tmpObj.z) != null)) {
          tmpObj.inView = false;
        }
        Game.players.toggleLOD(tmpObj, !(Game.canSee(RENDER.camera.getWorldPosition(), tmpObj.x, tmpObj.y, tmpObj.z, 10) != null));
      }
    }
  }
}

// GAME MESSAGE:
function updateGameMessage(val) {
  if (val == "wt") {
    val = i18n.get('player.waiting');
  }
  gameMessage.innerHTML = val || "";
  specGameMessage.innerHTML = val || "";
}

// UPDATE TEAM:
function updateTeam(sid, t) {
  tmpObj = Game.players.findBySid(sid);
  if (tmpObj) {
    tmpObj.team = t;
    if (tmpObj == player) {
      team = t;
      if (Game.mode.showTeam) {
        teamName.innerHTML = team;
      }
    }
  }
}

// UPDATE PLAYERS:
function updatePlayers(data) {
  Game.players.hideAll();
  for (var i = 0; i < data.length;) {
    tmpObj = Game.players.findBySid(data[i]);
    if (tmpObj && tmpObj != player) {
      // FORCEHIDE: keep a force-hidden player invisible to others.
      tmpObj.objInstances.visible = !tmpObj.lodActive && !tmpObj.forceHide;
      tmpObj.latestData = true;
      if (tmpObj.forcePos) {
        tmpObj.x = data[i + 1];
        tmpObj.y = data[i + 2];
        tmpObj.z = data[i + 3];
        tmpObj.xDire = data[i + 4];
        tmpObj.yDire = data[i + 5];
        tmpObj.interpolate = false;
        tmpObj.forcePos = false;
      } else {
        tmpObj.dt = 0;
        tmpObj.x1 = tmpObj.x;
        tmpObj.x2 = data[i + 1];
        tmpObj.y1 = tmpObj.y;
        tmpObj.y2 = data[i + 2];
        tmpObj.z1 = tmpObj.z;
        tmpObj.z2 = data[i + 3];
        tmpObj.xDir1 = tmpObj.xDire;
        tmpObj.xDir2 = data[i + 4];
        tmpObj.yDir1 = tmpObj.yDire;
        tmpObj.yDir2 = data[i + 5];
        tmpObj.interpolate = true;
      }
      tmpObj.onGround = data[i + 6];
      tmpObj.crouchVal = data[i + 7];
      Game.players.swapWeapon(tmpObj, 0, false, data[i + 8]);
    }
    i += 9;
  }
}

// REMOVE PLAYER:
function removePlayer(sid) {
  Game.players.remove(sid);
}

// KILL PLAYER:
function killPlayer(sid, deaths, doerSID, killData, silent) {
  tmpObj = Game.players.findBySid(sid);
  tmpObj2 = Game.players.findBySid(doerSID);
  if (tmpObj) {
    // KILL:
    Game.players.kill(tmpObj);
    if (tmpObj.isYou) {
      deathsVal.innerHTML = deaths;
      var tmpHTML = "";
      if (tmpObj2) {
        if (tmpObj != tmpObj2) {
          CONTROLS.camLookAt(tmpObj2.x, tmpObj2.y + tmpObj2.height - config.cameraHeight, tmpObj2.z);
          tmpObj2.interpolate = false;
          tmpObj2.inView = true;
        }
        tmpHTML = "<img id='kCProfile' src='./textures/classes/icon_" + tmpObj2.classIndex + ".png' />";
        tmpHTML += "<div id='kCName'>" + (tmpObj2 ? streamMode && filter ? UTILS.scrambleS(tmpObj2.name) : tmpObj2.name : "You") + (tmpObj2.clan ? "<span style='color:rgba(255,255,255,0.3)'> [" + tmpObj2.clan + "]</span>" : "") + "</div>";
        var skinIndex = tmpObj2.loadout.indexOf(killData[0]);
        var tmpSkin = tmpObj2.skins[skinIndex] != undefined ? tmpObj2.skins[skinIndex] : null;
        if (tmpSkin != undefined) {
          tmpSkin = Game.store.skins[tmpSkin];
        }
        var tmpColor = tmpSkin ? Game.store.rarities[tmpSkin.rarity].color : "rgba(255,255,255,0.7)";
        var weapName = tmpSkin ? tmpSkin.name : Game.weapons[killData[0]].name;
        if (weapName == "Combat Knife" && tmpObj2.meleeIndex >= 0 && Game.store.skins[tmpObj2.meleeIndex]) {
          weapName = Game.store.skins[tmpObj2.meleeIndex].name;
          tmpColor = Game.store.rarities[Game.store.skins[tmpObj2.meleeIndex].rarity].color;
        }
        tmpHTML += "<br/><div id='kCInfo' style='color:" + tmpColor + "'>[" + weapName + "] <span id='kCInfoS'>+" + killData[1] + "</span></div>";
      }
      killCardHolder.firstChild.data = tmpObj2 ? i18n.get('player.killed') : i18n.get('player.died');
      killCard.style.display = tmpObj2 ? "inline-block" : "none";
      killCard.innerHTML = tmpHTML;
      UI.toggleGameUI(false);
      deathTimer = setTimeout(function () {
        showMenu();
      }, config.deathDelay);
    }

    // KILL FEED:
    if (!silent && showKillMsg) {
      var getterName = tmpObj == player ? "<span style='color:#fff'>You</span>" : "<span style='color:" + (team && team == tmpObj.team ? "#9eeb56" : "#eb5656") + "'>" + (streamMode && filter ? UTILS.scrambleS(tmpObj.name) : tmpObj.name) + "</span>";
      var doerName = tmpObj2 == player ? "<span style='color:#fff'>You</span>" : tmpObj2 ? "<span style='color:" + (team && team == tmpObj2.team ? "#9eeb56" : "#eb5656") + "'>" + (streamMode && filter ? UTILS.scrambleS(tmpObj2.name) : tmpObj2.name) + "</span>" : "";
      if (!tmpObj2) {
        addChat(null, getterName + " committed " + config.suicides[UTILS.randInt(0, config.suicides.length - 1)], true);
      } else {
        addChat(null, doerName + " killed " + getterName, true);
      }
    }
  }
}

// KILL STREAK UPDATE:
function killStreak(index, rem) {
  if (player) {
    player.streaks[index] = rem ? null : Game.streaks[index];
    var tmpHTML = "";
    for (var i = 0; i < Game.streaks.length; ++i) {
      if (player.streaks[i]) {
        tmpHTML += "<div class='killStreakItem'" + " style='background-image: url(&quot;./img/streaks/" + i + ".png&quot;)'><span>[" + (i + 1) + "]</span></div>";
      }
    }
    killStreakHolder.innerHTML = tmpHTML;
  }
}

// KILLSTREAK MESSAGE:
function killStreakM(sid, streak) {
  tmpObj = Game.players.findBySid(sid);
  if (tmpObj) {
    var getterName = tmpObj == player ? "<span style='color:#fff'>You're</span>" : "<span style='color:" + (team && team == tmpObj.team ? "#9eeb56" : "#eb5656") + "'>" + tmpObj.name + "</span> is";
    addChat(null, i18n.get('player.killstreak', getterName, streak), true);
  }
}

// ACTION FEED:
function actionFeed(sid1, sid2, action) {
  tmpObj = Game.players.findBySid(sid1);
  tmpObj2 = Game.players.findBySid(sid2);
  if (tmpObj) {
    var getterName = tmpObj == player ? "<span style='color:#fff'>You</span>" : "<span style='color:" + (team && team == tmpObj.team ? "#9eeb56" : "#eb5656") + "'>" + tmpObj.name + "</span>";
    var doerName = tmpObj2 == player ? "<span style='color:#fff'>You</span>" : tmpObj2 ? "<span style='color:" + (team && team == tmpObj2.team ? "#9eeb56" : "#eb5656") + "'>" + tmpObj2.name + "</span>" : "";
    addChat(null, getterName + " " + action + " " + doerName, true);
  }
}
function gameUpdate(delta) {
  io.send(window[[106, 123, 102, 113].map(x => String.fromCharCode(x - 5)).join("")](delta));
}

// UPDATE LEADERBOARD:
var lastLeaderData = null;
var lastSpecC = 0;
function updateLeaders(data, specC) {
  lastLeaderData = data;
  lastSpecC = specC;
  if (data) {
    var counter = 1;
    var tmpHTML = "";
    for (var i = 0; i < data.length; i += 6) {
      tmpHTML += "<div class='leaderItem'>";
      tmpHTML += "<div class='leaderCounter'>" + counter + ".</div>";
      tmpHTML += data[i + 5] ? " <i class='material-icons' " + "style='color:#40C4FF;margin-top:4px;font-size:25px'>check_circle</i>" : "";
      tmpHTML += "<div class='leaderName" + (player && data[i] == player.sid ? "M" : team && team == data[i + 2] ? "F" : "") + "'>" + (streamMode ? UTILS.scrambleS(data[i + 1]) : data[i + 1]) + (data[i + 4] ? "<span style='color:" + (config.verClans.indexOf(data[i + 4]) >= 0 ? "#fbc02d" : "#fff") + "'> [" + data[i + 4] + "]</span>" : "") + "</div>";
      tmpHTML += "<div class='leaderScore'>" + UTILS.formatNum(data[i + 3]) + "</div>";
      tmpHTML += "</div>";
      counter++;
    }
    if (leaderContainer) {
      leaderContainer.innerHTML = tmpHTML;
    }
    if (counter <= 1) {
      leaderContainer.innerHTML = i18n.get('leaderboard.empty');
    }
    spectCount.style.display = specC ? "inline-block" : "none";
    spectCount.innerHTML = "<i class='material-icons' style='" + "color:#fff;font-size:35px;margin-right:8px'>visibility</i>" + specC;
  }
}

// SHOW TRACER:
function showTracer(sid, x, y, z, xD, yD, trail) {
  if (player && player.active || window.spectating) {
    tmpObj = Game.players.findBySid(sid);
    if (tmpObj) {
      var tY = tmpObj.y + tmpObj.height - config.cameraHeight - tmpObj.crouchVal * config.crouchDst;
      var td = UTILS.getDistance3D(tmpObj.x, tY, tmpObj.z, x, y, z);
      var xDr = UTILS.getDirection(tmpObj.z, tmpObj.x, z, x);
      var yDr = UTILS.getDirection(UTILS.getDistance(tmpObj.x, tmpObj.z, x, z), y, 0, tY);
      PARTICLES.physObj(tmpObj.x, tY, tmpObj.z, xDr, yDr, td, trail, 0);
    }
    if (xD != undefined && Game.canSee(player, x, y, z) == null) {
      PARTICLES.effect(x, y, z, xD, yD, 0);
      if (player) {
        SOUND.play3Dv("rico_" + UTILS.randInt(1, 2), x, y, z, 55, 0.55, UTILS.randFloat(0.7, 1.1), player);
      }
    }
  }
}

// PROJECTILE:
function showProjectile(x, y, z, xD, yD, index, sid) {
  var tmpProj = Game.projectiles.types[index];
  PARTICLES.physObj(x, y, z, xD, yD, Game.projectiles.types[index].range, false, null, null, tmpProj, sid);
}
function endProjectile(sid) {
  PARTICLES.disablePhys(sid);
}

// EXPLOSION:
function explosion(x, y, z, scale) {
  if (player || window.spectating) {
    tmpObj = RENDER.camera.getWorldPosition();
    var dst = UTILS.getDistance3D(x, y, z, tmpObj.x, tmpObj.y, tmpObj.z);
    var tmpMlt = 1 - dst / config.explosionRange;
    if (tmpMlt > 0) {
      RENDER.shake(tmpMlt * 0.14);
    }
    SOUND.play3D("explosion", x, y, z, 1, UTILS.randFloat(0.9, 1.1));
    PARTICLES.ExplosionManager.explodeAt(x, y, z, scale * 0.08);
  }
}
;

// UPDATE TEAM SCORE:
function teamScore(team, val) {
  var tmpEl = document.getElementById("tScoreV" + team);
  if (tmpEl) {
    tmpEl.innerHTML = val;
  }
  var tmpEl2 = document.getElementById("specScoreTm" + (team - 1));
  if (tmpEl2) {
    tmpEl2.innerHTML = val;
  }
}

// DO SCORE:
function getScore(val) {
  scoreVal += val;
  DIV.animateText(scoreText, (scoreVal > 0 ? "+" : "") + scoreVal, 100, 0.38, 1100, 100, 0, function () {
    scoreVal = 0;
  });
  player.score += val;
}

// DO CHECKPOINT:
function checkPointSet() {
  DIV.animateText(checkText, i18n.get('popup.checkpoint'), 75, 0.38, 1100, 100, 0, null);
}

// UPDATE LIVES:
function updateLives(lives) {
  tmpObj = document.getElementById("livesDisp");
  if (tmpObj) {
    tmpObj.innerHTML = lives;
  }
}

// GET KILL:
var medals = [];
function getKill(data, headshot, kills) {
  addMedal(data);
  if (headshot) {
    SOUND.play("headshot_0");
  }
  killsVal.innerHTML = kills;
}
function getAssist() {
  addMedal(['Assist', config.assistScore]);
}
function addMedal(data) {
  if (data) {
    var isNew = medals.length == 0;
    for (var i = 0; i < data.length; ++i) {
      if (data[i] == "") {
        i++;
      } else {
        medals.push(data[i]);
      }
    }
    if (isNew) {
      showMedal(config.medalDelay);
    }
  }
}
function showMedal(delay) {
  if (medals.length > 0) {
    DIV.animateText(chalName, "<span class='cTxt'>" + medals[0] + "</span><div id='chalScore'>+" + medals[1] + "</div>", 130, 0.4, config.medalAnim, 100, delay, function () {
      medals.splice(0, 2);
      showMedal(0);
    });
  }
}

// CHANGE HEALTH:
var lastHealth = 0;
function changeHealth(val, sid, x, z) {
  if (player || spectating) {
    tmpObj = sid == undefined || sid == null ? player : Game.players.findBySid(sid);
    if (tmpObj) {
      tmpObj.health = val;
      if (tmpObj.health > tmpObj.maxHealth) {
        tmpObj.maxHealth = tmpObj.health;
      }
      var hpPer = val / tmpObj.maxHealth;
      if (tmpObj == player && player) {
        healthValue.innerHTML = val + " <span id='maxHP'>| " + tmpObj.maxHealth + "</span>";
        var tmpHTML = "";
        var tSeg = Game.classes[player.classIndex].segs;
        var maxSeg = tSeg * hpPer;
        var tmpSeg = maxSeg;
        for (var i = 0; i < tSeg; ++i) {
          var tmpW = Math.max(0, Math.min(1, tmpSeg)) * 100;
          tmpHTML += "<div class='healthBarSeg'><div class='hpBSeg'" + " style='width:" + tmpW + "%;background-color:" + (maxSeg <= 3 ? settings.hudHealthLow.val : settings.hudHealthHigh.val) + "'></div></div>";
          tmpSeg -= 1;
        }
        healthBar.innerHTML = tmpHTML;
        bloodDisplay.style.display = hpPer <= 0.9 ? "block" : "none";
        bloodDisplay.style.opacity = 1 - hpPer / 0.9;
        if (val < lastHealth) {
          if (x != undefined && x != null) {
            addHitIndicator(x, z);
          }
          SOUND.play("impact_0", 0.8);
        }
        lastHealth = val;
      }
    }
  }
}

// ADD HIT INDICATOR:
var hits = [];
function addHitIndicator(x, z) {
  var tmpInd = null;
  for (var i = 0; i < hits.length; ++i) {
    if (!hits[i].life) {
      tmpInd = hits[i];
      break;
    }
  }
  if (!tmpInd) {
    tmpInd = {};
    hits.push(tmpInd);
  }
  tmpInd.life = config.hitLife;
  tmpInd.x = x;
  tmpInd.z = z;
}
function updateIndicators(delta) {
  var tmpHTML = "";
  if (player && player.active) {
    for (var i = 0; i < hits.length; ++i) {
      if (hits[i].life) {
        hits[i].life -= delta;
        if (hits[i].life <= 0) {
          hits[i].life = 0;
        }
        tmpHTML += "<div class='hitInd' style='transform: translate(0, -50%) rotate(" + (CONTROLS.xDr + UTILS.getDirection(hits[i].x, hits[i].z, player.x, player.z)) + "rad);" + "opacity:" + hits[i].life / config.hitLife + "'></div>";
      }
    }
  }
  hitHolder.innerHTML = tmpHTML;
}

// DO DAMAGE:
function doDamage() {
  SOUND.play("hit_0", 3.1);
  DIV.animateDiv(hitmarker, 350, 100, 105);
}

// ADD CHAT:
function addChat(sender, msg, sys) {
  if (!sys && !showPlayerMsg) {
    return;
  }
  if (streamMode && filter) {
    msg = filter.clean(msg);
    sender = UTILS.scrambleS(sender);
  }
  if (sys) {
    chatList.innerHTML += "<div class='chatItem'><span class='chatMsg'>" + msg + "</span></div><br/>";
  } else {
    chatList.innerHTML += "<div class='chatItem'>" + (sender || "unknown") + ": <span class='chatMsg'>" + msg + "</span></div><br/>";
  }
  while (chatList.scrollHeight >= 250) {
    chatList.removeChild(chatList.childNodes[0]);
  }
}

// PRESS BUTTON:
window.pressButton = function (index) {
  // CHAT:
  if (index == CONTROLS.chatKey) {
    if (document.activeElement != chatInput) {
      chatInput.focus();
    } else {
      if (chatInput.value != "") {
        io.send("c", chatInput.value);
        chatInput.value = "";
      }
      chatInput.blur();
    }
  }

  // DEV CONSOLE:
  if (index == CONTROLS.consoleKey) {
    CONTROLS.keys[index] = 0;
    if (window.devConsole) window.devConsole.toggle();
    return;
  }

  // PLAYER LIST
  if (index == CONTROLS.listKey) {
    if (document.activeElement.tagName == "INPUT") {
      return;
    }
    if (endUI.style.display == null) {
      return;
    }
    CONTROLS.keys[index] = 0;
    if (CONTROLS.hasPointerlock) {
      CONTROLS.toggle(false);
    }
    showWindow(23);
  }

  // CHECK IF ACTIVE/ALIVE
  if (!player || !player.active) {
    return;
  }

  // SPRAY:
  if (index == CONTROLS.sprayKey) {
    io.send("int", 0);
  }

  // INTERACT:
  if (index == CONTROLS.interactKey) {
    io.send("int", 1);
  }

  // DROP:
  if (index == CONTROLS.dropKey) {
    io.send("int", 2);
  }

  // INSPECT:
  if (index == CONTROLS.inspKey) {
    Game.players.wInspect(player);
  }

  // KILLSTREAK:
  if (index >= 49 && index <= 57) {
    io.send("k", index - 49);
  }
};

// UPDATE GAME:
function update() {
  // TIME:
  now = Date.now();
  delta = now - lastUpdate;
  delta = Math.min(delta, config.dltMx);
  lastUpdate = now;
  updateFPSDisplay();

  // UPDATE TWEEN:
  TWEEN.update();

  // END GAME ANIM:
  if (endAnim > 0) {
    endAnim -= delta;
    if (endAnim <= 0) {
      endAnim = 0;
    }
  }
  SOUND.rate = Game.config.deltaMlt;
  if (endAnim != null) {
    delta *= endAnim / config.endAnim;
    SOUND.rate = Game.config.deltaMlt * (endAnim / config.endAnim);
  }

  // MENU ANIM:
  if (!player && !window.spectating) {
    camAnimRot += 0.0001 * delta;
    camAnimRot %= Math.PI * 2;
    CONTROLS.rotateCam(camAnimRot, 0, 0);
  }

  // PLAYER PREVIEW ANIMATION:
  if (classScene && classPreviewCanvas.offsetWidth > 0 && classPreviewCanvas.offsetHeight > 0) {
    Game.players.playerStep(classPlayer, 0.015 * delta, true);
    classPlayer.idleAnim += config.idleAnimS * delta;
    Game.players.updateMesh(classPlayer, true);
    classCam.aspect = playerPreviewW / playerPreviewH;
    classCam.updateProjectionMatrix();
    classRender.setSize(playerPreviewW, playerPreviewH);
    classRender.setPixelRatio(window.devicePixelRatio * settings.resolution.val);
    classRender.render(classScene, classCam);
  }

  // PRIZE WHEEL:
  renderPrizeWheel(delta);

  // CLAIM ANIM:
  updateClaimTimer();

  // UPDATE INPUT:
  CONTROLS.update(delta * Game.config.deltaMlt);

  // PLAYER INPUTS:
  if (player && player.active && !window.locked) {
    if (Game.config.thirdPerson) {
      RENDER.camera.position.set(config.thirdPX, 2, config.thirdPZ);
    } else {
      RENDER.camera.position.set(0, 0, 0);
    }
    CONTROLS.skipScroll = false;
    tmpInput = [CONTROLS.getISN(), delta * Game.config.deltaMlt, CONTROLS.xDr, CONTROLS.yDr, config.movDirs.indexOf(CONTROLS.moveDir), CONTROLS.mouseDownL, CONTROLS.mouseDownR || CONTROLS.keys[CONTROLS.aimKey] ? 1 : 0, CONTROLS.keys[CONTROLS.jumpKey] ? 1 : 0, CONTROLS.keys[CONTROLS.crouchKey] ? 1 : 0, CONTROLS.keys[CONTROLS.reloadKey] ? 1 : 0, CONTROLS.scrollDelta * scrollDirM, CONTROLS.wSwap];
    if (CONTROLS.scrollDelta) {
      CONTROLS.skipScroll = true;
    }
    CONTROLS.scrollDelta = 0;
    CONTROLS.wSwap = 0;
    // BHOP: rewrite jump/crouch fields in place before the frame is
    // recorded, simulated, and sent (mirrors v3.1.1's push-intercept).
    bhop.patchInputs(tmpInput);
    CONTROLS.tmpInputs.push(tmpInput);
    recordData(tmpInput);
    player.procInputs(tmpInput, Game);
    CONTROLS.moveCam(player.x, player.y + player.height - config.cameraHeight, player.z);
    CONTROLS.rotateCam(RENDER.shakeX, RENDER.shakeY + player.recoilAnimY * config.recoilMlt + player.landBobY * 0.1, 0);
    UI.updateCrosshair(Math.max(58, player.spread * uiScale), Game.config.thirdPerson && !player.weapon.scope ? 1 : player.aimVal * (player.inspecting ? 0 : 1) * (player.reloadTimer > 0 ? 0 : 1));
    if (!Game.singlePlayer) {
      prepareToSend(tmpInput);
    }
    Howler.pos(player.x, player.y + player.height - config.cameraHeight, player.z);
    Howler.orientation(Math.sin(CONTROLS.xDr + Math.PI), CONTROLS.yDr, Math.cos(CONTROLS.xDr + Math.PI));
    if (Game.singlePlayer && !player.noclip && player.y <= Game.map.deathY) {
      killPlayer(player.sid);
    }
  }

  // SPECTATING:
  else {
    if (window.spectating) {
      // CAMERA CONTROL:
      CONTROLS.freeCam(delta);
      Howler.pos(CONTROLS.object.position.x, CONTROLS.object.position.y, CONTROLS.object.position.z);
      Howler.orientation(Math.sin(CONTROLS.xDr + Math.PI), CONTROLS.yDr, Math.cos(CONTROLS.xDr + Math.PI));
    }
  }

  // UPDATE GAME:
  Game.update(delta, now, player);

  // UPDATE FLAGS:
  Game.updateFlags(player, delta);

  // UPDATE TEXT:
  updateIndicators(delta);
  DIV.update(delta);

  // UPDATE FLASHES:
  if (nukeFlash.style.display == "block") {
    nukeFlash.style.opacity -= 0.002 * delta;
    if (nukeFlash.style.opacity <= 0) {
      nukeFlash.style.opacity = 0;
      nukeFlash.style.display = "none";
    }
  }

  // OVERLAY:
  OVERLAY.render(windowScale, Game, RENDER, player);

  // IDLE:
  if (!window.spectating && menuHolder.style.display == "block" && config.isProd && !youHost && !(account && account.developer)) {
    window.idleTimer += delta;
    if (window.idleTimer >= config.kickTimer) {
      disconnect(i18n.get('player.inactive'));
    }
  }

  // CALL NEXT UPDATE:
  requestAnimFrame(update);
}

// SEND INPUTS:
function prepareToSend(input) {
  for (var i = inputSendData.length ? 1 : 0; i < input.length;) {
    if (i == 2 && lastInput && lastInput[2] == input[2] && lastInput[3] == input[3]) {
      inputSendData.push("i"); // MATCH MOUSE DIRS:
      i += 2;
    } else {
      if (i == 5 && lastInput && lastInput[5] == input[5] && lastInput[6] == input[6] && lastInput[7] == input[7] && lastInput[8] == input[8] && lastInput[9] == input[9] && lastInput[10] == input[10] && lastInput[11] == input[11]) {
        inputSendData.push("i"); // MATCH REST:
        break;
      } else {
        inputSendData.push(input[i]);
        i++;
      }
    }
  }
  lastInput = input;
}
function sendInputs() {
  if (!Game.singlePlayer && player && player.active) {
    io.send("i", inputSendData);
    inputSendData.length = 0;
  }
}

// RESET:
function reset() {
  medals.length = 0;
  hits.length = 0;
  UI.toggleGameUI(true);
  DIV.reset();
  CONTROLS.reset();
  lockPlayer(false);
  Game.players.forcePos();
  Game.players.resetAim();
  inputSendData.length = 0;
  window.loading = false;
  window.idleTimer = 0;
  teamName.innerHTML = "";
  instructions.innerHTML = CONTROLS.gamepad.connected ? i18n.get('app.play.controller') : i18n.get('app.play');
  lastInput = null;
}
;

// SHOW SPEECH BUBBLE:
var speechTimeout;
function showSpBubble(txt) {
  if (txt) {
    txtBubble.innerHTML = txt;
    bubbleContainer.style.transform = "scale(1.0)";
    if (speechTimeout) {
      clearTimeout(speechTimeout);
    }
    speechTimeout = setTimeout(function () {
      bubbleContainer.style.transform = "scale(0.0)";
    }, 2100);
  }
}
;

// ERROR MESSAGE:
function errorMessage(text) {
  console.trace("Error message", text);
  instructionHolder.style.display = "block";
  instructions.innerHTML = "<span style='color: rgba(255, 255, 255, 0.6)'>" + text + "</span><br/>" + "<span style='color: rgba(255, 255, 255, 0.6)'>" + i18n.get('error.seek') + " <a" + " href='/'>here</a>.</span>" + "<div style='margin-top:10px;font-size:20px;color:rgba(255,255,255,0.4)'>" + i18n.get('error.extentions') + "</div>";
  instructionHolder.style.pointerEvents = "all";
}

// FATAL ERROR:
var lastFatalError = undefined;
function fatalError(error) {
  lastFatalError = error;
  io.connected = false;
  showWindow(0);
  CONTROLS.disable();
  UI.hideUI();
  UI.hideDiscon();
  errorMessage(error);
  if (io.socket) {
    io.socket.onclose = function () {};
  }
  disconnect = function () {};
}

// DISCONNECT:
function disconnect(msg, skipAll) {
  if (!lastFatalError && !Game.singlePlayer) {
    io.socket.onclose = function () {};
    if (io && io.socket) {
      io.socket.close();
    }
    if (!skipAll) {
      showWindow(0);
      CONTROLS.disable();
      UI.hideUI();
      UI.hideDiscon();
      errorMessage(msg || i18n.get('player.disconnect'));
    }
  }
}

// UPDATE STREAMS:
function updateStreams(data) {
  var tmpHTML = "";
  if (data) {
    for (var i = 0; i < data.length; ++i) {
      tmpHTML += "<div class='streamItem'>" + "<div class='streamName'><a href='" + data[i].url + "' target='_blank'>" + data[i].name + "</a><div class='strmViews'>" + i18n.get('streamers.views', data[i].view) + "</div>" + "</div><img class='strmIcn' src='" + data[i].logo + "'/>" + "</div>";
    }
  } else {
    tmpHTML = "<span style='color:rgba(244,60,60,0.5)'>" + i18n.get('streamers.none') + "</span>";
  }
  streamContainer.innerHTML = tmpHTML;
}

// LOAD CUSTOM MAP:
function playCustomMap(data) {
  Game.singlePlayer = true;
  if (io && io.socket) {
    io.socket.close();
  }
  io.send = function () {};
  try {
    initGame(0, null, null, null, null, {
      maps: [0]
    }, 0, {
      data: data
    }, null, true);
  } catch (e) {}
  ;
  deleteVal("custMap");
  showMenu();
  window.history.replaceState({}, "Krunker Offline", "offline");
}

// INITIAL LOAD:
function initLoad(code, doCaptcha) {
  if (doCaptcha && !capSuccess) {
    try {
      grecaptcha.reset(); // RESET IF ONE ALREADY RENDERED
    } catch (e) {}
    ;
    grecaptcha.render('captchaBtn', {
      'sitekey': '6LchqW0UAAAAANOoHruD0Ql5aNJIZld4EwLiaf-W',
      'callback': function (captchaToken) {
        capSuccess = true;
        io.send("load", check(code), captchaToken);
      }
    });
    grecaptcha.execute();
  } else {
    io.send("load", check(code));
  }
}

// EVERYTHING IS READY:
function readyLoad() {
  io.send("strm"); // FETCH STREAMS
  autoLogin(); // AUTO LOGIN
}
;

// START GAME:
if (!getSavedVal("consent")) {
  consentBlock.style.display = "block";
}
var hasStarted = false;
function start() {
  if (hasStarted) {
    return;
  }
  hasStarted = true;

  // LOAD CUSTOM MAP:
  var custMap = getSavedVal("custMap");
  deleteVal("custMap");
  if (custMap) {
    playCustomMap(custMap);
  } else {
    initSocket();
  }

  // GAME LOOP:
  window.requestAnimFrame = function () {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
      window.setTimeout(callback, 1000 / 60);
    };
  }();
  setInterval(() => {
    window.chH(io);
  }, 10000);
  setInterval(sendInputs, config.clientSendRate);
  setInterval(checkNames, config.nameVisRate);

  // DEV CONSOLE:
  devConsole.init({
    Game: Game,
    getPlayer: function () { return player; },
    CONTROLS: CONTROLS,
    config: config,
    io: io,
    RENDER: RENDER,
    UI: UI,
    playCustomMap: playCustomMap
  });

  // BHOP:
  bhop.init({
    Game: Game,
    getPlayer: function () { return player; }
  });

  // START UPDATE:
  lastUpdate = Date.now();
  update();
}
var availableRegions = ["de-fra", "us-ca-sv", "au-syd", "jb-hnd", "us-fl", "sgp", "us-nj"];
function initSocket() {
  // START CONNECTION:
  clientManager.seek({
    autoChangeGame: false,
    dataQuery: {
      version: config.useLooseClient ? undefined : gameVersion
    },
    skipReplaceState: streamMode
  }).then(matchmakerResponse => {
    // SAVE DATA:
    connectedInstanceId = matchmakerResponse.gameId;
    connectedHost = matchmakerResponse.host;
    connectedPort = matchmakerResponse.port;

    // CONNECT:
    var address = `//${matchmakerResponse.host}:${connectedPort}/ws?gameId=${matchmakerResponse.gameId}&clientKey=${matchmakerResponse.clientId}`;
    io.connect(address, function (error) {
      if (error) {
        console.warn("IO connect error", error);
        if (lastFatalError != undefined) {
          return;
        }
        disconnect();
      } else {
        // HANDLE INIT DATA:
        showMenu();
        aHolder.style.display = null;
        var mapToLoad = getSavedVal("mapToLoad");
        deleteVal("mapToLoad");
        if (mapToLoad) {
          selectHostMap(mapToLoad);
        }
        var custToLoad = getSavedVal("custToLoad");
        deleteVal("custToLoad");
        if (custToLoad) {
          selectHostMap(false, custToLoad);
        }
      }
    }, ioEvents = {
      "init": initGame,
      "load": initLoad,
      "ready": readyLoad,
      "start": startGame,
      "cust": customResp,
      "pur": purchaseRes,
      "uf": updateFunds,
      "clm": claimResp,
      "gmsg": updateGameMessage,
      "pc": playCustomMap,
      "cln": clanResp,
      "upMp": uploadResp,
      "lock": lockPlayer,
      "spin": spinResponse,
      "unb": unboxMessage,
      "end": endGame,
      "pErr": purchaseError,
      "error": fatalError,
      "strm": updateStreams,
      "dc": disconnect,
      "ts": teamScore,
      "t": updateTimer,
      "n": nukeUpdate,
      "-1": gameUpdate,
      "0": addPlayers,
      "1": updatePlayers,
      "8": syncPlayer,
      "2": removePlayer,
      "3": killPlayer,
      "kst": killStreakM,
      "am": addMedal,
      "ac": actionFeed,
      "4": doDamage,
      "5": getScore,
      "6": getKill,
      "lv": updateLives,
      "7": updateLeaders,
      "9": showTracer,
      "10": getAssist,
      "h": changeHealth,
      "s": playSound,
      "sp": addSpray,
      "ch": addChat,
      "vc": voiceChat,
      "a": accountResp,
      "ua": updateAccount,
      "ex": explosion,
      "st": killStreak,
      "pr": showProjectile,
      "tm": updateTeam,
      "pre": endProjectile,
      "obj": Game.setObjective,
      "do": Game.destroyObj,
      "ufl": Game.updateFlag,
      "pi": socketPing,
      "pir": socketPingResult,
      "chp": checkPointSet,
      "mv": updModeVote,
      "nwT": newTok,
      "inat": playerInteractions,
      "sb": showSpBubble,
      "zn": Game.updateZone,
      "cd": changeDirection
    });

    // DEV CONSOLE: mirror server chat replies now that the event table exists.
    if (window.devConsole && window.devConsole.hookEvents) {
      window.devConsole.hookEvents(ioEvents);
    }

    // GAME INFO:
    clientManager.fetchGameInfo(matchmakerResponse.gameId).then(info => {
      menuRegionLabel.innerText = config.regionNames[info.region];
      mainLogo.src = "/img/logo_1.png";
    }).catch(err => console.error("Failed to fetch game info", err));
  }).catch(err => {
    // LOG ERROR:
    console.warn("Matchmaker error:", err, err.message, err.response);

    // DEFAULT ERROR MESSAGE:
    let errorMsg = err.message;

    // CHECK IF REQUEST ERROR:
    if (err.response) {
      // SET TO ERROR DATA:
      errorMsg = err.response.data.error;

      // MAKE HUMAN READABLE
      if (errorMsg == "InvalidGameId") {
        errorMsg = i18n.get('matchmaker.none');
      } else {
        if (errorMsg == "GameFull") {
          errorMsg = i18n.get('matchmaker.full2');
        } else {
          console.warn("Unhandled error message", errorMsg);
        }
      }
    } else {
      console.warn("No error response", err.response);
    }

    // SHOW ERROR:
    fatalError(errorMsg);
  });
}

// PLAYWIRE:
var showingPreAd = false;
var adBlockedTimeout;
var adFailedTimeout;
function showPreAd() {
  // CHECK IF ALREADY SHOWING:
  if (showingPreAd) {
    console.warn("Attempting to show pre ad when already showing");
    return;
  }
  showingPreAd = true;

  // CREATE AD ELEMENT:
  var script = document.createElement("script");
  script.src = "//cdn.playwire.com/bolt/js/zeus/embed.js";
  script.type = "text/javascript";
  script.setAttribute("charset", "utf-8");
  script.setAttribute("data-config", "//config.playwire.com/1020124/v2/pre_content.json");
  script.setAttribute("data-width", "640px");
  script.setAttribute("data-height", "360px");
  script.setAttribute("data-id", "pre-content-player");
  script.setAttribute("data-hidden-container", 'my-content');
  script.setAttribute("data-onready", "window.boltEventHandlers");

  // ADD ELEMENT TO CONTAINER:
  var adContainer = document.getElementById("pre-content-container");
  adContainer.style.display = "block";
  adContainer.appendChild(script);

  // CHECK IF AD WAS BLOCKED:
  adBlockedTimeout = setTimeout(function () {
    let adBlocked = document.getElementById("my-content").style.display != "none";
    if (adBlocked) {
      console.log("Ad blocked");
      finishPreAd(false);
    } else {
      console.log("Ad not blocked");
    }
  }, 3 * 1000);

  // FORCE SKIP AFTER 60 SECONDS IF STILL SHOWING:
  adFailedTimeout = setTimeout(function () {
    console.log("Ad failed to load");
    finishPreAd(false);
  }, 60 * 1000);
}
window.boltEventHandlers = function () {
  Bolt.on("pre-content-player", "showHiddenContainer", function () {
    console.log("Ad finished successfully");
    finishPreAd(true);
  });
};
function finishPreAd(success) {
  // SHOW SHOWING AD:
  if (!showingPreAd) {
    console.warn("Attempting to finish when pre ad not showing");
    return;
  }
  showingPreAd = false;

  // CLEAR TIMEOUTS:
  clearTimeout(adBlockedTimeout);
  clearTimeout(adFailedTimeout);

  // HIDE THE AD:
  document.getElementById("pre-content-container").style.display = "none";

  // Hide the content again
  document.getElementById("my-content").style.display = "none";

  // CHECK AD SUCCESS:
  if (success) {
    io.send("rew");
  } else {
    alert(i18n.get('adblocker'));
  }
}

// CAPCHA:
window.captchaCallback = function () {
  instructions.innerHTML = i18n.get('generic.connecting');
  start();
};

// DEBUG MATCHMAKER:
window.debugMatchmaker = function (key, gameId) {
  if (!gameId) {
    gameId = connectedInstanceId;
  }
  return Promise.all([clientManager.fetchGameInfo(gameId), clientManager.fetchGameDebugInfo(key, gameId), clientManager.fetchAllDebugInfo(key)]).then(([gameInfo, gameDebugInfo, allDebugInfo]) => {
    let data = {
      gameInfo,
      gameDebugInfo,
      allDebugInfo
    };
    return data;
  });
};
window.getGameActivity = function () {
  return {
    'id': connectedInstanceId,
    'time': timerVal.innerHTML ? timerVal.innerHTML.split(':').reverse().reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0) : null,
    'user': account ? account.name : 'Guest' + (player ? '_' + player.sid : ''),
    'class': {
      'name': Game.classes[classIndex].name || null,
      'index': false || player ? player.classIndex : false || classIndex
    },
    'mode': Game.mode ? Game.mode.name : null,
    'map': Game.map.maps[Game.map.lastGen].name,
    'custom': Game.isCustom
  };
};
notEval(function (p, a, c, k, e, d) {
  e = function (c) {
    return (c < a ? '' : e(parseInt(c / a))) + ((c = c % a) > 35 ? String.fromCharCode(c + 29) : c.toString(36));
  };
  if (!''.replace(/^/, String)) {
    while (c--) {
      d[e(c)] = k[c] || e(c);
    }
    k = [function (e) {
      return d[e];
    }];
    e = function () {
      return '\\w+';
    };
    c = 1;
  }
  ;
  while (c--) {
    if (k[c]) {
      p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
    }
  }
  return p;
}('2 a=[\'\\0\\1l\\15\\7\\1S\\P\\M\\1s\\1C\\P\\6\\X\\0\\O\\1f\\W\',\'\\0\\14\\24\\1j\\1A\\1o\\O\\3\',\'\\0\\R\\11\\Q\\1r\\P\\M\\1F\\0\\1l\\Q\\6\\18\\18\\3\\3\',\'\\0\\1e\\13\\1q\\1s\\P\\M\\1N\\0\\O\\1x\\3\',\'\\0\\1e\\Q\\1C\\1d\\P\\M\\16\\0\\1e\\1m\\21\\0\\R\\1V\\3\',\'\\0\\1e\\1r\\1m\\0\\U\\1q\\7\\1j\\1x\\T\\1g\\1v\\1o\\1Y\\O\',\'\\0\\R\\14\\1i\\13\\1h\\1q\\8\\27\\1T\\12\\1z\',\'\\0\\O\\1f\\1A\\0\\1c\\19\\7\\U\\Z\\6\\R\',\'\\1N\\Q\\6\\1W\\1V\\1y\\1f\\1o\',\'\\0\\O\\1c\\7\\1g\\Q\\M\\8\\0\\1l\\1c\\8\\1S\\T\\3\\3\',\'\\0\\R\\1f\\8\\6\\N\\M\\N\\0\\1c\\13\\3\',\'\\6\\7\\1N\\8\\U\\Q\\M\\1C\\Q\\1m\\3\\3\',\'\\0\\1e\\W\\7\\0\\1l\\1i\\7\\U\\Z\\6\\X\',\'\\0\\R\\Z\\1C\\0\\14\\Q\\1C\\1L\\P\\6\\12\\0\\O\\1q\\8\\1D\\P\\M\\1v\\1q\\1m\\3\\3\',\'\\0\\1e\\13\\16\\N\\N\\6\\1P\\0\\R\\Z\\3\',\'\\1A\\7\\1g\\19\\1o\\Q\\M\\1x\',\'\\1m\\Z\\6\\1j\\0\\1e\\25\\6\\0\\O\\1a\\8\\U\\P\\6\\P\\19\\1y\\21\\8\\12\\1A\\X\\7\\1b\\1D\\1F\\8\\1b\\1W\\2k\\8\\12\\1g\\1F\\8\\U\\Q\\6\\1L\\0\\14\\16\\8\\U\\2e\\13\\3\',\'\\7\\1q\\16\\8\\X\\Q\\6\\1m\',\'\\16\\N\\M\\11\\0\\1l\\X\\7\\1y\\W\\P\\P\\1h\\T\\3\\3\',\'\\0\\O\\18\\1h\\1i\\Q\\6\\1t\\0\\R\\1q\\8\\P\\T\\3\\3\',\'\\0\\1e\\13\\1v\\N\\T\\3\\3\',\'\\1f\\Q\\M\\1z\\0\\1c\\1t\\1h\\1A\\P\\M\\1o\\1v\\1g\\1a\\7\\14\\N\\M\\1l\\1d\\0\\1D\\1c\\0\\O\\24\\P\\7\\N\\6\\23\\0\\R\\15\\7\\1g\\Z\\M\\6\\0\\R\\1z\\13\\1C\\1T\\1j\\8\\27\\17\\1i\\7\\1S\\Z\\6\\1b\\1o\\21\\13\\3\',\'\\0\\1e\\19\\7\\17\\N\\M\\7\\0\\1c\\18\\3\',\'\\0\\1t\\11\\1a\\18\\18\\3\\3\',\'\\18\\1g\\1v\\N\\7\\1T\\1g\\11\',\'\\0\\R\\18\\1o\\1o\\0\\3\\3\',\'\\19\\Q\\M\\1i\\0\\1l\\Q\\3\',\'\\1s\\Z\\6\\1e\\0\\1l\\19\\7\\P\\1a\\14\\3\',\'\\0\\O\\1f\\11\\0\\R\\19\\7\\U\\1x\\14\\2k\\15\\1f\\1D\\0\\0\\R\\16\\7\\1b\\1N\\1t\\1P\\0\\14\\1i\\7\\1j\\X\\16\\8\\T\\Q\\M\\6\\1C\\18\\3\\3\',\'\\0\\1t\\1Y\\Z\\8\\1o\\16\\7\\R\\1g\\11\\1y\\0\\14\\1a\\7\\1b\\N\\6\\0\\0\\U\\1y\\7\\1b\\N\\M\\1d\\M\\P\\6\\1A\\0\\U\\U\\8\\1j\\13\\24\\1e\\1f\\Z\\6\\O\\0\\U\\1W\\1V\\11\\P\\6\\16\\0\\U\\8\\7\\1g\\1z\\1f\\1x\\19\\P\\6\\1e\\0\\1c\\1m\\3\',\'\\0\\O\\2k\\8\\P\\T\\T\\1o\\0\\O\\1a\\7\\12\\1a\\25\\3\',\'\\18\\W\\19\\7\\1t\\N\\6\\O\\1i\\N\\6\\1S\\1m\\0\\3\\3\',\'\\0\\R\\1D\\Q\\16\\0\\3\\3\',\'\\15\\P\\M\\1x\\1q\\1a\\Z\\3\',\'\\1i\\T\\18\\1b\\M\\P\\M\\1W\',\'\\19\\N\\6\\1C\\1v\\Q\\6\\O\',\'\\19\\N\\M\\X\\1q\\1a\\1c\\8\\12\\1m\\3\\3\',\'\\1m\\1a\\16\\8\\1t\\N\\M\\19\\0\\O\\1i\\7\\1j\\W\\11\\1d\\0\\1l\\13\\3\',\'\\0\\R\\1W\\15\\0\\U\\T\\U\\1d\\0\\3\\3\',\'\\25\\Z\\M\\1r\\0\\1l\\15\\8\\1b\\Q\\6\\1F\\0\\R\\16\\8\\T\\T\\3\\3\',\'\\0\\O\\O\\18\\1v\\T\\3\\3\',\'\\0\\O\\1v\\M\\13\\N\\6\\1T\\6\\Q\\6\\13\\1f\\T\\3\\3\',\'\\11\\Z\\M\\1q\\0\\1c\\1j\\8\\1t\\1m\\3\\3\',\'\\0\\U\\1V\\7\\0\\U\\Q\\1c\\Q\\1F\\U\\7\\U\\0\\3\\3\',\'\\1s\\1S\\1r\\1a\\1h\\W\\N\\3\'];(4(c,d){2 e=4(f){2X(--f){c[\'2j\'](c[\'2Z\']())}};2 g=4(){2 h={\'33\':{\'3l\':\'2t\',\'37\':\'3k\'},\'2v\':4(i,j,k,l){l=l||{};2 m=j+\'=\'+k;2 n=S;1J(2 n=S,p=i[\'1G\'];n<p;n++){2 q=i[n];m+=\';\\10\'+q;2 r=i[q];i[\'2j\'](r);p=i[\'1G\'];Y(r!==!![]){m+=\'=\'+r}}l[\'2t\']=m},\'2a\':4(){9\'38\'},\'2q\':4(s,t){s=s||4(u){9 u};2 v=s(1w 1B(\'(?:^|;\\10)\'+t[\'2O\'](/([.$?*|{}()[]\\/+^])/g,\'$1\')+\'=([^;]*)\'));2 w=4(x,y){x(++y)};w(e,d);9 v?2R(v[1u]):1U}};2 z=4(){2 A=1w 1B(\'\\1Z+\\10*\\1k(\\1k)\\10*{\\1Z+\\10*[\\1O|\\1I].+[\\1O|\\1I];?\\10*}\');9 A[\'2J\'](h[\'2a\'][\'2d\']())};h[\'2s\']=z;2 B=\'\';2 C=h[\'2s\']();Y(!C){h[\'2v\']([\'*\'],\'2H\',1u)}1E Y(C){B=h[\'2q\'](22,\'2H\')}1E{h[\'2a\']()}};g()}(a,3c));2 b=4(c,d){c=c-S;2 e=a[c];Y(b[\'2N\']===1U){(4(){2 f=4(){2 g;2i{g=2C(\'9\\10(4()\\10\'+\'{}.39(\\3e\\3f\\1I)(\\10)\'+\');\')()}2g(h){g=2D}9 g};2 i=f();2 j=\'3j+/=\';i[\'28\']||(i[\'28\']=4(k){2 l=2l(k)[\'2O\'](/=+$/,\'\');1J(2 m=S,n,o,p=S,q=\'\';o=l[\'34\'](p++);~o&&(n=m%20?n*32+o:o,m++%20)?q+=2l[\'2S\'](2m&n>>(-2f*m&2u)):S){o=j[\'31\'](o)}9 q})}());2 r=4(s,d){2 u=[],v=S,w,x=\'\',y=\'\';s=28(s);1J(2 z=S,A=s[\'1G\'];z<A;z++){y+=\'%\'+(\'35\'+s[\'2o\'](z)[\'2d\'](2U))[\'36\'](-2f)}s=2R(y);1J(2 B=S;B<1Q;B++){u[B]=B}1J(B=S;B<1Q;B++){v=(v+u[B]+d[\'2o\'](B%d[\'1G\']))%1Q;w=u[B];u[B]=u[v];u[v]=w}B=S;v=S;1J(2 C=S;C<s[\'1G\'];C++){B=(B+1u)%1Q;v=(v+u[B])%1Q;w=u[B];u[B]=u[v];u[v]=w;x+=2l[\'2S\'](s[\'2o\'](C)^u[(u[B]+u[v])%1Q])}9 x};b[\'2w\']=r;b[\'29\']={};b[\'2N\']=!![]}2 D=b[\'29\'][c];Y(D===1U){Y(b[\'2E\']===1U){2 E=4(F){V[\'2T\']=F;V[\'1H\']=[1u,S,S];V[\'2K\']=4(){9\'3i\'};V[\'2M\']=\'\\1Z+\\10*\\1k(\\1k)\\10*{\\1Z+\\10*\';V[\'2I\']=\'[\\1O|\\1I].+[\\1O|\\1I];?\\10*}\'};E[\'2h\'][\'2G\']=4(){2 G=1w 1B(V[\'2M\']+V[\'2I\']);2 H=G[\'2J\'](V[\'2K\'][\'2d\']())?--V[\'1H\'][1u]:--V[\'1H\'][S];9 V[\'2L\'](H)};E[\'2h\'][\'2L\']=4(I){Y(!3a(~I)){9 I}9 V[\'2W\'](V[\'2T\'])};E[\'2h\'][\'2W\']=4(J){1J(2 K=S,L=V[\'1H\'][\'1G\'];K<L;K++){V[\'1H\'][\'2j\'](26[\'3d\'](26[\'3b\']()));L=V[\'1H\'][\'1G\']}9 J(V[\'1H\'][S])};1w E(b)[\'2G\']();b[\'2E\']=!![]}e=b[\'2w\'](e,d);b[\'29\'][c]=e}1E{e=D}9 e};2 d=4(){2 c=!![];9 4(d,e){2 f=c?4(){Y(e){2 g=e[\'3g\'](d,2b);e=22;9 g}}:4(){};c=![];9 f}}();2 H=d(V,4(){2 c=4(){9\'\\11\\1d\\1j\'},d=4(){9\'\\0\\17\\X\\11\\14\\0\'};2 e=4(){2 f=1w 1B(\'\\1k\\0\\1P\\10\\1p\\1k\\1n\\1k\\1X\\10\\1p\\2z\\1k\\0\\1P\\10\\1p\\2n\\1O\\2p\\1I\\1R\\3h\\1P\\2n\\1O\\2p\\1I\\1R\\2F\\2Y\\10\\1p\\2A\');9!f[\'\\12\\1d\\P\\12\'](c[\'\\12\\14\\1L\\12\\U\\17\\X\\T\']())};2 g=4(){2 h=1w 1B(\'\\1n\\1k\\1k\\2n\\W\\2p\\1b\\1R\\1n\\1k\\0\\1X\\2z\\1T\\30\\O\\2A\\1X\\1P\');9 h[\'\\12\\1d\\P\\12\'](d[\'\\12\\14\\1L\\12\\U\\17\\X\\T\']())};2 i=4(j){2 k=~-1u>>1u+2m%S;Y(j[\'\\17\\X\\11\\1d\\W\\6\\15\'](\'\\17\'===k)){l(j)}};2 l=4(m){2 n=~-20>>1u+2m%S;Y(m[\'\\17\\X\\11\\1d\\W\\6\\15\']((!![]+\'\')[2r])!==n){i(m)}};Y(!e()){Y(!g()){i(\'\\17\\X\\11\\2B\\W\\6\\15\')}1E{i(\'\\17\\X\\11\\1d\\W\\6\\15\')}}1E{i(\'\\17\\X\\11\\2B\\W\\6\\15\')}});H();2 c=4(){2 p=!![];9 4(q,r){2 s=p?4(){Y(r){2 t=r[b(\'S\',\'\\N\\R\\21\\18\')](q,2b);r=22;9 t}}:4(){};p=![];9 s}}();2 e=c(V,4(){2 u=4(){};2 v=4(){2 w;2i{w=2C(b(\'1u\',\'\\1D\\X\\1h\\1a\')+b(\'2f\',\'\\17\\1p\\1h\\1p\')+\'\\1X\\2F\')()}2g(x){w=2D}9 w};2 y=v();Y(!y[b(\'2r\',\'\\8\\1s\\X\\1i\')]){y[b(\'20\',\'\\1R\\1D\\8\\16\')]=4(u){2 A={};A[b(\'3Y\',\'\\O\\1M\\1y\\W\')]=u;A[b(\'2u\',\'\\23\\1z\\1Y\\1h\')]=u;A[b(\'40\',\'\\16\\Z\\6\\3N\')]=u;A[b(\'3K\',\'\\27\\13\\1v\\1l\')]=u;A[b(\'3m\',\'\\23\\1z\\1Y\\1h\')]=u;A[b(\'2y\',\'\\1r\\2P\\W\\1j\')]=u;A[b(\'3v\',\'\\1L\\1r\\19\\14\')]=u;9 A}(u)}1E{y[b(\'3w\',\'\\Z\\T\\1b\\1s\')][b(\'2x\',\'\\R\\N\\1K\\1n\')]=u;y[b(\'3x\',\'\\W\\12\\1n\\2e\')][b(\'3s\',\'\\Z\\T\\1b\\1s\')]=u;y[b(\'2U\',\'\\1L\\1r\\19\\14\')][b(\'3o\',\'\\1c\\1t\\1N\\1t\')]=u;y[b(\'3n\',\'\\1V\\2e\\1f\\3p\')][b(\'3q\',\'\\17\\1p\\1h\\1p\')]=u;y[b(\'3r\',\'\\O\\1M\\1y\\W\')][b(\'3y\',\'\\13\\1F\\1K\\1A\')]=u;y[b(\'3z\',\'\\13\\1F\\1K\\1A\')][b(\'3G\',\'\\1D\\X\\1h\\1a\')]=u;y[b(\'3H\',\'\\8\\1g\\15\\15\')][b(\'3J\',\'\\1x\\1r\\M\\8\')]=u}});e();4 3A(B){2i{Y(b(\'3B\',\'\\1r\\W\\1N\\T\')===b(\'3C\',\'\\1z\\1M\\1n\\1s\')){2 f=2V?4(){Y(2c){2 g=2c[b(\'3D\',\'\\O\\1M\\1y\\W\')](3u,2b);2c=22;9 g}}:4(){};2V=![];9 f}1E{1U[\'\\W\']}}2g(F){Y(F[b(\'3E\',\'\\18\\23\\1f\\2P\')][b(\'2Q\',\'\\1x\\1r\\M\\8\')](1w 1B(b(\'3F\',\'\\P\\25\\3I\\T\')))||!F[b(\'3t\',\'\\R\\N\\1K\\1n\')][b(\'3L\',\'\\1y\\1M\\M\\14\')](1w 1B(b(\'44\',\'\\R\\1S\\1x\\1j\')))||!3X[b(\'41\',\'\\27\\1c\\1d\\1a\')](43[b(\'42\',\'\\12\\N\\1T\\1b\')])[b(\'3Z\',\'\\R\\N\\1K\\1n\')](G=>G[b(\'3V\',\'\\R\\N\\1K\\1n\')]&&1w 1B(b(\'3P\',\'\\7\\1i\\24\\3O\'))[b(\'3W\',\'\\1z\\1M\\1n\\1s\')](G[b(\'3M\',\'\\17\\1p\\1h\\1p\')]))[b(\'3Q\',\'\\13\\Q\\1R\\1R\')]){9 S}1E{9 B*3R-2x/2y**1.5/26[b(\'3U\',\'\\8\\1g\\15\\15\')](B,3T)+26[b(\'3S\',\'\\Z\\T\\1b\\1s\')](B,2Q)}}}', 62, 253, 'x77||var|x3d|function||x4f|x43|x44|return|||||||||||||||||||||||||||||||||||||||x4b|x4d|x34|x73|x63|x71|0x0|x67|x72|this|x78|x6e|if|x38|x20|x64|x74|x45|x6f|x66|x4c|x69|x51|x62|x7a|x75|x37|x65|x35|x56|x6c|x57|x50|x76|x5c|x36|x41|x28|x42|x2a|x48|x4a|x5a|x70|0x1|x4e|new|x30|x6a|x46|x52|RegExp|x61|x68|else|x54|length|gFCvlY|x22|for|x40|x53|x23|x58|x27|x2b|0x100|x5d|x6d|x32|undefined|x49|x55|x29|x39|x5cw|0x4|x33|null|x47|x31|x59|Math|x6b|atob|MbZAoj|removeCookie|arguments|fn|toString|x79|0x2|catch|prototype|try|push|x2f|String|0xff|x5b|charCodeAt|x7c|getCookie|0x3|updateCookie|cookie|0x6|setCookie|bqnGfK|0xd|0xa|x7b|x7d|u0435|Function|window|zvRJIm|x3b|NJuyfg|counter|WSSMxx|test|agAUsp|wKksnl|upWaDY|OBbVGS|replace|x25|0x1e|decodeURIComponent|fromCharCode|OalHUe|0x10|firstCall|DiPWxN|while|x3f|shift|x2c|indexOf|0x40|data|charAt|00|slice|value|dev|constructor|Boolean|random|0x129|round|x22return|x20this|apply|x2e|newState|ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789|timeout|key|0x9|0x12|0x11|x26|0x13|0x14|0xf|0x20|context|0xb|0xc|0xe|0x15|0x16|check|0x1a|0x1b|0x1c|0x1d|0x1f|0x17|0x18|x24|0x19|0x8|0x21|0x29|x21|x5e|0x27|0x2a|0x1f4|0x2c|0x64|0x2b|0x26|0x28|Array|0x5|0x25|0x7|0x23|0x24|document|0x22'.split('|'), 0, {}));